// Viaje Alan & Carolina — Mayo/Junio 2026
// Madrid · Budapest · Praga · Israel
// Todas las coordenadas verificadas. Contenido curado con énfasis cultural histórico + judío.

export const TRIP = {
  meta: {
    title: "Madrid · Budapest · Praga · Israel",
    subtitle: "Mayo · Junio 2026",
    travelers: "Alan & Carolina",
    dates: "31 May — 16 Jun 2026",
    home: { lat: -33.4489, lng: -70.6693, name: "Santiago, Chile" },
  },

  // ============== VUELOS ==============
  flights: [
    {
      id: "f1",
      code: "IB118",
      airline: "Iberia",
      from: { code: "SCL", city: "Santiago", lat: -33.3927, lng: -70.7853, terminal: "T2 Internacional" },
      to: { code: "MAD", city: "Madrid", lat: 40.4936, lng: -3.5668, terminal: "T4" },
      depart: "2026-05-31T10:40:00-04:00",
      arrive: "2026-06-01T05:20:00+02:00",
      duration: "12h 40m",
      bookingRef: "H4E1E",
      notes: "Vuelo nocturno transatlántico, no-stop. Llega en la madrugada.",
    },
    {
      id: "f2",
      code: "W6 2392",
      airline: "Wizz Air",
      from: { code: "MAD", city: "Madrid", lat: 40.4719, lng: -3.5626, terminal: "T1" },
      to: { code: "BUD", city: "Budapest", lat: 47.4298, lng: 19.2611, terminal: "T2B" },
      depart: "2026-06-01T10:35:00+02:00",
      arrive: "2026-06-01T13:45:00+02:00",
      duration: "3h 10m",
      bookingRef: "MLTSKM",
      seats: "1B / 1C",
      notes: "Conexión apretada (~5h en Madrid). Cambio de T4 → T1 — usar el bus de transferencia gratuita o el metro intra-aeropuerto (~15 min).",
    },
    {
      id: "f3",
      code: "FR4034",
      airline: "Ryanair",
      from: { code: "BUD", city: "Budapest", lat: 47.4298, lng: 19.2611 },
      to: { code: "PRG", city: "Praga", lat: 50.1008, lng: 14.2632 },
      depart: "2026-06-04T05:50:00+02:00",
      arrive: "2026-06-04T07:05:00+02:00",
      duration: "1h 15m",
      bookingRef: "YSP64L",
      bags: "Alan: 10kg cabina · Carolina: 20kg bodega",
      notes: "Vuelo muy temprano. Considerar taxi del hotel hacia 03:30. Ryanair es estricto con medidas/peso — revisar online check-in 24h antes.",
    },
    {
      id: "f4",
      code: "U8461",
      airline: "Blue Bird Airways",
      from: { code: "PRG", city: "Praga", lat: 50.1008, lng: 14.2632, terminal: "T1" },
      to: { code: "TLV", city: "Tel Aviv", lat: 32.0114, lng: 34.8867 },
      depart: "2026-06-07T18:55:00+02:00",
      arrive: "2026-06-07T23:40:00+03:00",
      duration: "3h 45m",
      bookingRef: "30506C61",
      bags: "Alan: 8kg cabina · Carolina: 20kg bodega",
      notes: "Llegar al aeropuerto 15:45–16:00 (3h antes para vuelo a Israel — control de seguridad extra).",
    },
    {
      id: "f5",
      code: "IB7710",
      airline: "Iberia",
      from: { code: "TLV", city: "Tel Aviv", lat: 32.0114, lng: 34.8867 },
      to: { code: "BCN", city: "Barcelona", lat: 41.2974, lng: 2.0833 },
      depart: "2026-06-14T17:45:00+03:00",
      arrive: "2026-06-14T21:25:00+02:00",
      duration: "4h 40m",
      bookingRef: "AKYXRJ",
      hopperRef: "CSMVXT",
      passengers: "Alan & Carolina",
      paymentRef: "Amex 6320",
      paymentTotal: "US$ 1.136,94 (TLV–BCN–MAD total)",
      notes: "Llegada Barcelona 21:25. Escala nocturna en la ciudad — pasan la noche en hotel y siguen al día siguiente a Madrid. Asientos TLV-BCN: sin seleccionar todavía (hacerlo en check-in Iberia 24h antes).",
    },
    {
      id: "f5b",
      code: "IB420",
      airline: "Iberia",
      from: { code: "BCN", city: "Barcelona", lat: 41.2974, lng: 2.0833 },
      to: { code: "MAD", city: "Madrid", lat: 40.4936, lng: -3.5668, terminal: "T4" },
      depart: "2026-06-15T19:05:00+02:00",
      arrive: "2026-06-15T20:30:00+02:00",
      duration: "1h 25m",
      bookingRef: "AKYXRJ",
      hopperRef: "CSMVXT",
      passengers: "Alan & Carolina",
      seats: "9D · 9E",
      notes: "Asientos asignados 9D y 9E. Llegar al aeropuerto BCN 17:00 (2h antes — vuelo doméstico). Conexión apretada con IB117 a Santiago (sale 23:59 desde Madrid T4) — 3h 30min de margen, suficiente si todo va a horario.",
    },
    {
      id: "f6",
      code: "IB117",
      airline: "Iberia",
      from: { code: "MAD", city: "Madrid", lat: 40.4936, lng: -3.5668, terminal: "T4" },
      to: { code: "SCL", city: "Santiago", lat: -33.3927, lng: -70.7853 },
      depart: "2026-06-15T23:59:00+02:00",
      arrive: "2026-06-16T07:25:00-04:00",
      duration: "13h 26m",
      bookingRef: "H4E1E",
      notes: "Sale Madrid la noche del 15 de junio (23:59) y llega a Santiago el 16 a las 07:25. El '16 jun' que aparece en algunos correos es la fecha de llegada — todo en orden.",
      warning: true,
    },
  ],

  // ============== AUTOS DE ALQUILER ==============
  cars: [
    {
      id: "car-tlv",
      company: "Enterprise",
      provider: "Booking.com",
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Enterprise_Rent-A-Car_logo.svg/512px-Enterprise_Rent-A-Car_logo.svg.png",
      model: "Renault Clio o similar",
      class: "Económico (CDMR)",
      specs: { seats: 5, doors: 4, bags: "1 grande + 1 pequeña", transmission: "Automática", ac: true },
      pickup: {
        at: "2026-06-09T09:00:00+03:00",
        location: "Aeropuerto Tel Aviv Ben Gurion (TLV) — en el aeropuerto",
        instructions: "Después de recoger el equipaje, encuentre al mostrador de Enterprise en el área de llegadas. Mostrar el vale de confirmación de Booking.com (ref 716160421) + licencia de conducir + tarjeta de crédito del titular.",
      },
      dropoff: {
        at: "2026-06-14T15:00:00+03:00",
        location: "Aeropuerto Tel Aviv Ben Gurion (TLV) — en el aeropuerto",
      },
      driver: "Alan Guendelman",
      driverAge: 55,
      bookingRef: "716160421",
      url: "https://secure.booking.com/myreservations.html",
      price: "US$ 290,34 (6 días · todo incluido)",
      included: ["Kilometraje ilimitado", "Tasas e impuestos locales", "Cobertura parcial por colisión (CDW)", "Cobertura en caso de robo", "Seguro de responsabilidad civil (TPL)"],
      tip: "🚗 Llevar licencia de conducir internacional (la chilena puede aceptarse, pero la IDP evita problemas). Tarjeta de crédito a nombre del conductor con €1000-1500 de límite disponible (retenido como depósito). Combustible: política 'lleno a lleno' — devolver con el estanque lleno o cobran +30%. Las franquicias por daños/robo NO están incluidas — si quieren cobertura total, contratar el seguro premium en el mostrador de Enterprise (~US$10-15/día) o usar la cobertura de su tarjeta de crédito.",
    },
  ],

  // ============== HOTELES ==============
  hotels: [
    {
      id: "h1",
      name: "You Hotel Budapest — Handwritten Collection",
      city: "Budapest",
      address: "Szentkirályi utca 8, 1088 Budapest, Hungría",
      lat: 47.4937,
      lng: 19.0635,
      checkIn: "2026-06-01T15:00:00+02:00",
      checkOut: "2026-06-04T05:00:00+02:00",
      nights: 3,
      breakfast: true,
      phone: "+36 70 667 3230",
      bookingRef: "5384.859.194",
      pin: "7759",
      price: "≈ US$381 / €327",
      neighborhood: "Distrito VIII (Józsefváros) — borde con el Distrito V y el Barrio Judío",
      walkTo: [
        { name: "Museo Nacional Húngaro", min: 5 },
        { name: "Gran Sinagoga (Dohány)", min: 12 },
        { name: "Basílica de San Esteban", min: 18 },
        { name: "Parlamento", min: 25 },
      ],
      tip: "Ubicación céntrica y tranquila, a 10 minutos a pie del Barrio Judío y los ruin bars. Pidan habitación hacia el patio interior si quieren más silencio.",
    },
    {
      id: "h2",
      name: "MOODs Boutique Hotel",
      city: "Praga",
      address: "Klimentská 28, Praga 110 00, República Checa",
      lat: 50.0915,
      lng: 14.4329,
      checkIn: "2026-06-04T15:00:00+02:00",
      checkOut: "2026-06-07T12:00:00+02:00",
      nights: 3,
      breakfast: true,
      phone: "+420 222 330 100",
      bookingRef: "6275.380.059",
      price: "≈ US$643 / €552",
      neighborhood: "Nové Město (Ciudad Nueva), a pasos del Barrio Judío (Josefov) y de la Ciudad Vieja",
      walkTo: [
        { name: "Sinagoga Española", min: 7 },
        { name: "Antiguo Cementerio Judío", min: 9 },
        { name: "Plaza de la Ciudad Vieja", min: 12 },
        { name: "Puente Carlos", min: 18 },
      ],
      tip: "Hotel boutique de diseño, muy bien valorado por su desayuno. Las habitaciones varían — si pueden, pidan una más amplia (Deluxe).",
    },
    {
      id: "h3",
      name: "Depto de su hijo · Tel Aviv",
      city: "Tel Aviv",
      address: "Herzl 62, Tel Aviv-Yafo, Israel",
      lat: 32.0608,
      lng: 34.7705,
      checkIn: "2026-06-07T23:40:00+03:00",
      checkOut: "2026-06-14T00:00:00+03:00",
      nights: 7,
      breakfast: false,
      phone: "—",
      bookingRef: "Familiar",
      price: "—",
      neighborhood: "Florentin / sur de Neve Tzedek — barrio bohemio-artístico, lleno de cafés, street art, vida nocturna y mercados",
      walkTo: [
        { name: "Mercado del Carmelo", min: 12 },
        { name: "Neve Tzedek (centro)", min: 8 },
        { name: "Playa Banana / HaTayelet", min: 15 },
        { name: "Jaffa (Old City)", min: 18 },
        { name: "Rothschild Blvd", min: 14 },
        { name: "Mercado Levinsky", min: 6 },
      ],
      tip: "Florentin = barrio joven, ruidoso de noche (los fines de semana). Para taxis usen Gett o Uber. Bicicletas eléctricas (Tel-O-Fun) son la mejor forma de moverse por la ciudad.",
    },
    {
      id: "h4",
      name: "Club In Eilat — Coral Beach Villa Resort",
      city: "Eilat",
      address: "P.O.B 1505, Eilat, 88114, Israel",
      lat: 29.5083,
      lng: 34.9217,
      checkIn: "2026-06-10T16:00:00+03:00",
      checkOut: "2026-06-12T10:30:00+03:00",
      nights: 2,
      breakfast: true,
      phone: "+972 8 636 1773",
      bookingRef: "5461467799",
      pin: "6944",
      price: "₪1.678 (≈ US$450)",
      neighborhood: "Coral Beach (sur de Eilat) — al lado del Underwater Observatory y la mejor zona de snorkeling",
      walkTo: [
        { name: "Coral Beach (snorkeling)", min: 2 },
        { name: "Underwater Observatory", min: 5 },
        { name: "Promenade / Marina", min: 18 },
      ],
      tip: "🏨 Villa de 1 dormitorio para 3 adultos. Desayuno incluido. ⚠️ Pagar 50% adelantado 7 días antes (antes del 3 jun). Cancelación gratis hasta 2 jun 23:59. ⚠️ Si cancelan entre 3–10 jun pagan 50%; desde 11 jun en adelante pagan el 100%.",
    },
    {
      id: "h5",
      name: "Eurostars Grand Marina",
      city: "Barcelona",
      address: "Moll de Barcelona S/N, 08039 Barcelona, España",
      lat: 41.3756,
      lng: 2.1827,
      checkIn: "2026-06-14T22:30:00+02:00",
      checkOut: "2026-06-15T12:00:00+02:00",
      nights: 1,
      breakfast: true,
      phone: "+34 936 03 90 00",
      bookingRef: "E030-755854",
      pin: "4GZC8GJMDG",
      price: "€243 total · 1 noche · Habitación superior · desayuno incluido (paga en el hotel)",
      neighborhood: "Port Vell — Moll de Barcelona, junto al WTC y a la base del telefèric. Hotel 5⭐ con vistas al puerto y a Montjuïc. Súper céntrico: a 5 min andando del Maremagnum y La Rambla, 10 min a Barceloneta y al Born, 15 min en taxi al aeropuerto.",
      walkTo: [
        { name: "Torre d'Alta Mar (telefèric del puerto)", min: 5 },
        { name: "La Rambla / Mirador de Colón", min: 5 },
        { name: "Maremagnum & Aquarium", min: 5 },
        { name: "Born / Santa María del Mar", min: 12 },
        { name: "Barri Gòtic / Catedral", min: 12 },
        { name: "Playa de la Barceloneta", min: 12 },
        { name: "Metro Drassanes (L3)", min: 3 },
      ],
      tip: "🏨 Eurostars Grand Marina 5⭐ · Habitación superior · desayuno incluido (Restaurante Marina, 1ª planta, lun-vie 7:00-10:30 · dom 7:30-11:00) · check-in 15:00 / check-out 12:00. Localizador E030-755854 · PIN web 4GZC8GJMDG. Pagar al check-in. Tasa de ciudad €26,40 NO incluida. Aparcamiento valet €38/día. Lobby bar abierto dom-jue 11:00-00:00 (cocina cierra 22:30 — opción de cena rápida si llegan justos). Room service 24h. Piscina exterior 10:00-20:00. Gimnasio 24h. 🚖 Aeropuerto El Prat a 15 min en taxi (€25-30) — mucho más cerca que de Les Corts.",
    },
  ],

  // ============== DÍAS ==============
  days: [
    {
      id: "d0",
      date: "2026-05-31",
      dayLabel: "Domingo",
      city: "Santiago → Madrid",
      flag: "🇨🇱 ✈️ 🇪🇸",
      title: "El comienzo",
      summary: "Vuelo nocturno transatlántico. Empieza la aventura.",
      hero: "https://images.unsplash.com/photo-1569154941061-e231b4725ef1?w=1200&q=70",
      narrative: "Hoy comienza el viaje. Iberia IB118 sale a las 10:40 desde Santiago y, después de casi 13 horas sobre el Atlántico, los deja en Madrid al amanecer. Cenen bien antes del vuelo — el de a bordo nunca es suficiente — y traten de dormir desde que apaguen las luces. El truco para llegar enteros: hidratarse, evitar el alcohol y caminar el pasillo cada 2 horas.",
      stops: ["flight:f1"],
    },
    {
      id: "d1",
      date: "2026-06-01",
      dayLabel: "Lunes",
      city: "Madrid → Budapest",
      flag: "🇪🇸 ✈️ 🇭🇺",
      title: "Madrid de paso · Llegada a Budapest",
      summary: "Conexión rápida en Madrid y vuelo a Hungría. Tarde libre en Budapest.",
      hero: "https://images.unsplash.com/photo-1551867633-194f125bddfa?w=1200&q=70",
      narrative: "Aterrizan en Madrid 05:20 y vuelan a Budapest a las 10:35. Son 5 horas justas pero útiles: pasaje de control, cambio de T4 a T1 (hay bus gratuito o tren intra-aeropuerto, 15 min). Si alcanzan, un café con churros en el aeropuerto. Llegan a Budapest 13:45. Taxi oficial Főtaxi o miniBUD desde el aeropuerto (~25 min, €25–30). Check-in en el hotel desde las 15:00. La tarde es para aclimatarse: caminar sin rumbo, cambiar dólares a forintos (HUF) — ojo, no en las casas de cambio de la calle turística, mejor en bancos o en el aeropuerto. Cena temprana cerca del hotel.",
      stops: ["flight:f2", "hotel:h1", "place:bud-andrassy", "place:bud-rosenstein"],
      tips: [
        "Moneda: Florín húngaro (HUF). 1 € ≈ 400 HUF. Casi todo acepta tarjeta.",
        "Idioma: Húngaro. Mucha gente joven habla inglés. 'Hola'= Szia (sía). 'Gracias'= Köszönöm (kó-só-nóm).",
        "Propina: 10–12% en restaurantes, no siempre incluida — revisar la cuenta.",
      ],
    },
    {
      id: "d2",
      date: "2026-06-02",
      dayLabel: "Martes",
      city: "Budapest",
      flag: "🇭🇺",
      title: "Buda · Castillo, Bastión y vistas",
      summary: "El lado Buda del Danubio. Historia, panoramas y el atardecer en el Puente de las Cadenas.",
      hero: "https://images.unsplash.com/photo-1541849546-216549ae216d?w=1200&q=70",
      narrative: "Hoy cruzamos al lado Buda — el viejo, el aristocrático, el de las colinas. Desayuno temprano en el hotel y partan caminando hacia el Danubio. Suban en el funicular (Sikló) hasta la colina del Castillo, recorran el Distrito del Castillo a paso lento, perdiéndose en sus callejas medievales. La Iglesia Matías deslumbra desde adentro — pidan el ticket combinado con el Bastión de los Pescadores, esa terraza neorrománica con siete torres (una por cada tribu magiar) que ofrece la postal más famosa de la ciudad. Bajen a almorzar al lado Pest atravesando el Puente de las Cadenas a pie — es corto y vale la pena. Por la tarde, descanso en el hotel y al anochecer vuelvan al Bastión: las luces del Parlamento al otro lado del río son inolvidables.",
      stops: ["place:bud-funicular", "place:bud-castillo", "place:bud-matias", "place:bud-bastion", "place:bud-puente-cadenas", "place:bud-gellert-hill", "place:bud-stand25"],
      tips: [
        "Compren la entrada a Iglesia Matías + torre por separado — la torre tiene cupos limitados.",
        "Funicular: ida ~€5. Si están bien de rodillas, subir a pie por la cuesta es agradable (15 min).",
        "Atardecer ideal en el Bastión: ~20:30 en junio. Llevar una chaqueta liviana.",
        "Si quedan energías para más vista: Colina Gellért tiene un panorama 360° aún mejor, bus 27 los sube en 10 min.",
      ],
    },
    {
      id: "d3",
      date: "2026-06-03",
      dayLabel: "Miércoles",
      city: "Budapest",
      flag: "🇭🇺",
      title: "Pest · Barrio Judío, Parlamento y Danubio",
      summary: "El día más emotivo. Memoria, sinagogas y el río que parte la ciudad.",
      hero: "https://images.unsplash.com/photo-1565008576549-57569a49371d?w=1200&q=70",
      narrative: "Hoy es el día clave. Empiecen temprano por el Parlamento — reserven con anticipación el tour guiado en español (45 min, incluye la Corona de San Esteban). Después caminen 10 minutos por la orilla del Danubio hasta el memorial 'Zapatos en la orilla': 60 pares de zapatos de hierro fundido, recordatorio mudo de los judíos asesinados aquí por las milicias Arrow Cross en el invierno de 1944–45. Detenerse. Respirar. Continúen hacia la Basílica de San Esteban (suban a la cúpula si pueden, vistas 360°) y almuercen liviano. La tarde está dedicada al Barrio Judío (Distrito VII): la Gran Sinagoga de la calle Dohány — la más grande de Europa, segunda del mundo —, su patio con el Árbol de la Vida (sauce metálico con los nombres de víctimas en cada hoja), el Museo Judío adjunto, y caminar las calles Kazinczy y Rumbach descubriendo las otras sinagogas. Por la noche, los famosos 'ruin bars' (Szimpla Kert es el original) en el corazón del barrio. Para cerrar el día con sentido: cena en Spinoza — restaurante-café-teatro-galería en Dob u. 15, cocina húngara-judía tradicional (sopa de ganso con matzá, paprikash, flódni), música en vivo todas las noches. O alternativa Mazel Tov (más mediterráneo) o Rosenstein.",
      stops: ["place:bud-parlamento", "place:bud-zapatos", "place:bud-basilica", "place:bud-dohany", "place:bud-arbol", "place:bud-kazinczy", "place:bud-rumbach", "place:bud-szimpla", "place:bud-spinoza", "place:bud-mazel-tov"],
      tips: [
        "Parlamento: reserva online imprescindible. Cupos en español agotan rápido.",
        "Gran Sinagoga: cubrirse hombros y rodillas. Hombres reciben kipá a la entrada.",
        "Szimpla Kert (ruin bar): mejor antes de las 21:00, después se llena. Domingos en la mañana = mercado de productores con quesos, mieles, pálinkas.",
        "Si quieren más: Casa del Terror (Andrássy 60) suma una hora intensa al día 3, justo en el camino al barrio judío. La Plaza de los Héroes + el City Park son otra opción si prefieren tarde más liviana (M1 línea amarilla, 15 min).",
      ],
    },
    {
      id: "d4",
      date: "2026-06-04",
      dayLabel: "Jueves",
      city: "Budapest → Praga",
      flag: "🇭🇺 ✈️ 🇨🇿",
      title: "Vuelo temprano · Praga y el Barrio Judío",
      summary: "Madrugón a Praga. Tarde para entrar al corazón de Josefov, abierto y vivo.",
      hero: "https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=1200&q=70",
      narrative: "Día de transición + el día más cargado de memoria. Vuelo Ryanair 05:50 — taxi desde el hotel hacia 03:30. Hagan check-in online la noche anterior (Ryanair cobra €55 si lo hacen en el aeropuerto). Llegan a Praga 07:05. Desde el aeropuerto, taxi Uber/Bolt al hotel (~25 min, 700–900 CZK). Dejen las maletas, desayunen tranquilos. Mañana liviana: caminen a la Plaza de la Ciudad Vieja, esperen el Reloj Astronómico en hora en punto, entren a la Iglesia de Týn. Almuercen temprano en Lokál Dlouhááá (Pilsner del tanque, comida checa honesta) — a 5 min andando de Josefov. Tarde dedicada al Barrio Judío: hoy jueves está TODO abierto hasta las 18:00 (sin restricciones de Shabat). Compren el ticket combinado del Museo Judío de Praga. Empiecen por la Sinagoga Pinkas: en sus paredes están escritos a mano los nombres de 77.297 judíos checos y moravos asesinados en la Shoá. Salgan al Antiguo Cementerio Judío — 12.000 lápidas amontonadas en capas, algunos cuerpos enterrados 12 niveles bajo el suelo. Allí descansa el Rabbi Loew, el maharal que según la leyenda creó al Golem. Sigan a la Sinagoga Klausen, Sinagoga Maisel, Sala Ceremonial, y cierren en la Sinagoga Española — el interior morisco más hermoso que verán, dorado y celeste. La Sinagoga Vieja-Nueva (Staronová) es ticket aparte (220 CZK) pero es la más antigua de Europa que sigue activa. Final del día: caminen al atardecer por el Puente Carlos (las estatuas barrocas, los músicos, los turistas se diluyen después de las 19:00). Cena ligera — mañana es temprano.",
      stops: ["flight:f3", "hotel:h2", "place:prg-ciudad-vieja", "place:prg-reloj", "place:prg-tyn", "place:prg-lokal", "place:prg-pinkas", "place:prg-cementerio", "place:prg-klausen", "place:prg-maisel", "place:prg-espanola", "place:prg-vieja-nueva", "place:prg-kafka", "place:prg-puente-carlos"],
      tips: [
        "Moneda: Corona checa (CZK). 1 € ≈ 25 CZK. Aceptan tarjeta casi en todas partes.",
        "Idioma: Checo. Mucho menos inglés que en Budapest — útil un par de palabras. 'Hola'= Dobrý den. 'Gracias'= Děkuji (dié-kuyi).",
        "Cuidado con los cambios de moneda en la calle (Wenceslao, etc.) — estafas frecuentes. Usar cajeros Euronet con precaución también. Mejor: cajeros de bancos checos (ČSOB, Komerční Banka).",
        "Ticket combinado del Museo Judío: ~500 CZK. La Vieja-Nueva es ticket aparte (~220 CZK).",
      ],
    },
    {
      id: "d5",
      date: "2026-06-05",
      dayLabel: "Viernes",
      city: "Praga · Terezín",
      flag: "🇨🇿 🕯️",
      title: "Terezín · Memoria del Holocausto",
      summary: "Excursión día completo al gueto-campo. El cierre necesario después de Josefov.",
      hero: "https://images.unsplash.com/photo-1620939273659-c2b1ce30af46?w=1200&q=70",
      narrative: "Hoy salen de Praga para el día más cargado del viaje. Terezín queda a 60 km al norte de Praga — 1 hora en bus. Fue el gueto-campo donde los nazis concentraron a 150.000 judíos checos, alemanes y austríacos antes de mandarlos a Auschwitz. La SS usaba Terezín como teatro de propaganda: en 1944 hicieron creer a la Cruz Roja Internacional que era 'la ciudad que Hitler regaló a los judíos'. Mientras tanto, 33.000 personas murieron aquí mismo y otros 88.000 fueron deportados al este.\n\n🚐 Hoy van con la excursión de NATTIVUS (proveedor local: Torres de Praga), 6 horas en español. Ref de reserva: NTT76562474. Punto de encuentro: puerta del supermercado Billa, en V Celnici 4 (estación de metro Náměstí Republiky, línea B amarilla) — a 5 min andando del hotel. Salida 09:00, llegar 15 min antes (08:45). Visitas: la Pequeña Fortaleza (cárcel de la Gestapo), el Museo del Gueto (con los dibujos de los niños — los 15.000 niños que pasaron por Terezín, sólo 100 sobrevivieron), los Barracones de Magdeburg y el Cementerio Nacional. Las entradas al complejo van INCLUIDAS en el tour. Vuelven a Praga a media tarde.\n\nEsta noche: cena sencilla y temprano cerca del hotel, no fuercen un plan grande. Si quieren reflexión, un café tranquilo en Café Louvre (donde iba Einstein y Kafka) o en Slavia frente al río.",
      stops: ["place:prg-terezin-fortaleza", "place:prg-terezin-museo", "place:prg-terezin-magdeburg", "place:prg-terezin-cementerio", "place:prg-louvre", "place:prg-eska"],
      tips: [
        "🚐 Tour NATTIVUS · ref NTT76562474 · 09:00 · 6h · 2 adultos · español. Punto de encuentro: Billa, V Celnici 4 (metro Náměstí Republiky · línea B). Lleguen 08:45.",
        "Contacto del operador (Torres de Praga): +420 777 546 992 · reservas@torresdepraga.com — usalo SÓLO para puntos de encuentro / emergencias del día.",
        "El bono PDF: llévenlo en el celular para mostrarlo en el punto de encuentro. Ya está guardado en este lugar dentro de la app.",
        "Cancelación: gratis hasta 48h antes. Después de las 09:00 del miércoles 3 jun no hay reembolso.",
        "Llevar: agua, calzado cómodo, algo para la lluvia (zona descubierta). Almuerzo: hay un café modesto en el complejo o lleven snacks.",
        "Plan emocional: no agendar nada pesado para esta noche. Día emocionalmente exigente.",
      ],
    },
    {
      id: "d6",
      date: "2026-06-06",
      dayLabel: "Sábado",
      city: "Praga",
      flag: "🇨🇿",
      title: "Castillo, Catedral y Mala Strana",
      summary: "El otro lado del río. La colina del castillo, el Callejón de Oro y Kafka asomándose entre las callejas.",
      hero: "https://images.unsplash.com/photo-1541849546-216549ae216d?w=1200&q=70",
      narrative: "Hoy subimos al Castillo de Praga, el complejo de castillo más grande del mundo según el Guinness. Crucen el Puente Carlos temprano (antes de las 09:00 está casi vacío). Suban por la calle Nerudova en Mala Strana — bonita, llena de casas con símbolos antiguos en lugar de números (la del Tres Violines, la del León Rojo...). Lleguen al Castillo a las 9:00 sharp para evitar colas y aprovechar la mejor luz en los vitrales de Mucha de la Catedral de San Vito. Entrada con ticket 'B' (450 CZK): Catedral + Palacio Real + Basílica de San Jorge + Callejón de Oro. El Callejón de Oro es donde vivió Kafka (casa nº 22, un par de años). Cambio de guardia con banda: 12:00 en el primer patio. Almuercen en Lobkowicz Café (terraza con vistas) o bajen a Mala Strana a U Modré Kachničky. Tarde: jardines del Palacio Wallenstein (gratis, con pavos reales sueltos), Iglesia de San Nicolás (barroco que abruma), el Muro de Lennon, la isla Kampa. Vuelvan al hotel cruzando otra vez el Carlos al atardecer.",
      stops: ["place:prg-mala-strana", "place:prg-nerudova", "place:prg-castillo", "place:prg-san-vito", "place:prg-callejon-oro", "place:prg-wallenstein", "place:prg-san-nicolas", "place:prg-lennon-wall", "place:prg-kampa", "place:prg-modre-kachnicky"],
      tips: [
        "Castillo: ticket 'B' es el mejor balance precio/contenido (450 CZK).",
        "La Catedral entra dentro del ticket, pero hay una zona libre — vayan al fondo para ver bien Mucha.",
        "Cambio de guardia: cada hora en punto. La principal a las 12:00 en el primer patio (con banda).",
        "Sábado: misa temprana 7:00 termina mucho antes de las visitas (9:00). Sin restricciones.",
      ],
    },
    {
      id: "d7",
      date: "2026-06-07",
      dayLabel: "Domingo",
      city: "Praga → Tel Aviv",
      flag: "🇨🇿 ✈️ 🇮🇱",
      title: "Última mañana · Israel te espera",
      summary: "Mañana en Praga + traslado al aeropuerto. Vuelo a Tel Aviv 18:55.",
      hero: "https://images.unsplash.com/photo-1583422409516-2895a77efded?w=1200&q=70",
      narrative: "Última mañana en Praga. Si dejaron Josefov para hoy, aprovechen apenas abren (09:00). Si ya lo hicieron, dedíquenle el tiempo a cosas chicas: el barrio de Vinohrady (más local, menos turístico, cafés de barrio), o un paseo por el Vyšehrad (la otra colina, donde está el cementerio con Dvořák y Smetana — más silencioso y poético que el Castillo). Almuercen liviano. Salgan del hotel a las 15:00 hacia el aeropuerto (Uber/Bolt, ~25 min). Llegar 3 horas antes a Praga T1 — el control de seguridad para vuelos a Israel es más exhaustivo. Aterrizan en Tel Aviv 23:40. Su hijo los espera.",
      stops: ["place:prg-vysehrad", "place:prg-vinohrady", "flight:f4"],
      tips: [
        "Aeropuerto de Praga: el T1 atiende vuelos extra-Schengen (Israel incluido).",
        "Antes del vuelo a Israel: control de seguridad con preguntas (origen del viaje, dónde estuvieron, equipaje). Tranquilos y honestos, es protocolo estándar.",
      ],
    },
    // ===== Días Israel (vacíos como pediste) =====
    { id: "d8", date: "2026-06-08", dayLabel: "Lunes", city: "Israel", flag: "🇮🇱", title: "Israel · con su hijo", summary: "Día libre — visita familiar.", narrative: "Días en Israel. Esta sección queda libre — ya conocen el país y están con su hijo. Cualquier nota o foto que quieran agregar después la pueden subir.", stops: [], israel: true },
    { id: "d9", date: "2026-06-09", dayLabel: "Martes", city: "Israel", flag: "🇮🇱", title: "Israel", summary: "Día libre.", narrative: "Israel.", stops: [], israel: true },
    { id: "d10", date: "2026-06-10", dayLabel: "Miércoles", city: "Tel Aviv → Eilat", flag: "🇮🇱 🏜️", title: "Bajada al sur · Negev y Eilat", hero: "https://images.unsplash.com/photo-1599580546666-c89cce9ebd84?w=1200&q=70", summary: "Día largo de ruta: Mitzpe Ramon, Neot Semadar, Red Canyon, Timna y noche en Eilat.", narrative: "Día de ruta por el desierto del Negev hacia Eilat. Salida 8:00 AM desde la casa de Ariel en Tel Aviv. Toman Ruta 1 hacia Beer Sheva y bajan por Ruta 40 al corazón del Negev. Primera parada hacia las 11:00: Mitzpe Ramon — el cráter erosivo más grande del mundo. Visita corta al mirador + Visitor Center (~1h 30min) y almuerzo en alguno de los cafés del pueblo. Siguen por Ruta 40 → Ruta 25 hacia el este hasta enganchar con Ruta 90 (Arava). Café en el kibutz Neot Semadar (bodega ecológica). Continúan al Red Canyon (HaKanyon HaAdom) — si el tiempo lo permite y queda luz, sendero corto de 45 min. Última parada antes del hotel: Timna Park (minas del rey Salomón) — visita recorrida por dentro en auto, ~1h. Llegan al Club In Eilat Coral Beach Villa Resort al anochecer (check-in 16:00 en adelante, villa de 1 dormitorio, desayuno incluido).\n\n⚠️ DÍA LARGO. Considerar prioridades: si llegan justos de tiempo, saltarse Red Canyon (lo pueden hacer otro día desde Eilat) y entrar a Timna ya con luz baja.\n\nLLEVAR: agua abundante (2L/persona), bloqueador, gorro, calzado cerrado, snacks. Negev en junio = 38°C+.", stops: ["place:il-mitzpe-ramon", "place:il-neot-semadar", "place:il-red-canyon", "place:il-timna-park", "hotel:h4"], israel: true, tips: ["Ruta sugerida ida: Ruta 1 → 40 (Mitzpe Ramon) → 25 → 90. Vuelta opcional por Ruta 90 (eje Mar Muerto).", "Combustible: cargar lleno antes de salir de Tel Aviv. Próximas gasolineras confiables: Mitzpe Ramon, Yotvata y Eilat.", "Velocidad límite Ruta 40 y 90: 90 km/h. Hay controles de radar frecuentes.", "Mitzpe Ramon mirador: entrada al pueblo gratis, Visitor Center 28 NIS. Hay buenos cafés (Lasha Bakery, Café Hayey HaMidbar).", "Red Canyon: si llegan después de las 17:00 el cañón ya está en sombra — perfecto para fotos.", "Hotel Eilat: PIN reserva 6944 · ref 5461467799. Confirmar pago 50% antes del 3 jun."] },
    { id: "d11", date: "2026-06-11", dayLabel: "Jueves", city: "Eilat", flag: "🇮🇱 🐠", title: "Eilat · Mar Rojo", hero: "https://images.unsplash.com/photo-1539635278303-d4002c07eae3?w=1200&q=70", summary: "Día completo en Eilat: playa, Underwater Observatory, Mall y vida nocturna.", narrative: "Día de descanso y mar después del road trip. Mañana: playa al norte de la ciudad (Coral Beach o Princess Beach son las mejores para snorkeling — peces tropicales se ven a 2 metros de la orilla). Mediodía: Underwater Observatory Marine Park — el único acuario submarino de Israel, con torre de observación a 6m bajo el agua, túneles, tiburones y una piscina de tortugas. Tarde: Ice Mall Eilat (el único mall con pista de patinaje sobre hielo en el medio — buena pausa del calor) y caminar la Promenade. Cena: pescado fresco en la Marina (Pago Pago, The Last Refuge o Eddie's Hideaway).", stops: ["place:il-eilat-coral-beach", "place:il-eilat-underwater", "place:il-eilat-ice-mall", "place:il-eilat-promenade", "place:il-eilat-pago-pago"], israel: true, tips: ["Coral Beach Nature Reserve: 35 NIS, incluye snorkel guiado por boyas señalizadas. Mejor temprano o al atardecer (sin viento).", "Underwater Observatory: 99 NIS adultos. Llegar 11:00 antes del calor.", "Eilat es zona libre de impuestos (sin IVA) — compras más baratas que en el resto del país.", "Cuidado con el sol del Negev: junio = 40°C+. Usar gorro y SPF 50 obligatorios."] },
    { id: "d12", date: "2026-06-12", dayLabel: "Viernes", city: "Eilat → Beit Guvrin → Jerusalén → Bet El", flag: "🇮🇱 🕯️", title: "Regreso · Beit Guvrin, Jerusalén y Shabat en Bet El", hero: "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?w=1200&q=70", summary: "Vuelta del sur. Cuevas UNESCO, mercado Mahane Yehuda + Kotel y llegada antes del Shabat.", narrative: "Salida temprano de Eilat (idealmente 7:00) — día denso. Subida por Ruta 90 → Ruta 35 hacia el oeste. Primera parada: Parque Nacional Beit Guvrin–Maresha, Patrimonio UNESCO. Cuevas excavadas en piedra caliza durante 2.000 años — la Cueva de la Campana, columbarios, aceiteras. Caminata fácil dentro de las cuevas con sombra natural (~1h 30min).\n\nSiguen a Jerusalén (~50 min). Viernes en la mañana es EL momento del Mercado Mahane Yehuda — toda la ciudad se prepara para el Shabat: jalá fresca, rugelach calientes, frutas, halva. Comer algo, comprar para llevar a Bet El. Después, caminar 15 min o tomar taxi hasta la Ciudad Vieja para una visita corta al Kotel (Muro Occidental) antes de que la ciudad cierre por Shabat. Si llegan ~16:00 al Kotel, ya empieza el ambiente del Kabalat Shabat.\n\nSalen de Jerusalén con tiempo (no más tarde de 17:30) hacia Bet El por Ruta 60. ~30 minutos. Llegada a casa del hermano antes de las 18:30 para acomodar la entrada al Shabat tranquilos.\n\n🕯️ SHABAT en familia. Velas se encienden 19:23 viernes 12 jun. Havdalá sábado ~20:30.", stops: ["place:il-beit-guvrin", "place:il-mahane-yehuda", "place:il-kotel", "place:il-bet-el-house"], israel: true, tips: ["Beit Guvrin: 28 NIS adultos. Audio-guía gratis en español por app Parques Nacionales. Linterna pequeña.", "Mahane Yehuda cierra 15:00 viernes — llegar entre 11:00–13:00 para vivirlo en plenitud. Marzipan = la mejor jalá.", "Para estacionar en Jerusalén: parking Mamilla (cerca del Kotel) o Givat Ram. Comuna abre Shabat 14:00 — el centro se vacía rápido.", "Ruta a Bet El: Ruta 60 desde Jerusalén. Hay checkpoint al entrar a Judea y Samaria — pasaportes a mano.", "En Bet El no se conduce en Shabat (vie 19:30 → sáb 20:30). Coordinar llegada con tiempo de sobra (idealmente antes de 18:30)."] },
    { id: "d13", date: "2026-06-13", dayLabel: "Sábado", city: "Bet El · Shabat", flag: "🇮🇱 🕯️", title: "Shabat en Bet El", summary: "Día completo de Shabat con tu hermano. Después de Havdalá, viaje de regreso a Tel Aviv.", narrative: "Shabat completo en familia. Servicios en la sinagoga del asentamiento, almuerzo extendido, descanso. Bet El tiene vistas hermosas hacia las colinas de Samaria y un mirador desde donde se ven las cumbres del valle.\n\nSalida después de Havdalá (~20:30): viaje en auto Bet El → Tel Aviv (~1h 15min por Ruta 60 + Ruta 1). Llegada a casa de Ariel en Tel Aviv ~22:00.", stops: ["place:il-bet-el-house"], israel: true, tips: ["Havdalá en junio: ~20:30. No salgan antes — ruta 60 puede tener tránsito el sábado de noche.", "Cargar combustible al salir de Jerusalén si tienen poco — entre Bet El y Tel Aviv hay menos estaciones abiertas tarde."] },
    { id: "d14", date: "2026-06-14", dayLabel: "Domingo", city: "Tel Aviv → Barcelona", flag: "🇮🇱 ✈️ 🇪🇸", title: "Despedida de Israel · llegada a Port Vell", hero: "https://images.unsplash.com/photo-1583422409516-2895a77efded?w=1200&q=70", summary: "Mañana en Tel Aviv. Vuelo TLV → BCN 17:45. Llegada 21:25, taxi al Eurostars Grand Marina (Port Vell), cena cerca del hotel.", narrative: "Mañana tranquila en Tel Aviv para despedirse de Ariel. Almuerzo temprano en familia. Salida al aeropuerto Ben Gurion 14:00 — el control de seguridad de salida de Israel es exhaustivo (preguntas largas, revisión de equipaje, mejor llegar 3h antes para vuelos internacionales).\n\nVuelo Iberia IB7710 sale 17:45 y llega a Barcelona-El Prat 21:25 (4h 40min, +1h huso). Taxi al **Eurostars Grand Marina** (Moll de Barcelona S/N, Port Vell) — ~15 min · €25-30 (mucho más cerca del aeropuerto que Les Corts). Check-in rápido en el lobby (localizador E030-755854).\n\n🍤 **Cena cerca** (van a llegar al hotel ~22:30): el plan más sensato es **Salamanca** (Passeig Joan de Borbó 21, Barceloneta · 7 min andando por el Moll · cocina abierta hasta 23:30) — paella valenciana, arroz negro, mariscadas. Llamar al salir del aeropuerto (+34 932 21 50 33) para avisar hora estimada y dejar mesa pedida. Plan B si están muertos: **Lobby Bar del hotel** (cocina cierra 22:30, opciones rápidas — bocadillos, ensaladas, copa de cava) o **Room service 24h**. Mañana es el aniversario y van a comer fuerte al mediodía — esta noche conviene cena ligera y dormir bien.", stops: ["flight:f5", "hotel:h5", "place:bcn-salamanca-bcn"], israel: true, tips: [
      "TLV salida: llegar 14:45 (3h antes). Control de seguridad por capas — contestar tranquilo y directo.",
      "Pasaporte chileno NO necesita visa Schengen — verificar 6 meses de validez.",
      "Aeropuerto El Prat → Hotel Eurostars Grand Marina (Port Vell): taxi ~€25-30 / 15 min.",
      "Recordatorio reserva hotel: Eurostars Grand Marina · localizador E030-755854 · PIN web 4GZC8GJMDG · pagar al check-in (€243).",
      "🍤 Llamar a Salamanca al salir del aeropuerto: +34 932 21 50 33 (Passeig Joan de Borbó 21, Barceloneta · 7 min andando).",
      "🥂 Recordatorio: mañana es el aniversario — reservar Torre d'Alta Mar 13:00 con 1-2 semanas de antelación (torredealtamar.com).",
    ] },
    {
      id: "d15",
      date: "2026-06-15",
      dayLabel: "Lunes",
      city: "Barcelona → Madrid → Santiago",
      flag: "🇪🇸 ✈️ 🇨🇱",
      title: "🥂 Aniversario en Barcelona · vuelo nocturno a Chile",
      hero: "https://images.unsplash.com/photo-1583422409516-2895a77efded?w=1200&q=70",
      summary: "🥂 Aniversario: Palau de la Música + Born + almuerzo panorámico en Torre d'Alta Mar. Vuelo 19:05.",
      narrative: "🥂 Hoy es su aniversario. El día está armado para que sea memorable sin estrés: hotel central, paseo modernista por la mañana y almuerzo panorámico al mediodía con vista al Mediterráneo.\n\n⏰ TIMING: pueden estar fuera del hotel hasta las 15:30. Antes de salir dejen las maletas en consigna del hotel (gratis) y avisen al recepcionista. **16:00 taxi al aeropuerto desde el hotel** (15 min, €25-30 — están al lado del aeropuerto).\n\n09:30 — Desayuno buffet en el Restaurante Marina (1ª planta del hotel · incluido).\n\n10:30 — Check-out con maletas a consigna.\n\n10:45 — Taxi o metro al **Palau de la Música Catalana** (8 min taxi / 15 min metro L3 Drassanes → Catalunya → L4 Urquinaona).\n\n11:00 — **Palau de la Música Catalana** (visita guiada en español, 50 min, €20). La otra obra cumbre del modernismo que NO es de Gaudí — un Domènech i Montaner alucinante: techos de cristal azul, mosaicos de pegaso, columnas floridas. Patrimonio UNESCO. Muchos menos turistas que en Casa Batlló. ⚠️ Comprar tickets online HOY: palaumusica.cat\n\n12:00 — Caminata por el **Born**: Mercat de Santa Caterina (techo ondulado de Miralles), Carrer de Montcada (museos Picasso por fuera + galerías), Santa María del Mar (la catedral del mar — gótico catalán puro). Calles tranquilas, terrazas escondidas.\n\n12:50 — Taxi corto al hotel/Torre d'Alta Mar (8 min, €10) por el Passeig de Colom.\n\n🥂 **13:00 — ALMUERZO DE ANIVERSARIO · Torre d'Alta Mar** — restaurante panorámico dentro de la Torre de Sant Sebastià (el telefèric del puerto), a 75m de altura. Vistas 360° al Mediterráneo, Montjuïc, la Sagrada Familia y la Barcelona vieja. Cocina mediterránea contemporánea: menú degustación o à la carte. Pidan mesa de ventana (al reservar avisen que es aniversario — suelen poner una copa de cava de cortesía). €95-130 pp + vino. **2 horas tranquilos**.\n\n15:15 — Bajar de la torre · caminata 5 min al hotel.\n\n15:30 — Hotel: retirar maletas, refrescarse.\n\n16:00 — 🚖 **TAXI AL AEROPUERTO** (~€25-30, 15 min). Vuelo IB420 BCN→MAD sale 19:05.\n\n20:30 — Llegada Madrid T4. Conexión IB117 a Santiago a las 23:59. 3h 30min de margen — cenar tranquilos en T4 (Tapas Madrid en Sala D) o lounge si tienen acceso.",
      stops: ["place:bcn-palau-musica", "place:bcn-santa-caterina", "place:bcn-torre-alta-mar", "flight:f5b", "flight:f6"],
      tips: [
        "🎟️ Palau de la Música — COMPRAR HOY: palaumusica.cat · €20 con guía español · slot recomendado 11:00.",
        "🥂 Torre d'Alta Mar — RESERVAR 1-2 SEMANAS ANTES (torredealtamar.com · +34 932 21 00 07). Mesa de ventana. Avisar aniversario.",
        "⚠️ Lunes: Bar del Pla CERRADO · Cal Pep solo cena · Monestir Pedralbes CERRADO. 7 Portes queda como plan B (12 min andando del hotel).",
        "🚖 Aeropuerto a 15 min en taxi del hotel — quedan súper cerca, no se estresen.",
        "Asientos BCN-MAD ya asignados: 9D y 9E.",
        "Cena previa al vuelo a Santiago: lounge de Iberia en T4 (si tienen acceso) o Tapas Madrid (Sala D, T4).",
      ],
    },
  ],

  // ============== LUGARES ==============
  places: {
    // ===== BUDAPEST =====
    "bud-castillo": {
      id: "bud-castillo",
      name: "Castillo de Buda",
      nameLocal: "Budavári Palota",
      city: "Budapest",
      lat: 47.4961,
      lng: 19.0397,
      type: "sight",
      icon: "🏰",
      hero: "https://images.unsplash.com/photo-1565008576549-57569a49371d?w=1000&q=70",
      story: "El gran palacio que corona la colina de Buda fue residencia real desde el siglo XIII. Destruido y reconstruido tantas veces que su silueta actual (1950s) es ya el séptimo o octavo castillo levantado en el mismo lugar. Adentro: la Galería Nacional Húngara y el Museo de Historia de Budapest. Pero lo mejor está fuera — caminar el patio, mirar el Danubio.",
      hours: "Patio: siempre abierto. Museos: 10:00–18:00 (cerrado lunes).",
      tip: "El patio es gratis y la vista del Parlamento desde aquí es inmejorable.",
    },
    "bud-matias": {
      id: "bud-matias",
      name: "Iglesia de Matías",
      nameLocal: "Mátyás-templom",
      city: "Budapest",
      lat: 47.5021,
      lng: 19.0341,
      type: "sight",
      icon: "⛪",
      hero: "https://images.unsplash.com/photo-1551867633-194f125bddfa?w=1000&q=70",
      story: "Aquí coronaron a los últimos reyes de Hungría — Francisco José y Sissi entre ellos, en 1867. Las paredes interiores están pintadas con motivos folklóricos magiares en colores intensos, algo único en Europa. El techo de tejas vidriadas Zsolnay brilla al sol como un dragón.",
      hours: "Lun–Vie 09:00–17:00 · Sáb 09:00–12:00 · Dom 13:00–17:00 (cierres por misas/bodas)",
      tip: "Compren ticket combinado con la torre (subida estrecha, 200 escalones, vista 360°).",
    },
    "bud-bastion": {
      id: "bud-bastion",
      name: "Bastión de los Pescadores",
      nameLocal: "Halászbástya",
      city: "Budapest",
      lat: 47.5018,
      lng: 19.0345,
      type: "sight",
      icon: "🗼",
      hero: "https://images.unsplash.com/photo-1565008576549-57569a49371d?w=1000&q=70",
      story: "Las siete torres simbolizan las siete tribus magiares que conquistaron la cuenca de los Cárpatos en el 895. No es una fortificación real — se construyó en 1902 como mirador panorámico, en estilo neorrománico inspirado en cuentos de hadas. Desde sus arcadas blancas, el Parlamento parece flotar sobre el Danubio.",
      hours: "Terrazas superiores: 09:00–19:00 (entrada con costo). Terraza inferior: gratis 24h.",
      tip: "Llegar 1 hora antes del atardecer. La luz dorada sobre el Parlamento es lo mejor.",
    },
    "bud-puente-cadenas": {
      id: "bud-puente-cadenas",
      name: "Puente de las Cadenas",
      nameLocal: "Széchenyi Lánchíd",
      city: "Budapest",
      lat: 47.499,
      lng: 19.0428,
      type: "sight",
      icon: "🌉",
      hero: "https://images.unsplash.com/photo-1551867633-194f125bddfa?w=1000&q=70",
      story: "El primer puente permanente sobre el Danubio entre Buda y Pest (1849), encargado por el conde Széchenyi después de no poder cruzar el río en invierno para asistir al funeral de su padre. Los leones que custodian las entradas fueron objeto de bromas durante un siglo: la leyenda decía que el escultor olvidó hacerles la lengua y se suicidó de vergüenza (mentira: las tienen, pero hay que mirar bien).",
      tip: "Crucen a pie. De noche está iluminado con luces tibias — postal absoluta.",
    },
    "bud-funicular": {
      id: "bud-funicular",
      name: "Funicular Sikló",
      nameLocal: "Budavári Sikló",
      city: "Budapest",
      lat: 47.4991,
      lng: 19.0407,
      type: "transit",
      icon: "🚠",
      story: "Funicular histórico de 1870, segundo más antiguo de Europa. Sube en 1 minuto los 50 m de desnivel hasta el Castillo. Es turístico, sí, pero un mini paseo con encanto.",
      hours: "07:30–22:00",
      tip: "Ida: ~€5. Si están con energía, suban a pie por la cuesta (15 min, escaleras).",
    },
    "bud-parlamento": {
      id: "bud-parlamento",
      name: "Parlamento Húngaro",
      nameLocal: "Országház",
      city: "Budapest",
      lat: 47.5072,
      lng: 19.0457,
      type: "sight",
      icon: "🏛️",
      hero: "https://images.unsplash.com/photo-1541849546-216549ae216d?w=1000&q=70",
      story: "El edificio más grande de Hungría y el tercer parlamento más grande del mundo. Neogótico, terminado en 1904, con 691 habitaciones, 27 km de pasillos y una cúpula de 96 m (la altura coincide con el año 896, la llegada de los magiares — los húngaros aman estos guiños históricos). Adentro, la Corona de San Esteban, vigilada por dos guardias inmóviles.",
      hours: "08:00–18:00",
      tip: "Reservar online el tour en español con anticipación (45 min). Llegar 30 min antes — control de seguridad.",
    },
    "bud-zapatos": {
      id: "bud-zapatos",
      name: "Zapatos en la orilla del Danubio",
      nameLocal: "Cipők a Duna-parton",
      city: "Budapest",
      lat: 47.5028,
      lng: 19.0444,
      type: "memorial",
      icon: "🕯️",
      jewish: true,
      hero: "https://images.unsplash.com/photo-1620939273659-c2b1ce30af46?w=1000&q=70",
      story: "60 pares de zapatos de hierro fundido, dispuestos sobre el malecón. Cada par representa a un judío que en el invierno de 1944–45 fue obligado por las milicias fascistas Arrow Cross (Nyilaskeresztes) a sacarse los zapatos antes de ser fusilado al borde del río. Los cuerpos caían al Danubio; los zapatos eran valiosos y se reciclaban. El memorial — del cineasta Can Togay y el escultor Gyula Pauer — fue inaugurado en 2005. Pequeñas piedras y velas suelen aparecer dentro de los zapatos: la tradición judía de honrar a los muertos.",
      tip: "Tomarse un momento. No es necesaria entrada ni guía. Llevar una piedra para dejarla, si quieren.",
    },
    "bud-basilica": {
      id: "bud-basilica",
      name: "Basílica de San Esteban",
      nameLocal: "Szent István-bazilika",
      city: "Budapest",
      lat: 47.5008,
      lng: 19.0537,
      type: "sight",
      icon: "⛪",
      story: "La iglesia católica más importante de Hungría, dedicada al rey-santo que cristianizó al país en el año 1000. Adentro, en una urna iluminada, la reliquia más curiosa del país: la mano derecha momificada de San Esteban (la 'Santa Diestra'). La cúpula tiene exactamente 96 m, igual al Parlamento — ninguna construcción de la ciudad puede superarlos.",
      hours: "Lun–Vie 09:00–17:00 · Sáb 09:00–13:00 · Dom 13:00–17:00",
      tip: "Subir a la cúpula (ascensor + escaleras finales): €6, vista de 360° de Pest.",
    },
    "bud-andrassy": {
      id: "bud-andrassy",
      name: "Avenida Andrássy",
      nameLocal: "Andrássy út",
      city: "Budapest",
      lat: 47.5054,
      lng: 19.0676,
      type: "sight",
      icon: "🏛️",
      story: "La 'Champs-Élysées' de Budapest. 2,3 km de palacetes, embajadas, la Ópera del Estado, cafés y el primer metro continental de Europa (línea M1, 1896, todavía en uso). Patrimonio UNESCO. Caminarla entera lleva 40 min, pero vale el café en Művész Kávéház.",
      tip: "Tomen el M1 (la 'línea amarilla') una estación al menos — los vagones originales restaurados son adorables.",
    },
    "bud-dohany": {
      id: "bud-dohany",
      name: "Gran Sinagoga de Dohány",
      nameLocal: "Dohány utcai Zsinagóga",
      city: "Budapest",
      lat: 47.4956,
      lng: 19.0610,
      type: "synagogue",
      icon: "🕍",
      jewish: true,
      hero: "https://images.unsplash.com/photo-1620939273659-c2b1ce30af46?w=1000&q=70",
      story: "La sinagoga más grande de Europa y la segunda del mundo. 3.000 asientos. Terminada en 1859 en estilo neomorisco — torres bizantinas, interior dorado, lámparas de cristal. Theodor Herzl, el padre del sionismo, nació al lado (la casa hoy es museo). Durante la guerra, el barrio judío fue convertido en gueto: las 70.000 personas confinadas aquí enterraron a sus muertos en el patio de la sinagoga, contra toda tradición — por eso hoy hay un cementerio dentro de un templo, único en el mundo. Detrás está el patio del Árbol de la Vida: un sauce metálico de Imre Varga, cada hoja con el nombre de una víctima.",
      hours: "Dom–Jue 10:00–17:00 · Vie 10:00–14:00 · Sáb cerrado (Shabat)",
      tip: "Ticket incluye sinagoga + cementerio + Museo Judío + Templo de los Héroes. Ofrecen tours guiados en español varios horarios.",
    },
    "bud-arbol": {
      id: "bud-arbol",
      name: "Árbol de la Vida (Memorial)",
      nameLocal: "Életfa",
      city: "Budapest",
      lat: 47.4955,
      lng: 19.0617,
      type: "memorial",
      icon: "🌳",
      jewish: true,
      story: "Escultura del húngaro-judío Imre Varga (1991): un sauce llorón de metal donde cada una de sus 30.000 hojas lleva el nombre o tatuaje de un mártir del Holocausto húngaro. La forma es la de una menorá invertida. Está en el patio detrás de la Gran Sinagoga, junto al cementerio improvisado del gueto.",
      tip: "Acceso incluido en el ticket de la Gran Sinagoga.",
    },
    "bud-kazinczy": {
      id: "bud-kazinczy",
      name: "Sinagoga de Kazinczy",
      nameLocal: "Kazinczy utcai zsinagóga",
      city: "Budapest",
      lat: 47.4965,
      lng: 19.0626,
      type: "synagogue",
      icon: "🕍",
      jewish: true,
      story: "Sinagoga ortodoxa, construida 1913 en Art Nouveau húngaro (¡un estilo casi inexistente en el mundo!). Sigue activa, comunidad pequeña pero viva. Su escuela talmúdica funciona al lado.",
      hours: "Dom–Jue 10:00–16:00 · Vie 10:00–13:00 · Sáb cerrado",
      tip: "Entrada modesta (€3). Si están abiertos, valen su minuto.",
    },
    "bud-rumbach": {
      id: "bud-rumbach",
      name: "Sinagoga de Rumbach",
      nameLocal: "Rumbach Sebestyén utcai zsinagóga",
      city: "Budapest",
      lat: 47.4972,
      lng: 19.0608,
      type: "synagogue",
      icon: "🕍",
      jewish: true,
      story: "Diseñada por el vienés Otto Wagner (1872), sinagoga del 'judaísmo Status Quo' — una corriente intermedia única en Hungría. Cerrada y abandonada por décadas, fue restaurada y reabierta en 2021. Interior octogonal, colores cálidos, una joya recuperada.",
      hours: "10:00–18:00 (cerrada sábados)",
      tip: "Menos conocida que Dohány — entren sin prisa, suelen estar solos.",
    },
    "bud-szimpla": {
      id: "bud-szimpla",
      name: "Szimpla Kert (ruin bar original)",
      nameLocal: "Szimpla Kert",
      city: "Budapest",
      lat: 47.4972,
      lng: 19.0633,
      type: "food",
      icon: "🍻",
      story: "El 'ruin bar' original (2001). Un edificio en ruinas del Barrio Judío que iban a demoler, ocupado por amigos que pusieron sillas viejas, bicicletas colgadas, una bañera reconvertida en sofá. El concepto explotó: hoy todo el barrio es ruin bars. Szimpla sigue siendo el más auténtico — multinivel, con cine al aire libre, mercado de granjeros los domingos, conciertos a diario.",
      hours: "Lun–Jue 15:00–04:00 · Vie–Sáb 12:00–04:00 · Dom 09:00–04:00",
      tip: "Vayan antes de las 21:00 para verlo bien, después se llena. Domingos en la mañana: mercado de productores con quesos, embutidos (sin cerdo si preguntan), miel y palinka casera.",
    },
    "bud-rosenstein": {
      id: "bud-rosenstein",
      name: "Rosenstein",
      city: "Budapest",
      lat: 47.5024,
      lng: 19.0883,
      type: "food",
      icon: "🍽️",
      jewish: true,
      cuisine: "Cocina judía-húngara",
      story: "Restaurante familiar desde 1996, tres generaciones de la familia Rosenstein. Reducción honesta de la cocina judía-húngara: sopa de pollo con kneidlach, sólet (cholent), hígado picado, ganso (¡no cerdo!), strudel de manzana. Bien escondido cerca de la estación Keleti, casi sin turistas. Carolina y Alan deberían reservar al menos un par de días antes.",
      reserve: "+36 1 333 3492 · rosenstein.hu",
      tip: "Pidan la sopa de pollo de la abuela, el ganso asado y el strudel. Si pueden, charlen con Tibor Rosenstein, el dueño — adora hablar con visitantes judíos.",
      noPork: true,
    },
    "bud-mazel-tov": {
      id: "bud-mazel-tov",
      name: "Mazel Tov",
      city: "Budapest",
      lat: 47.4970,
      lng: 19.0631,
      type: "food",
      icon: "🍽️",
      jewish: true,
      cuisine: "Mediterránea-Mediooriental",
      story: "Restaurante-jardín en el corazón del Barrio Judío, dentro de un patio de ruin bar reconvertido. Cocina mediterránea con guiño israelí: hummus, sabich, falafel, shakshuka, ensaladas frescas, pescado. No es kosher estricto pero no sirven cerdo. Música en vivo casi todas las noches. Patio cubierto con plantas y guirnaldas — muy bonito.",
      hours: "12:00–01:00",
      reserve: "+36 70 626 4280",
      tip: "Reservar — siempre lleno. Pidan el plato de mezzes para compartir.",
      noPork: true,
    },
    "bud-spinoza": {
      id: "bud-spinoza",
      name: "Spinoza Café & Restaurant",
      city: "Budapest",
      lat: 47.4960,
      lng: 19.0598,
      type: "food",
      icon: "🎻",
      jewish: true,
      cuisine: "Húngara · judía tradicional",
      story: "Una institución del Barrio Judío de Budapest. En Dob utca 15, dentro de una antigua panadería y fábrica de caramelos, funciona como restaurante + café + teatro + galería. La cocina une el alma húngara y la judía: sopa de ganso con bolas de matzá (de receta de abuela), csirkepaprikás con spätzle casero, sólet, y la joya — flódni, la torta judía tradicional de 3 capas (manzana, nuez, semilla de amapola) con salsa de ciruela. Sin cerdo en los platos tradicionales. Música en vivo todas las noches y concierto Klezmer los viernes. Ambiente nostálgico del 'viejo Pest', acogedor, perfecto para una cena con sentido.",
      hours: "Lun–Mié 17:00–23:00 · Jue–Dom 12:00–23:00",
      reserve: "+36 1 413 7488 · spinoza@spinoza.hu · spinoza-restaurant.hu",
      tip: "Reservar para mesa de noche. El flódni es imperdible — pídanlo aunque estén llenos. Música en vivo desde las 19:30 aprox.",
      noPork: true,
    },
    "bud-stand25": {
      id: "bud-stand25",
      name: "Stand25",
      city: "Budapest",
      lat: 47.4998,
      lng: 19.0349,
      type: "food",
      icon: "🥘",
      cuisine: "Húngara contemporánea",
      story: "Bib Gourmand Michelin. El chef Tamás Széll (campeón Bocuse d'Or europeo) cocina la mejor húngara contemporánea de la ciudad a precios razonables. Goulash con caracol de pollo, paprikás de carne, krémes (milhojas húngaras). En el lado Buda, cerca del Castillo.",
      hours: "Mar–Sáb 12:00–22:00",
      reserve: "+36 30 961 3262 · stand25.hu",
      tip: "Reservar con días de anticipación. Almuerzo menú degustación a buen precio.",
      noPork: false,
      noPorkNote: "Tiene platos de cerdo en carta — pedir alternativas (las hay).",
    },

    // ============== BUDAPEST — EXTRAS (Heroes' Sq, Gellért, Termales, Andrássy etc) ==============
    "bud-heroes-square": {
      id: "bud-heroes-square",
      name: "Plaza de los Héroes",
      nameLocal: "Hősök tere",
      city: "Budapest",
      lat: 47.5147,
      lng: 19.0779,
      type: "sight",
      icon: "🏛️",
      story: "Plaza monumental en el extremo de la Avenida Andrássy. En el centro, la Columna del Milenio (1896, mil años desde la llegada de los magiares a la cuenca de los Cárpatos). A los lados, dos colonadas con estatuas de los 14 grandes líderes de Hungría: San Esteban, Béla IV, Matías Corvino, Kossuth, etc. Patrimonio UNESCO junto con toda la avenida.",
      tip: "Final natural de un paseo por Andrássy (M1, línea amarilla, hasta 'Hősök tere'). De aquí entran al City Park (Városliget) que está justo detrás.",
    },
    "bud-city-park": {
      id: "bud-city-park",
      name: "City Park + Castillo Vajdahunyad",
      nameLocal: "Városliget",
      city: "Budapest",
      lat: 47.5158,
      lng: 19.0848,
      type: "sight",
      icon: "🏰",
      story: "Detrás de la Plaza de los Héroes, el parque más grande del centro. Adentro: el Castillo de Vajdahunyad — un edificio mestizo que reúne piezas de 21 castillos diferentes de Hungría histórica (románico, gótico, renacentista, barroco), construido en 1896 para la Exposición del Milenio. También: el lago artificial (en invierno pista de patinaje), los Baños Széchenyi y un monumento al 'Anónimo' (cronista medieval con la cara cubierta).",
      tip: "Caminata relajada después de Andrássy. Toquen el dedo del 'Anónimo' — tradición de buena suerte para escritores.",
    },
    "bud-szechenyi-baths": {
      id: "bud-szechenyi-baths",
      name: "Baños Termales Széchenyi",
      nameLocal: "Széchenyi Gyógyfürdő",
      city: "Budapest",
      lat: 47.5188,
      lng: 19.0816,
      type: "sight",
      icon: "♨️",
      story: "El balneario termal más grande de Europa, dentro del City Park. Edificio neobarroco amarillo huevo, 18 piscinas (3 al aire libre, 15 cubiertas), saunas, baños turcos. El agua viene de un pozo de 1.246 m de profundidad a 76°C — rica en minerales. Famoso por las partidas de ajedrez en la piscina exterior, con jugadores nadando entre movidas. La experiencia más relajante (y telegénica) de Budapest.",
      hours: "06:00–22:00 todos los días",
      tip: "Llevar traje de baño, chanclas y toalla (o alquilar). Mejor entre semana en la mañana. Si entran al atardecer, el efecto luces+vapor+edificio amarillo es inolvidable. Reserva online: szechenyifurdo.hu para fast-track.",
    },
    "bud-gellert-hill": {
      id: "bud-gellert-hill",
      name: "Colina Gellért + Estatua de la Libertad",
      nameLocal: "Gellért-hegy",
      city: "Budapest",
      lat: 47.4865,
      lng: 19.0463,
      type: "sight",
      icon: "🗽",
      story: "Una de las dos colinas de Buda (235 m), nombrada en honor a San Gellért, monje italiano martirizado por paganos magiares en 1046 (lo metieron en un barril claveteado y lo tiraron rodando colina abajo — sí). En la cima: la Estatua de la Libertad (Szabadság-szobor), 14 m de bronce levantada en 1947 para conmemorar la liberación soviética, hoy reinterpretada como símbolo de libertad a secas. Vista panorámica 360° — la mejor de toda Budapest.",
      tip: "Subir a pie desde el Puente de la Libertad (35 min) o bus 27 (10 min) y bajar caminando. Atardecer aquí es la postal definitiva.",
    },
    "bud-house-of-terror": {
      id: "bud-house-of-terror",
      name: "Casa del Terror",
      nameLocal: "Terror Háza",
      city: "Budapest",
      lat: 47.5070,
      lng: 19.0635,
      type: "memorial",
      icon: "🕯️",
      jewish: true,
      story: "Andrássy 60 — el edificio más siniestro de Hungría. Sede de la Cruz Flechada (fascistas que asesinaron a 20.000 judíos en 1944–45) y después del ÁVH, la policía secreta comunista. Sótanos donde se torturó y ejecutó. Hoy museo intenso que documenta los dos terrores totalitarios del siglo XX en Hungría. Salida por la 'galería de victimarios' — caras de los responsables que vivieron impunes.",
      hours: "Mar–Dom 10:00–18:00 · Lun cerrado",
      tip: "Entrada 4.000 HUF (~€10). Reserva online: terrorhaza.hu/en/tickets. Audio en español incluido. Reservar 2h. Intenso emocionalmente.",
    },
    "bud-opera": {
      id: "bud-opera",
      name: "Ópera del Estado",
      nameLocal: "Magyar Állami Operaház",
      city: "Budapest",
      lat: 47.5026,
      lng: 19.0590,
      type: "sight",
      icon: "🎭",
      story: "Inaugurada en 1884, neorrenacentista, fue diseñada por Miklós Ybl para competir con la Ópera de Viena. Francisco José pidió que NO fuera más grande — así que es más pequeña pero más bella. Reabrió en 2022 tras 5 años de restauración. Sala dorada de 1.260 asientos, frescos de Lotz, acústica top.",
      hours: "Tours guiados 13:00, 14:30 y 16:00 (~5.500 HUF)",
      tip: "Si encuentran función en sus fechas, entrada de ópera o ballet desde 3.000 HUF — la experiencia entera por menos que un cine en Chile.",
    },

    // ===== PRAGA =====
    "prg-ciudad-vieja": {
      id: "prg-ciudad-vieja",
      name: "Plaza de la Ciudad Vieja",
      nameLocal: "Staroměstské náměstí",
      city: "Praga",
      lat: 50.0875,
      lng: 14.4214,
      type: "sight",
      icon: "🏛️",
      hero: "https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=1000&q=70",
      story: "El corazón de Praga desde el siglo X. La rodean: la Iglesia de Týn con sus torres góticas afiladas (Týn parece salido de un cuento gótico), la Iglesia barroca de San Nicolás, el monumento al reformador Jan Hus quemado en 1415, y el Antiguo Ayuntamiento con su famoso Reloj. En el suelo, 27 cruces blancas marcan donde fueron ejecutados los nobles checos en 1621 — el inicio de tres siglos de dominación Habsburgo.",
      tip: "Volver de noche, sin turistas: a las 22:00 la plaza vacía es mágica.",
    },
    "prg-reloj": {
      id: "prg-reloj",
      name: "Reloj Astronómico",
      nameLocal: "Pražský orloj",
      city: "Praga",
      lat: 50.0870,
      lng: 14.4208,
      type: "sight",
      icon: "🕰️",
      story: "El reloj astronómico medieval más antiguo en funcionamiento (1410). Cada hora en punto, los 12 apóstoles desfilan en las ventanitas, la Muerte toca su campanilla y un gallo canta. Es breve, modesto, casi anti-climático — pero seis siglos de mecanismo continuo. La leyenda dice que cuando los praguenses cegaron al maestro relojero Hanuš para que no replicara su obra en otra ciudad, él metió la mano en el mecanismo y lo paró por 400 años. El reloj inferior es astrolabio (posición del Sol, Luna, signos zodiacales). Tres relojes en uno: cuadrante astronómico arriba, calendario zodiacal abajo, y un anillo con horas del día.",
      hours: "🕐 ESPECTÁCULO DE LOS APÓSTOLES: cada hora en punto, de 09:00 a 23:00 (en abril–octubre).\n🗼 TORRE DEL AYUNTAMIENTO (vista 360° y mecanismo del reloj): Lun 11:00–22:00 · Mar–Dom 09:00–22:00.\nEl espectáculo dura 45 segundos. Algunos visitantes se decepcionan — la magia está en saber que ese mecanismo ha sonado cada hora desde 1410.",
      tip: "🕰️ Para el espectáculo de la hora: llegar 10 min antes (la plaza se llena). 🗼 Para subir a la torre (recomendado): comprar entrada online 250 CZK, reservar slot de 30 min — la vista de la plaza y los techos rojos es la mejor. Hay ascensor (no escaleras). 💡 Lo mejor: subir a la torre 15 min antes de una hora en punto y mirar el espectáculo desde arriba.",
    },
    "prg-tyn": {
      id: "prg-tyn",
      name: "Iglesia de Nuestra Señora de Týn",
      nameLocal: "Kostel Matky Boží před Týnem",
      city: "Praga",
      lat: 50.0879,
      lng: 14.4225,
      type: "sight",
      icon: "⛪",
      story: "Las dos torres góticas afiladas de 80 m que dominan la plaza son la silueta de Praga junto al Castillo. Construida en el siglo XIV. Interior barroco — una sorpresa después de la fachada negra. Aquí está enterrado Tycho Brahe, el astrónomo danés que perdió la nariz en un duelo y la reemplazó por una de plata.",
      hours: "Mar–Sáb 10:00–13:00 y 15:00–17:00 · Dom 10:00–12:00",
      tip: "La entrada es por un pasaje estrecho atrás de la plaza, fácil de pasar por alto.",
    },
    "prg-puente-carlos": {
      id: "prg-puente-carlos",
      name: "Puente Carlos",
      nameLocal: "Karlův most",
      city: "Praga",
      lat: 50.0865,
      lng: 14.4114,
      type: "sight",
      icon: "🌉",
      hero: "https://images.unsplash.com/photo-1564511287568-c0baf6c43eb6?w=1000&q=70",
      story: "El puente más famoso de Europa central. 516 m, 30 estatuas barrocas a los lados, construido entre 1357 y 1402. Carlos IV — el rey checo y emperador del Sacro Imperio — puso la primera piedra a las 5:31 del 9 de julio de 1357, una hora calculada como palíndromo numérico (1357 9 7 5:31) para dar suerte al puente. Funcionó: ahí sigue. Toquen la estatua de San Juan Nepomuceno (el caballero arrojado al río por el rey Wenceslao IV) para volver a Praga.",
      tip: "Antes de las 09:00 o después de las 22:00 — sin turistas, con la luz justa. De día está saturado.",
    },
    "prg-castillo": {
      id: "prg-castillo",
      name: "Castillo de Praga",
      nameLocal: "Pražský hrad",
      city: "Praga",
      lat: 50.0905,
      lng: 14.4001,
      type: "sight",
      icon: "🏰",
      hero: "https://images.unsplash.com/photo-1583422409516-2895a77efded?w=1000&q=70",
      story: "El complejo de castillo más grande del mundo (70.000 m²). Fundado en el siglo IX, sigue siendo residencia presidencial. Contiene varias capas históricas: la Basílica de San Jorge (románica, siglo X), la Catedral de San Vito (gótica, terminada en 1929 — sí, 1929), el Palacio Real (con la Sala Vladislao, donde cabe un torneo a caballo adentro), el Callejón de Oro (callecita medieval de casas de muñecas) y los jardines.",
      hours: "Patios: 06:00–22:00 (gratis). Edificios con ticket: 09:00–17:00.",
      tip: "Ticket B (450 CZK): Catedral + Palacio + Basílica + Callejón. Suficiente. Lleguen temprano.",
    },
    "prg-san-vito": {
      id: "prg-san-vito",
      name: "Catedral de San Vito",
      nameLocal: "Katedrála svatého Víta",
      city: "Praga",
      lat: 50.0904,
      lng: 14.4003,
      type: "sight",
      icon: "⛪",
      story: "Iniciada en 1344, terminada en 1929. 585 años. Estilo gótico que termina volviéndose neogótico en las naves nuevas — pero pegado con tal coherencia que casi no se nota. Adentro, el vitral de Alfons Mucha (1931, Art Nouveau) ilumina una capilla lateral con colores que parecen vivos. Reposa San Wenceslao, los reyes checos, y las joyas de la corona (cerradas a 7 llaves).",
      tip: "El vitral de Mucha está en la tercera capilla a la izquierda. La luz mejor: media mañana.",
    },
    "prg-callejon-oro": {
      id: "prg-callejon-oro",
      name: "Callejón de Oro",
      nameLocal: "Zlatá ulička",
      city: "Praga",
      lat: 50.0915,
      lng: 14.4035,
      type: "sight",
      icon: "🏠",
      story: "Calleja medieval con casas diminutas, originalmente para arqueros de la guardia real, después para orfebres (de ahí el nombre), después para artistas y escritores. Franz Kafka vivió en la casa Nº 22 entre 1916 y 1917, donde escribió varios cuentos. Hoy las casas son tiendas o pequeñas exposiciones — visita corta pero atmosférica.",
      tip: "Incluido en el ticket del Castillo. Después de las 17:00 está abierto y gratis (con menos atracciones).",
    },
    "prg-mala-strana": {
      id: "prg-mala-strana",
      name: "Mala Strana",
      city: "Praga",
      lat: 50.0879,
      lng: 14.4042,
      type: "sight",
      icon: "🏘️",
      story: "El barrio bajo del Castillo. Calles empedradas, palacios barrocos, jardines escondidos, embajadas. Mucho menos turístico que el otro lado del río. Caminen sin agenda — perderse aquí es parte del plan.",
      tip: "Entren al patio del Palacio Wallenstein (jardín gratis, pavos reales sueltos). Cerca: la Iglesia de San Nicolás.",
    },
    "prg-nerudova": {
      id: "prg-nerudova",
      name: "Calle Nerudova",
      nameLocal: "Nerudova",
      city: "Praga",
      lat: 50.0883,
      lng: 14.4029,
      type: "sight",
      icon: "🛤️",
      story: "Calle empinada que sube de Mala Strana al Castillo. Antes de que existieran los números de casa, cada edificio tenía un símbolo tallado encima de la puerta — los Tres Violines (nº 12, casa de tres familias de luthiers), las Dos Soles, el León Rojo, la Llave Dorada. Caminar mirando hacia arriba es la mejor manera de subir.",
      tip: "Subida cansadora pero corta. Hay un tranvía (línea 22) que sube por una calle paralela si la rodilla protesta.",
    },
    "prg-wallenstein": {
      id: "prg-wallenstein",
      name: "Jardines Wallenstein",
      nameLocal: "Valdštejnská zahrada",
      city: "Praga",
      lat: 50.0900,
      lng: 14.4067,
      type: "sight",
      icon: "🌿",
      story: "Jardín barroco italiano del siglo XVII detrás del Palacio Wallenstein (hoy Senado). Pavos reales paseando sueltos, una gruta artificial con estalactitas-fantasmas, estatuas mitológicas (las originales fueron saqueadas por los suecos en 1648, estos son réplicas).",
      hours: "Abr–Oct 07:30–18:00. Entrada gratis.",
      tip: "Refugio silencioso a 5 min del Puente Carlos. Pocos turistas lo encuentran.",
    },
    "prg-san-nicolas": {
      id: "prg-san-nicolas",
      name: "Iglesia de San Nicolás (Mala Strana)",
      nameLocal: "Kostel sv. Mikuláše",
      city: "Praga",
      lat: 50.0884,
      lng: 14.4036,
      type: "sight",
      icon: "⛪",
      story: "La obra maestra del barroco checo. Cúpula y frescos que abruman — Mozart tocó aquí el órgano en 1787, y su Requiem fue interpretado en su funeral aquí en 1791. Subir a la torre del campanario es una experiencia distinta: durante la Guerra Fría era un puesto de vigilancia de la StB (policía secreta) sobre la embajada de EE.UU. al frente.",
      hours: "09:00–17:00",
      tip: "Conciertos de órgano al mediodía algunos días — los carteles los ven en la puerta.",
    },

    // ===== PRAGA JUDÍA =====
    "prg-pinkas": {
      id: "prg-pinkas",
      name: "Sinagoga Pinkas",
      nameLocal: "Pinkasova synagoga",
      city: "Praga",
      lat: 50.0892,
      lng: 14.4178,
      type: "synagogue",
      icon: "🕍",
      jewish: true,
      hero: "https://images.unsplash.com/photo-1620939273659-c2b1ce30af46?w=1000&q=70",
      story: "Sinagoga del siglo XVI, hoy memorial del Holocausto checo. En 1955, los artistas Václav Boštík y Jiří John pintaron a mano, letra por letra, los nombres, fechas de nacimiento y campos de exterminio de las 77.297 víctimas judías de Bohemia y Moravia, en las paredes de la sinagoga. En el piso superior, dibujos de los niños del campo de tránsito de Terezín — la mayoría asesinados en Auschwitz. Cuando los comunistas tomaron el poder, taparon todos los nombres en 1968. Fueron repintados en 1995, uno por uno, otra vez.",
      hours: "Dom–Vie 09:00–18:00 (verano). Sáb cerrado.",
      tip: "Incluida en el ticket combinado del Museo Judío. Reserven 45–60 min — los nombres no se terminan de leer.",
    },
    "prg-cementerio": {
      id: "prg-cementerio",
      name: "Antiguo Cementerio Judío",
      nameLocal: "Starý židovský hřbitov",
      city: "Praga",
      lat: 50.0894,
      lng: 14.4174,
      type: "memorial",
      icon: "🪦",
      jewish: true,
      hero: "https://images.unsplash.com/photo-1620939273659-c2b1ce30af46?w=1000&q=70",
      story: "Uno de los lugares más sobrecogedores de Europa. En uso entre 1439 y 1787, era el único cementerio permitido para los judíos de Praga — y el espacio era pequeñísimo. Cuando se llenaba, traían tierra y enterraban encima. Se calcula que hay 100.000 personas bajo unas 12.000 lápidas amontonadas en hasta 12 capas. Aquí descansa el Rabbi Yehuda Loew (1525–1609), el Maharal, sabio kabbalista que según la leyenda fabricó al Golem con barro del río Vltava para proteger al gueto. Sobre su tumba, montones de papelitos con plegarias.",
      hours: "Dom–Vie 09:00–18:00. Sáb cerrado.",
      tip: "Incluida en el ticket combinado. Llevar piedrita para dejar sobre la tumba del Maharal (tradición judía).",
    },
    "prg-klausen": {
      id: "prg-klausen",
      name: "Sinagoga Klausen",
      nameLocal: "Klausová synagoga",
      city: "Praga",
      lat: 50.0900,
      lng: 14.4170,
      type: "synagogue",
      icon: "🕍",
      jewish: true,
      story: "Sinagoga barroca al lado del cementerio. Hoy alberga la exposición permanente del Museo Judío sobre tradiciones, ritos y vida diaria de la comunidad judía checa. Bien curada, ayuda a entender el contexto.",
      hours: "Dom–Vie 09:00–18:00. Sáb cerrado.",
      tip: "Incluida en el ticket combinado.",
    },
    "prg-maisel": {
      id: "prg-maisel",
      name: "Sinagoga Maisel",
      nameLocal: "Maiselova synagoga",
      city: "Praga",
      lat: 50.0884,
      lng: 14.4194,
      type: "synagogue",
      icon: "🕍",
      jewish: true,
      story: "Construida por Mordejai Maisel, el alcalde judío de Praga durante la 'edad de oro' del gueto (siglo XVI). El Maisel original fue mecenas del Maharal y financió escuelas, hospitales y la pavimentación del gueto. Hoy exposición sobre la historia judía en tierras checas, siglos X al XVIII.",
      hours: "Dom–Vie 09:00–18:00. Sáb cerrado.",
      tip: "Incluida en el ticket combinado.",
    },
    "prg-espanola": {
      id: "prg-espanola",
      name: "Sinagoga Española",
      nameLocal: "Španělská synagoga",
      city: "Praga",
      lat: 50.0901,
      lng: 14.4220,
      type: "synagogue",
      icon: "🕍",
      jewish: true,
      hero: "https://images.unsplash.com/photo-1620939273659-c2b1ce30af46?w=1000&q=70",
      story: "La más bella de Praga, sin duda. Construida en 1868 en estilo neomorisco — inspirada en la Alhambra. Interior cubierto entero de arabescos dorados, azules y rojos, con caligrafías geométricas. Conciertos de música clásica varias noches a la semana (Mozart, Dvořák) — vale la pena uno si pueden.",
      hours: "Dom–Vie 09:00–18:00. Sáb cerrado.",
      tip: "Si hay concierto, reserven entrada en la puerta el mismo día o la web. Acústica y belleza juntas.",
    },
    "prg-vieja-nueva": {
      id: "prg-vieja-nueva",
      name: "Sinagoga Vieja-Nueva",
      nameLocal: "Staronová synagoga",
      city: "Praga",
      lat: 50.0898,
      lng: 14.4188,
      type: "synagogue",
      icon: "🕍",
      jewish: true,
      story: "La sinagoga más antigua de Europa que sigue activa — desde 1270. Gótica temprana, austera, casi sin decoración (las leyes judías no permiten figuras). Doce ventanas estrechas (doce tribus). Su nombre extraño viene de 'Altneuschul' en yídish, posible distorsión del hebreo 'Al Tnai' (condicional): construida bajo la condición de que sería desmontada cuando llegara el Mesías. Y, dice la leyenda, el Golem del Rabbi Loew sigue dormido en el ático.",
      hours: "Dom–Jue 09:00–18:00 · Vie 09:00–14:00 · Sáb cerrado",
      tip: "TICKET APARTE — no incluida en el Museo Judío combinado. ~220 CZK.",
    },
    "prg-kafka": {
      id: "prg-kafka",
      name: "Estatua de Kafka (cabeza giratoria)",
      nameLocal: "Hlava Franze Kafky",
      city: "Praga",
      lat: 50.0830,
      lng: 14.4248,
      type: "sight",
      icon: "🗿",
      story: "Escultura del artista checo David Černý (2014): una cabeza de 11 m de altura formada por 42 placas de acero inoxidable que giran independientemente. Cuando todas se alinean, aparece el rostro de Franz Kafka — el escritor judío-praguense más famoso del siglo XX, que vivió y murió obsesionado por esta ciudad ('Praga no me suelta. Esta madrecita tiene garras').",
      hours: "Funciona todo el día, las placas giran cada hora aprox.",
      tip: "Está en la entrada del centro comercial Quadrio, en la salida del metro Národní třída. Aprovechen para ver otra escultura cercana: 'Piss' (los dos hombres orinando sobre el mapa de Chequia, también de Černý).",
    },
    "prg-dancing-house": {
      id: "prg-dancing-house",
      name: "Casa Danzante (Fred & Ginger)",
      nameLocal: "Tančící dům",
      city: "Praga",
      lat: 50.0755,
      lng: 14.4140,
      type: "sight",
      icon: "💃",
      story: "El edificio más contemporáneo de Praga, terminado en 1996 por Frank Gehry junto al arquitecto croata-checo Vlado Milunić. Surgió de un terreno bombardeado por error en 1945 que quedó vacío 50 años. La torre de vidrio que se inclina representa a una bailarina (Ginger Rogers) abrazada por su pareja de piedra rígida (Fred Astaire) — homenaje a la mítica pareja de los musicales de Hollywood. El nombre original fue 'Fred & Ginger' pero los praguenses prefieren 'Tančící dům' (casa danzante). Generó polémica enorme cuando se inauguró sobre un Praga gótica-barroca — ahora es ícono y patrimonio mundial. En el último piso hay un restaurante con vista (Ginger & Fred Restaurant) y un bar-terraza 360° (Glass Bar).",
      hero: "https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?w=1000&q=70",
      hours: "Exterior: siempre. Glass Bar (terraza): 11:00–24:00 todos los días",
      tip: "Mejor vista del edificio: desde el puente Jiráskův Most o desde la otra orilla del río. La terraza-bar Glass Bar (último piso) cobra ~250 CZK de entrada que se descuenta del consumo — drink + atardecer = plan perfecto.",
    },

    // ============== PRAGA — EXTRAS (Wenceslao, Lennon, Kampa, Petřín, Mucha, Obecní) ==============
    "prg-wenceslas-square": {
      id: "prg-wenceslas-square",
      name: "Plaza de Wenceslao",
      nameLocal: "Václavské náměstí",
      city: "Praga",
      lat: 50.0810,
      lng: 14.4275,
      type: "sight",
      icon: "🐎",
      story: "Más que plaza, un bulevar de 750 m. En lo alto, la estatua ecuestre de San Wenceslao (patrón de Bohemia, asesinado por su hermano en 935). Aquí pasó la historia: la 'Misa de Acción de Gracias' tras la primera independencia en 1918, la inmolación del estudiante Jan Palach en 1969 protestando contra la invasión soviética, el sonar de llaves de la Revolución de Terciopelo en 1989. Café Velryba y el Hotel Europa (Art Nouveau, hoy Tatra) la flanquean.",
      tip: "Para sentir el peso histórico, bajen al pequeño memorial de Jan Palach + Jan Zajíc al pie de la estatua. Está a 8 min a pie del hotel MOODs.",
    },
    "prg-lennon-wall": {
      id: "prg-lennon-wall",
      name: "Muro de John Lennon",
      nameLocal: "Lennonova zeď",
      city: "Praga",
      lat: 50.0857,
      lng: 14.4063,
      type: "sight",
      icon: "🎸",
      story: "En 1980, tras el asesinato de Lennon, jóvenes praguenses pintaron su rostro y letras de canciones en este muro de Mala Strana como acto de resistencia anti-soviética (los Beatles estaban prohibidos). El régimen lo blanqueaba; la gente lo repintaba. El muro nunca calló. Sigue cubierto de grafitis, mensajes, fragmentos de 'Imagine' en 50 idiomas. Cambia cada semana — lo que vean nadie lo ha visto antes.",
      tip: "Justo al cruzar el Puente Carlos hacia Mala Strana. Entrada gratis, abierto 24h. Lleven un plumón fino si quieren dejar un mensaje propio.",
    },
    "prg-kampa": {
      id: "prg-kampa",
      name: "Isla Kampa + 'Bebés' de Černý",
      nameLocal: "Ostrov Kampa",
      city: "Praga",
      lat: 50.0837,
      lng: 14.4067,
      type: "sight",
      icon: "👶",
      story: "Isla diminuta entre el Vltava y el canal del Diablo, en Mala Strana. Parque verde, molinos antiguos, museo de arte moderno Kampa. La estrella: las 3 esculturas gigantes de bebés sin cara — 'Miminka' (Bebés) — del artista checo David Černý (2000), arrastrándose por el césped y trepando la Torre Žižkov al otro lado de la ciudad. Inquietantes y geniales.",
      tip: "Llegar caminando por el Puente Carlos (bajar por la escalerita lateral derecha) o por el Lennon Wall. Atardecer perfecto con vista al Castillo desde la otra orilla.",
    },
    "prg-petrin": {
      id: "prg-petrin",
      name: "Colina Petřín + Torre (mini-Eiffel)",
      nameLocal: "Petřín",
      city: "Praga",
      lat: 50.0832,
      lng: 14.3956,
      type: "sight",
      icon: "🗼",
      story: "Colina arbolada de 327 m sobre Mala Strana. En la cima, una torre de hierro de 63 m (1891) construida como respuesta checa a la Torre Eiffel — incluso es del mismo año del original (¡cuando los checos no tenían país!). Vista panorámica 360° de Praga. Subir por el funicular Lanovka (incluido en el ticket del metro/tranvía). Adentro de Petřín hay también un laberinto de espejos, una capilla y un observatorio.",
      hours: "Torre: Abr–Sep 10:00–22:00 · Funicular: 09:00–23:30",
      tip: "Si tienen energía, alternativa al Castillo. Subir en funicular, caminar 15 min al laberinto y bajar caminando entre cerezos en flor (en mayo–junio). Entrada torre: 200 CZK.",
    },
    "prg-mucha-museum": {
      id: "prg-mucha-museum",
      name: "Museo Mucha",
      nameLocal: "Muchovo muzeum",
      city: "Praga",
      lat: 50.0843,
      lng: 14.4287,
      type: "sight",
      icon: "🎨",
      story: "Alfons Mucha (1860–1939) — el genio Art Nouveau checo que diseñó los carteles iconográficos de Sarah Bernhardt en París, las series 'Las Cuatro Estaciones' y 'Las Cuatro Artes', y el vitral de la Catedral San Vito. Pero su obra cumbre fue 'La Epopeya Eslava' — 20 lienzos gigantes (algunos de 6×8 m) sobre la historia de los pueblos eslavos. Este museo pequeño tiene su trayectoria personal, bocetos, fotografías. La Epopeya está en otro museo (Veletržní palác).",
      hours: "10:00–18:00 todos los días",
      tip: "Entrada 320 CZK. Visita de 1h. Compren el libro de la tienda — los carteles originales valen miles de euros.",
    },
    "prg-obecni-dum-building": {
      id: "prg-obecni-dum-building",
      name: "Casa Municipal (edificio)",
      nameLocal: "Obecní dům",
      city: "Praga",
      lat: 50.0879,
      lng: 14.4283,
      type: "sight",
      icon: "🏛️",
      story: "El edificio Art Nouveau más espectacular de Praga (1912), construido sobre la antigua Corte Real. Aquí se declaró la independencia checoslovaca el 28 octubre 1918. Adentro: la Sala Smetana (1.500 asientos, conciertos a diario), café, restaurantes, salas decoradas por Mucha (la Sala del Alcalde), Aleš (la Sala Sladkovský), Preisler. Patrimonio nacional.",
      hours: "Hall principal y café: 07:30–23:00",
      tip: "Hall y café son gratis. Tour guiado de las salas decoradas: ~290 CZK, dura 1h. Si encuentran un concierto en la Sala Smetana, vale la pena.",
    },

    // ============== PRAGA — IMPRESCINDIBLES EXTRA (Cirilo, Terezín, Pólvora, Strahov, Guardia, Vrtba) ==============
    "prg-cirilo-metodio": {
      id: "prg-cirilo-metodio",
      name: "Iglesia San Cirilo y San Metodio (Operación Antropoide)",
      nameLocal: "Kostel sv. Cyrila a Metoděje",
      city: "Praga",
      lat: 50.0765,
      lng: 14.4185,
      type: "memorial",
      icon: "🕯️",
      jewish: true,
      story: "Una de las historias más alucinantes y trágicas de la Segunda Guerra Mundial. En esta iglesia barroca se escondieron los 7 paracaidistas checoslovacos que el 27 de mayo de 1942 asesinaron a Reinhard Heydrich — 'el Carnicero de Praga', mano derecha de Himmler, presidente de la Conferencia de Wannsee donde se planificó la Solución Final. Tras semanas escondidos en la cripta, los nazis fueron delatados y rodearon la iglesia con 800 SS. Tras 6 horas de combate desigual, los paracaidistas se suicidaron con sus últimas balas. La cripta hoy es museo — los muros aún tienen los agujeros de bala. Salvador Dalí lloró aquí. Espacio profundo y emocionalmente intenso, especialmente para visitantes judíos (el atentado precipitó la masacre nazi en represalia de Lidice y Ležáky, pero también aceleró la caída del régimen).",
      hours: "Mar–Sáb 09:00–17:00 · Dom 10:00–17:00 · Lun cerrado",
      tip: "Cripta y museo: 75 CZK. Apenas 25 min de visita, pero es indeleble. La iglesia está en Resslova 9, 12 min a pie del hotel MOODs. Las películas 'Anthropoid' (2016) y 'HHhH / The Man with the Iron Heart' (2017) cuentan esta historia.",
    },
    "prg-terezin": {
      id: "prg-terezin",
      name: "Terezín · Campo de concentración",
      nameLocal: "Terezín",
      city: "Praga",
      lat: 50.5113,
      lng: 14.1480,
      type: "memorial",
      icon: "✡️",
      jewish: true,
      story: "A 60 km al norte de Praga, ciudad-fortaleza del siglo XVIII que los nazis convirtieron en gueto-tránsito y campo de concentración. Por aquí pasaron 155.000 judíos checos, austríacos, holandeses, daneses — la mayoría rumbo a Auschwitz. 35.000 murieron en el propio Terezín por hambre y enfermedades. Terezín tuvo un macabro rol propagandístico: fue el campo modelo que la Cruz Roja visitó en 1944, los nazis montaron un teatro, café y orquesta sólo para esa visita. Aún se conservan dibujos de los 15.000 niños prisioneros — 9 de cada 10 fueron asesinados. Hoy es museo. Memorial doloroso pero crucial.",
      hours: "Abr–Oct 09:00–18:00 · Nov–Mar 09:00–16:30",
      tip: "Excursión de medio día desde Praga. La forma más fácil: tour guiado en español (~€55, incluye transporte + entrada + guía, 6h). Alternativa: bus público desde Florenc (~€8 ida y vuelta, 1h cada tramo). 🕯️ Reservar día específico — pueden incluirlo en un día Israel-libre tras Praga (si tuvieran un día extra) o sustituyendo medio día en Praga. Para Carolina y Alan: una visita profundamente significativa.",
    },
    "prg-powder-tower": {
      id: "prg-powder-tower",
      name: "Torre de la Pólvora",
      nameLocal: "Prašná brána",
      city: "Praga",
      lat: 50.0871,
      lng: 14.4276,
      type: "sight",
      icon: "🗼",
      story: "Una de las 13 puertas medievales de Praga, construida en 1475 como entrada ceremonial real. El nombre viene del siglo XVII cuando se usó para almacenar pólvora. Marca el inicio del Camino Real (Královská cesta) que los reyes recorrían hacia su coronación en San Vito. Gótica tardía con detalles renacentistas en lo alto. Junto a la Casa Municipal.",
      hours: "Abr–Sep 10:00–22:00 · Oct 10:00–20:00",
      tip: "Subida 186 escalones, no apta para mareados. Ticket: ~190 CZK. Vista magnífica del centro y un cuadro 1:1 de cómo era Praga medieval.",
    },
    "prg-strahov": {
      id: "prg-strahov",
      name: "Monasterio Strahov + Biblioteca barroca",
      nameLocal: "Strahovský klášter",
      city: "Praga",
      lat: 50.0860,
      lng: 14.3892,
      type: "sight",
      icon: "📚",
      story: "Monasterio premonstratense fundado en 1143 sobre la colina de Petřín, detrás del Castillo. Pasaron la guerra de los Treinta Años, los Habsburgos, los comunistas. Su biblioteca conserva 200.000 volúmenes — incluidos manuscritos del siglo IX. Dos salones imperdibles: la Sala Filosófica (1797, frescos de Maulbertsch en el techo dorado, biblioteca barroca de roble negro) y la Sala Teológica (1679, decorada con estucos blancos sobre verde). Una de las bibliotecas más bellas del mundo según el National Geographic.",
      hours: "09:00–17:00 · cerrado los días de fiesta religiosa",
      tip: "Ticket biblioteca: 150 CZK (sólo se observa desde la puerta — no entran a las salas para proteger los frescos). Ticket galería de pinturas: 150 CZK. Tienen cervecería propia (Klášterní pivovar Strahov) con cerveza monástica — vale la pena un parón ahí.",
    },
    "prg-vrtba-garden": {
      id: "prg-vrtba-garden",
      name: "Jardín Vrtba (barroco)",
      nameLocal: "Vrtbovská zahrada",
      city: "Praga",
      lat: 50.0864,
      lng: 14.4030,
      type: "sight",
      icon: "🌳",
      story: "Jardín barroco italiano de 1720, escondido en Mala Strana detrás de un palacio. Tres terrazas escalonadas con estatuas mitológicas de Matyáš Bernard Braun, fuentes, glorietas, vistas espectaculares del Castillo y los techos de Mala Strana. Uno de los rincones secretos más bellos de Praga — pocos turistas lo encuentran.",
      hours: "Abr–Oct 10:00–18:00 · cerrado en invierno",
      tip: "Entrada 119 CZK. Acceso por una puerta discreta en Karmelitská 25 — se pierde fácil. Llevar libro y sentarse en la terraza alta.",
    },
    "prg-guard-change": {
      id: "prg-guard-change",
      name: "Cambio de Guardia del Castillo",
      nameLocal: "Výměna stráží",
      city: "Praga",
      lat: 50.0890,
      lng: 14.3989,
      type: "sight",
      icon: "💂",
      story: "Espectáculo militar diario frente al Castillo. Las pequeñas relevas son cada hora en punto de 07:00 a 20:00 — discretas, breves, los guardias cambian uniforme en silencio. Pero la GRAN ceremonia es a las 12:00 todos los días: en el primer patio (Hradčanské náměstí), con banda militar de bronce, izada de bandera, marcha solemne, fanfarrias. Uniformes diseñados en 1990 por Theodor Pištěk (vestuarista de la película 'Amadeus', ganador del Óscar). 25 minutos de ceremonia bien organizada — y gratis.",
      hours: "Pequeñas: cada hora 07:00–20:00 · Gran ceremonia: 12:00 todos los días",
      tip: "Llegar al primer patio 11:30 para conseguir buen lugar. La banda llega marchando — los altos tienen las trompetas, los bajos los tambores. Una de las experiencias del Castillo que NO tiene ticket — sólo presencia.",
    },

    "prg-vysehrad": {
      id: "prg-vysehrad",
      name: "Vyšehrad",
      city: "Praga",
      lat: 50.0648,
      lng: 14.4173,
      type: "sight",
      icon: "⛰️",
      story: "La 'otra' colina de Praga, mucho menos turística que el Castillo. Fortificación medieval con la Basílica de San Pedro y San Pablo (neogótica, espigada como dos lápices apuntando al cielo), un parque verde, vistas panorámicas espectaculares al Vltava y la ciudad. Adentro: el Cementerio de Vyšehrad, donde descansan los grandes checos — Antonín Dvořák, Bedřich Smetana, Alfons Mucha, Karel Čapek. Más silencioso, más poético, menos selfies.",
      hours: "Parque y cementerio: 09:30–18:00 · Basílica: 10:00–18:00",
      tip: "Llegar en metro línea C, estación 'Vyšehrad', después caminar 5 min. Bajar a pie por las escaleras viejas hacia Náplavka (el malecón con cafés-barcaza) — caminata preciosa de 30 min.",
    },

    // ===== RESTAURANTES PRAGA =====
    "prg-lokal": {
      id: "prg-lokal",
      name: "Lokál Dlouhááá",
      city: "Praga",
      lat: 50.0901,
      lng: 14.4244,
      type: "food",
      icon: "🍻",
      cuisine: "Checa tradicional · cervecería",
      story: "La mejor versión moderna de una cervecería checa tradicional (hospoda). Pilsner Urquell directo del tanque (sin pasteurizar, llega de la fábrica de Plzeň a diario), platos checos honestos: goulash, svíčková (lomo en salsa de crema y arándanos), schnitzel, queso frito. Camareros con su humor seco.",
      hours: "Lun–Vie 11:00–01:00 · Sáb 12:00–01:00 · Dom 12:00–22:00",
      tip: "No reservan — llegar 18:30–19:00 o esperar. Pedir la cerveza 'pivo z tanku' (de tanque).",
      noPork: false,
      noPorkNote: "Hay platos de cerdo y otros que no. Goulash de res, svíčková (lomo de res), pollo schnitzel, sopas — sin problema.",
    },
    "prg-modre-kachnicky": {
      id: "prg-modre-kachnicky",
      name: "U Modré Kachničky",
      city: "Praga",
      lat: 50.0865,
      lng: 14.4030,
      type: "food",
      icon: "🦆",
      cuisine: "Checa refinada · caza",
      story: "'El Patito Azul' — restaurante clásico checo en Mala Strana. Cocina seria de tradición: pato, ciervo, jabalí (¡ojo, mejor evitar este!), perdiz, salsas con frutos del bosque. Salones íntimos con vajilla antigua y muebles de madera oscura.",
      hours: "12:00–23:00",
      reserve: "+420 257 320 308",
      tip: "El pato a la naranja es la especialidad. Reservar.",
      noPork: false,
      noPorkNote: "Tiene cerdo y jabalí en carta. Pero el pato, el ciervo, el cordero — espectaculares.",
    },
    "prg-louvre": {
      id: "prg-louvre",
      name: "Café Louvre",
      city: "Praga",
      lat: 50.0833,
      lng: 14.4192,
      type: "food",
      icon: "☕",
      cuisine: "Café histórico",
      story: "Abierto en 1902. Aquí se reunían Kafka, Albert Einstein (cuando enseñaba en la Universidad Alemana, 1911), Karel Čapek y un círculo intelectual praguense que ayudó a inventar el siglo XX. Salones art nouveau con mesas de billar al fondo. Desayunos largos, almuerzos clásicos, tortas (medovník — torta de miel).",
      hours: "Lun–Vie 08:00–23:30 · Sáb–Dom 09:00–23:30",
      tip: "Subir por la escalera de mármol al primer piso — los salones están arriba.",
      noPork: true,
    },
    "prg-eska": {
      id: "prg-eska",
      name: "Eska",
      city: "Praga",
      lat: 50.0935,
      lng: 14.4476,
      type: "food",
      icon: "🍞",
      cuisine: "Checa contemporánea · panadería",
      story: "Restaurante-panadería de moda en el barrio Karlín (al otro lado del río, oriental y moderno). Cocina checa reinterpretada con ingredientes locales: pan negro recién horneado, mantequilla con cebolla quemada, sopas de raíz, pescado de río. Decoración industrial. Imprescindible para ver la Praga del siglo XXI.",
      hours: "Lun–Vie 08:00–23:00 · Sáb–Dom 09:00–23:00",
      reserve: "+420 731 140 884 · eska.ambi.cz",
      tip: "Reservar. Pidan el pan recién horneado de entrada — viene caliente.",
      noPork: false,
      noPorkNote: "Hay platos con cerdo, pero hay también pescado, cordero y vegetales.",
    },

    // ===== TEREZÍN (excursión desde Praga) =====
    "prg-terezin-fortaleza": {
      id: "prg-terezin-fortaleza",
      name: "Pequeña Fortaleza de Terezín",
      nameLocal: "Malá pevnost",
      city: "Terezín",
      lat: 50.5128,
      lng: 14.1547,
      type: "memorial",
      icon: "🕯️",
      jewish: true,
      hero: "https://images.unsplash.com/photo-1605792657660-596af9009e82?w=1200&q=70",
      story: "La Pequeña Fortaleza fue la cárcel política de la Gestapo entre 1940 y 1945. Más de 32.000 prisioneros pasaron por sus celdas: resistentes checos, intelectuales, judíos. Más de 2.500 murieron aquí mismo. Aquí también estuvo encerrado Gavrilo Princip, el atentador del archiduque Francisco Fernando, que murió de tuberculosis en una celda en 1918. Sobre la entrada principal, la inscripción 'Arbeit Macht Frei' (El trabajo libera) — la misma que en Auschwitz. Caminen por los patios, las celdas de aislamiento, el corredor de fusilamiento, el cementerio nacional. Es silencioso, es duro, es necesario.",
      hours: "Abr–Oct 08:00–18:00 · Nov–Mar 08:00–16:30 · Crematorio cerrado los sábados.",
      tip: "Audio-guía en español incluida en el ticket combinado (260 CZK). Tomarse el tiempo — no es museo de paso.",
    },
    "prg-terezin-museo": {
      id: "prg-terezin-museo",
      name: "Museo del Gueto",
      nameLocal: "Muzeum ghetta",
      city: "Terezín",
      lat: 50.5108,
      lng: 14.1499,
      type: "memorial",
      icon: "📜",
      jewish: true,
      story: "En el corazón del antiguo gueto, este museo cuenta la vida y muerte de los 150.000 judíos que pasaron por Terezín entre 1941 y 1945. Lo más conmovedor: los dibujos de los niños. De los 15.000 niños que pasaron por Terezín, solo unos 100 sobrevivieron. La maestra Friedl Dicker-Brandeis les enseñaba arte en secreto; antes de ser deportada a Auschwitz, escondió sus dibujos en dos maletas. Hoy más de 4.000 de esos dibujos están aquí. Verlos es indispensable. También se cuenta cómo los nazis usaron Terezín como teatro de propaganda: una visita de la Cruz Roja en 1944, una película de mentira, antes de mandar a casi todos a Auschwitz.",
      hours: "Abr–Oct 09:00–18:00 · Nov–Mar 09:00–17:30 · Abierto todos los días.",
      tip: "Si solo pueden ver una cosa en Terezín, que sea esta. Los dibujos de los niños quedan grabados para siempre.",
    },
    "prg-terezin-magdeburg": {
      id: "prg-terezin-magdeburg",
      name: "Barracones de Magdeburg",
      nameLocal: "Magdeburská kasárna",
      city: "Terezín",
      lat: 50.5104,
      lng: 14.1474,
      type: "memorial",
      icon: "🏚️",
      jewish: true,
      story: "Reconstrucción de los habitáculos donde vivían los deportados: literas triples apiladas, espacios mínimos, condiciones inhumanas. Pero también aquí, en estos mismos cuartos, surgió una vida cultural extraordinaria: orquestas, óperas (incluida la 'Brundibár' para niños, representada 55 veces), conferencias filosóficas, periódicos clandestinos. La paradoja de Terezín: la creatividad como acto de resistencia mientras los trenes a Auschwitz seguían saliendo cada semana.",
      hours: "Abr–Oct 09:00–18:00 · Nov–Mar 09:00–17:30 · Abierto todos los días.",
      tip: "Ver la sección dedicada a Brundibár — la ópera infantil que se representó 55 veces antes de que los niños fueran deportados.",
    },
    "prg-terezin-cementerio": {
      id: "prg-terezin-cementerio",
      name: "Cementerio Nacional y Crematorio",
      nameLocal: "Národní hřbitov a krematorium",
      city: "Terezín",
      lat: 50.5079,
      lng: 14.1545,
      type: "memorial",
      icon: "🕊️",
      jewish: true,
      story: "Entre la Pequeña Fortaleza y el gueto se extiende el Cementerio Nacional: 10.000 tumbas individuales y una gran estrella de David rodeada de cruces. El Crematorio (separado, junto al cementerio judío) fue construido en 1942 para incinerar a los muertos del gueto — 30.000 cuerpos pasaron por aquí. Hoy es un memorial. La Sala de los Ritos contiene los hornos preservados intactos. Es la parte más silenciosa de Terezín.",
      hours: "Abr–Oct 09:00–18:00. ⚠️ Crematorio cerrado los SÁBADOS (otros días sí abre). Cementerio siempre accesible.",
      tip: "El Crematorio cierra los sábados. Las otras 3 partes del memorial (Pequeña Fortaleza, Museo del Gueto, Barracones) sí abren sábado.",
    },

    // ===== TEL AVIV =====
    "tlv-abu-hassan": {
      id: "tlv-abu-hassan",
      name: "Abu Hassan / Ali Karavan",
      city: "Tel Aviv",
      lat: 32.0539,
      lng: 34.7548,
      type: "food",
      icon: "🥣",
      jewish: false,
      cuisine: "Hummus tradicional árabe",
      story: "El templo del hummus de Israel, en Jaffa desde 1959. Tres sucursales a una cuadra de distancia, todas de la misma familia. Hummus puro, masabacha y ful — solo eso, durante 65 años. Cierran cuando se acaba el hummus del día (suele ser entre las 14:00 y 15:00). Comer aquí es una experiencia ritual: te sientas, pides 'shalosh' (los tres tipos), te traen pita caliente, cebolla cruda, pepinillos, y un té con menta. Sin reservas, sin tarjeta, solo efectivo. Imperdible.",
      hours: "Dom–Vie ~08:00–15:00 (hasta agotar) · Cerrado sábados",
      tip: "Ir antes de las 13:00. Pedir 'masabacha' y 'ful'. Sólo efectivo. Cerrado en Shabat.",
      noPork: true,
    },
    "tlv-hakosem": {
      id: "tlv-hakosem",
      name: "HaKosem",
      city: "Tel Aviv",
      lat: 32.0747,
      lng: 34.7720,
      type: "food",
      icon: "🧆",
      jewish: true,
      cuisine: "Falafel y hummus modernos",
      story: "'El Mago' — referencia del falafel en Tel Aviv desde 2007. Eli Mizrahi (el dueño, ex-actor) hace falafel verde por dentro (mucho cilantro), hummus suave, sabich generoso. Sin pretensiones: barra alta, taburetes, y una atención casi obsesiva por la calidad. Aparece en todas las listas de mejores falafels del mundo.",
      hours: "Dom–Jue 10:00–21:00 · Vie 10:00–17:00 · Sáb cerrado",
      reserve: "Sin reserva, llegar y hacer fila (~10 min)",
      tip: "Pedir el falafel con todo. Si está lleno, el sabich también es brutal.",
      noPork: true,
    },
    "tlv-dr-shakshuka": {
      id: "tlv-dr-shakshuka",
      name: "Dr. Shakshuka",
      city: "Tel Aviv",
      lat: 32.0530,
      lng: 34.7540,
      type: "food",
      icon: "🍳",
      jewish: true,
      cuisine: "Tripolitana-libia · judía mizrají",
      story: "Institución de Jaffa especializada en cocina tripolitana-judía (familia libia que llegó en los 50). Salones llenos de cobre y especias colgando, manteles a cuadros, comida abundante. Shakshuka legendaria (roja, verde, con merguez), couscous, mafrum, cordero. Ambiente bullicioso, familiar, sin pretensiones.",
      hours: "Dom–Jue 12:00–23:00 · Vie 12:00–17:00 · Sáb cerrado",
      reserve: "+972 3-682-2842",
      tip: "Pedir shakshuka de entrada para compartir. Reservar viernes al mediodía (se llena).",
      noPork: true,
    },
    "tlv-miznon": {
      id: "tlv-miznon",
      name: "Miznon",
      city: "Tel Aviv",
      lat: 32.0775,
      lng: 34.7715,
      type: "food",
      icon: "🥖",
      jewish: true,
      cuisine: "Pita gourmet · Eyal Shani",
      story: "Concepto del chef Eyal Shani (estrella mediática israelí). Pita rellena reinterpretada con productos de altísima calidad: coliflor entero asado, hamburguesa, batata con tahini, ratatouille. La carta cambia con la estación. Caos contenido, música alta, gente joven. Es lo más Tel Aviv que existe — global y al mismo tiempo absolutamente local.",
      hours: "11:30–23:00 todos los días (incluso Shabat)",
      reserve: "Sin reserva, contador y fila",
      tip: "Coliflor entero asado: ícono. Pita de batata: postre salado obligatorio.",
      noPork: true,
    },
    "tlv-saluf": {
      id: "tlv-saluf",
      name: "Saluf & Sons",
      city: "Tel Aviv",
      lat: 32.0683,
      lng: 34.7707,
      type: "food",
      icon: "🫓",
      jewish: true,
      cuisine: "Yemenita · judía teimaní",
      story: "Cocina yemenita auténtica en una callejuela tranquila cerca de Nahalat Binyamin. Tres generaciones de la familia Saluf sirviendo jachnun (pan enrollado de 8h), malawach (crepe yemenita), zhug (salsa picante de cilantro), sopa de pollo con khawaij. Decoración modesta, comida brutal. La cocina judía-yemenita es uno de los grandes secretos de Israel.",
      hours: "Dom–Jue 12:00–23:00 · Vie 11:00–16:00 · Sáb cerrado",
      reserve: "+972 3-522-1344",
      tip: "Pedir el sampler yemenita para descubrir varios platos. Domingo en la mañana = jachnun perfecto.",
      noPork: true,
    },
    "tlv-abu-lafia": {
      id: "tlv-abu-lafia",
      name: "Abu Lafia",
      city: "Tel Aviv",
      lat: 32.0541,
      lng: 34.7541,
      type: "food",
      icon: "🥯",
      jewish: false,
      cuisine: "Panadería árabe · 1880",
      story: "Panadería de Jaffa fundada en 1880 — sí, 1880. Cuatro generaciones después, sigue siendo la mejor del barrio. Famosa por el 'sambusak' (empanadilla árabe), el 'fatayer' (zaatar y queso), pan árabe recién horneado, knafeh. Abierta 24 horas. Una visita aquí es ver la otra historia de la ciudad — la árabe, la pre-Israel, la del puerto antiguo.",
      hours: "24 horas",
      tip: "Pedir el knafeh caliente — se prepara al momento. Cerca del Reloj de Jaffa.",
      noPork: true,
    },
    "tlv-romano": {
      id: "tlv-romano",
      name: "Romano",
      city: "Tel Aviv",
      lat: 32.0617,
      lng: 34.7713,
      type: "food",
      icon: "🍽️",
      jewish: false,
      cuisine: "Israelí moderna · Florentin",
      story: "El restaurante-icono de Florentin — su barrio. Patio en un edificio antiguo, cocina mediterránea-israelí moderna con ingredientes de mercado, vermouth casero, vinos naturales. Música DJ, ambiente bohemio-cool. El menú cambia cada semana. Cena, no almuerzo.",
      hours: "Dom–Sáb 19:00–01:00",
      reserve: "Reservar — siempre lleno. romano.co.il",
      tip: "Reservar con 1 semana. Pedir el vermouth de la casa para empezar.",
      noPork: false,
      noPorkNote: "Pueden tener algún plato con cerdo en la carta semanal. La mayoría es pescado, pollo, vegetales.",
    },
    "tlv-cafelix": {
      id: "tlv-cafelix",
      name: "Cafelix Florentin",
      city: "Tel Aviv",
      lat: 32.0588,
      lng: 34.7707,
      type: "food",
      icon: "☕",
      jewish: false,
      cuisine: "Café de especialidad · brunch",
      story: "El mejor café de filtro de Tel Aviv, dicen muchos. Tostadores locales, baristas serios, brunch con shakshuka y bagels. Ubicado en pleno Florentin — a 3 minutos de Herzl 62. Mesas en la calle, gente trabajando con laptops, ambiente Tel Aviv puro.",
      hours: "07:00–18:00",
      tip: "Empezar el día aquí con un filtro V60 y una shakshuka. A 3 min andando del hotel.",
      noPork: true,
    },
    "tlv-mashawsha": {
      id: "tlv-mashawsha",
      name: "Mashawsha",
      city: "Tel Aviv",
      lat: 32.0715,
      lng: 34.7726,
      type: "food",
      icon: "🥣",
      jewish: false,
      cuisine: "Hummus tradicional",
      story: "Hummusiyya en Rashi street que rivaliza con Abu Hassan en lealtad. Familiar, sin pretensiones, hummus servido tibio con un golpe de aceite de oliva, cebolla cruda, pita caliente. También sirven 'ful' (habas) y 'sabich'. Almuerzo de obreros, intelectuales y abuelos por igual.",
      hours: "Dom–Vie 09:00–17:00 · Sáb cerrado",
      tip: "Pedir 'hummus shel ha-yom' (hummus del día). Cerrado en Shabat.",
      noPork: true,
    },
    "tlv-port-sa-id": {
      id: "tlv-port-sa-id",
      name: "Port Sa'id",
      city: "Tel Aviv",
      lat: 32.0641,
      lng: 34.7745,
      type: "food",
      icon: "🍷",
      jewish: false,
      cuisine: "Mediterránea-mediooriental",
      story: "Junto a la sinagoga de la Gran Sinagoga. Mesas en la calle bajo árboles, música indie, jóvenes y locales, vino natural israelí. Cocina mezze de mercado: ensaladas de verano, pescado a la brasa, kebab de res, pan recién horneado. Uno de los lugares más auténticos para sentir el Tel Aviv contemporáneo.",
      hours: "12:00–01:00",
      reserve: "Sin reserva — llegar y esperar mesa",
      tip: "Mejor para cena. Pedir varias mezze para compartir. Vino israelí (Yarden, Recanati).",
      noPork: false,
    },

    // ===== MADRID =====
    "mad-plaza-mayor": {
      id: "mad-plaza-mayor",
      name: "Plaza Mayor",
      city: "Madrid",
      lat: 40.4155,
      lng: -3.7074,
      type: "sight",
      icon: "🏛️",
      story: "Plaza barroca de 1619, ha sido mercado, plaza de toros, escenario de autos de fe inquisitoriales y coronaciones. Hoy turística pero icónica. A 5 minutos: la Plaza de la Villa, más íntima.",
      tip: "Café en alguna terraza solo para sentarse a mirar. Las paellas de las terrazas no son recomendables — para comer, vayan a los aledaños.",
    },
    "mad-prado": {
      id: "mad-prado",
      name: "Museo del Prado",
      city: "Madrid",
      lat: 40.4138,
      lng: -3.6921,
      type: "sight",
      icon: "🎨",
      story: "Una de las pinacotecas más importantes del mundo. Velázquez (Las Meninas), Goya (las pinturas negras, los fusilamientos del 3 de mayo), El Bosco (El jardín de las delicias), El Greco. Si solo tienen una hora: Velázquez y Goya.",
      hours: "Lun–Sáb 10:00–20:00 · Dom 10:00–19:00",
      tip: "GRATIS de lunes a sábado 18:00–20:00 y domingos 17:00–19:00. Aprovechen.",
    },
    "mad-lhardy": {
      id: "mad-lhardy",
      name: "Lhardy",
      city: "Madrid",
      lat: 40.4156,
      lng: -3.7008,
      type: "food",
      icon: "🍲",
      cuisine: "Española tradicional",
      story: "Abierto en 1839, posiblemente el restaurante histórico más elegante de Madrid. Famoso por su cocido madrileño (jueves), sus croquetas, sus consomés (¡servidos en la barra de pie como en el XIX!).",
      hours: "13:00–16:00 · 20:30–23:00",
      reserve: "+34 915 21 33 85",
      menu: ["Cocido madrileño (solo jueves) — €38", "Consomé de jerez en la barra — €4", "Croquetas de la casa", "Pescado del día", "Tarta de fresa"],
      tip: "Cocido madrileño SÓLO los jueves. Reservar con días.",
      noPork: false,
      noPorkNote: "El cocido incluye chorizo, morcilla y tocino. Pueden pedir solo las verduras y carnes (vaca, gallina, hueso). Otras opciones del menú sin cerdo: pescados, ternera, croquetas de gallina.",
    },

    // ============== MÁS BUDAPEST (restaurantes alternativos + cafés) ==============
    "bud-hungarikum": {
      id: "bud-hungarikum",
      name: "Hungarikum Bisztró",
      city: "Budapest",
      lat: 47.5037,
      lng: 19.0498,
      type: "food",
      icon: "🥘",
      cuisine: "Húngara tradicional",
      story: "Cocina húngara honesta y cantidades generosas, a dos cuadras del Parlamento. Manteles a cuadros, fotos viejas en las paredes, un acordeonista al fondo. Muy popular con visitantes — reservar es necesario.",
      hours: "11:30–23:00",
      reserve: "+36 1 797 7177 · hungarikumbisztro.hu",
      menu: ["Gulyás (sopa de gulash, no estofado) — 3.500 HUF", "Csirkepaprikás (pollo paprikash con nokedli) — 5.900 HUF", "Pörkölt de ternera (gulash 'seco' con paprika) — 6.500 HUF", "Sopa de pescado halászlé — 4.800 HUF", "Túrós csusza (pasta con queso fresco y crema)", "Somlói galuska (postre nacional, trifle de chocolate)"],
      tip: "Reservar 2–3 días antes. Llegar puntual o pierden la mesa.",
      noPork: false,
      noPorkNote: "Tienen cerdo en muchos platos, pero también ternera, pollo, ganso, pato y pescado. Pidan sin tocino si aparece como guarnición.",
    },
    "bud-frici-papa": {
      id: "bud-frici-papa",
      name: "Frici Papa Kifőzdéje",
      city: "Budapest",
      lat: 47.5025,
      lng: 19.0625,
      type: "food",
      icon: "🍲",
      cuisine: "Húngara casera · barato",
      story: "Comedor de barrio sin pretensiones — ni decoración, ni música, ni reservas. Solo comida húngara casera abundante a precios de hace 20 años. Sirven a obreros, jubilados y a algún turista que se atreve. Carta con 50+ platos por menos de €8.",
      hours: "Lun–Sáb 11:00–22:30",
      menu: ["Sopa de gulash — 1.490 HUF (€3.70)", "Pörkölt de pollo con nokedli — 2.490 HUF", "Csirkepaprikás — 2.490 HUF", "Schnitzel de pavo — 2.690 HUF", "Töltött káposzta (col rellena) — 2.290 HUF", "Palacsinta dulce (crepe) — 990 HUF"],
      tip: "Sin reserva, hay que esperar mesa pero rota rápido. Cash o tarjeta. Pidan en inglés básico, el mesero anota en su libreta como hace 40 años.",
      noPork: false,
      noPorkNote: "Hay cerdo en muchos platos pero el pollo, ternera y pavo abundan. Pregunten 'pork?' antes de pedir.",
    },
    "bud-karavan": {
      id: "bud-karavan",
      name: "Karaván Street Food",
      city: "Budapest",
      lat: 47.4969,
      lng: 19.0627,
      type: "food",
      icon: "🌮",
      cuisine: "Street food · patio",
      story: "Patio al lado de Szimpla Kert con foodtrucks fijos. Lo mejor de Budapest para comer rápido y variado: lángos, hamburguesas gourmet, kebab, vegano. Mesas comunitarias, ambiente casual. Casi todo bajo €10.",
      hours: "11:00–01:00",
      menu: ["Lángos clásico (con crema agria y queso rallado) — 1.800 HUF", "Lángos con ajo, salami y queso — 2.500 HUF", "Burger Bun (artesanal) — 3.200 HUF", "Vegan Love (falafel) — 2.800 HUF"],
      tip: "Imprescindible probar lángos aquí. Pidan el clásico con tejföl (crema) y sajt (queso). Que NO les pongan kolbász (salchicha) si quieren evitar cerdo.",
      noPork: true,
    },
    "bud-mercado-central": {
      id: "bud-mercado-central",
      name: "Mercado Central (Gran Mercado)",
      nameLocal: "Nagy Vásárcsarnok",
      city: "Budapest",
      lat: 47.4868,
      lng: 19.0586,
      type: "food",
      icon: "🥖",
      story: "El mercado cubierto más grande de Budapest (1897), tejas Zsolnay de colores en la fachada y techo de hierro forjado. Planta baja: productores con paprika, salami (¡ojo cerdo!), tokaj, foie gras de ganso húngaro. Segundo piso: docena de puestos de lángos, gulash, palacsinta y kürtőskalács. Buena parada de almuerzo.",
      hours: "Lun 06:00–17:00 · Mar–Vie 06:00–18:00 · Sáb 06:00–15:00 · Dom cerrado",
      menu: ["Lángos arriba (Lángos Csemege, el mejor) — 1.500–2.500 HUF", "Kürtőskalács (chimney cake) — 1.500 HUF", "Palacsinta (crepes) — 1.000 HUF", "Paprika dulce molida (souvenir) — 1.500 HUF/100g"],
      tip: "El piso 2, lado norte: Lángos Csemege, fila pero vale la pena. Compren paprika en escamas para llevar — la diferencia con la del supermercado es enorme.",
    },
    "bud-bors": {
      id: "bud-bors",
      name: "Bors GasztroBár",
      city: "Budapest",
      lat: 47.4978,
      lng: 19.0640,
      type: "food",
      icon: "🥖",
      cuisine: "Sopas y baguettes gourmet",
      story: "Local diminuto (caben 4 personas paradas) con la mejor relación calidad-precio del Barrio Judío. Dos especialidades: sopas creativas que rotan cada semana (cherry-pollo, calabaza-naranja-jengibre) y baguettes calientes monumentales. Premio Bib Gourmand Michelin a pesar de costar €5.",
      hours: "Lun–Sáb 11:30–21:00 · Dom cerrado",
      menu: ["Sopa del día — 1.300 HUF (€3)", "Baguette 'Bombay Chicken' — 1.900 HUF", "Baguette 'Sloppy Joe' — 1.900 HUF", "Baguette del mes (rota)"],
      tip: "Sin mesas adentro — la mayoría come parado en la calle o lo llevan al parque. Llegar 12:30 para evitar fila.",
      noPork: false,
      noPorkNote: "Algunas baguettes llevan cerdo. Pregunten antes — siempre hay opciones de pollo, res o vegetariano.",
    },
    "bud-new-york-cafe": {
      id: "bud-new-york-cafe",
      name: "New York Café",
      city: "Budapest",
      lat: 47.4969,
      lng: 19.0764,
      type: "food",
      icon: "☕",
      cuisine: "Café histórico · postres",
      story: "Considerado por muchas guías 'el café más bello del mundo'. Abierto en 1894 en un palacio neobarroco, frescos en el techo, lámparas de cristal y mármoles. En sus mesas escribieron Molnár, Ady, Karinthy. Cerró con el comunismo, reabrió en 2006 tras restauración millonaria. Muy turístico, sí, pero al menos un café aquí es obligatorio.",
      hours: "08:00–24:00",
      reserve: "Reservas online: newyorkcafe.hu",
      menu: ["Café vienés — 2.500 HUF", "Dobos torta (especialidad de la casa) — 4.200 HUF", "Eszterházy torta — 4.200 HUF", "Desayuno New York (eggs benedict, salmón, espumante) — 12.500 HUF", "Pasta y platos principales — 8.000–18.000 HUF"],
      tip: "Caro pero el espacio vale. Si solo quieren el efecto, pidan café+postre (que igual cuesta como un almuerzo). Reservar online o esperar fila.",
      noPork: true,
      noPorkNote: "Carta amplia sin necesidad de cerdo.",
    },
    "bud-gerbeaud": {
      id: "bud-gerbeaud",
      name: "Café Gerbeaud",
      city: "Budapest",
      lat: 47.4983,
      lng: 19.0537,
      type: "food",
      icon: "🍰",
      cuisine: "Café histórico · pastelería",
      story: "Pastelería abierta en 1858 por el suizo Henrik Kugler, comprada en 1884 por Emil Gerbeaud quien la convirtió en lugar de culto. Aquí se inventaron varios postres clásicos húngaros: el konyakos meggy (chocolate relleno de licor y cereza ácida) y el Gerbeaud-szelet (capas de masa con nuez y mermelada de damasco). Salones imperiales en mármol y caoba, plaza Vörösmarty afuera.",
      hours: "09:00–21:00",
      menu: ["Dobos torta — 2.400 HUF", "Gerbeaud-szelet — 1.800 HUF", "Esterházy — 2.400 HUF", "Strudel de manzana (rétes) — 1.800 HUF", "Café espresso — 1.200 HUF"],
      tip: "Más relajado y menos pretencioso que New York Café. La tarta Gerbeaud es la prueba mandatoria.",
      noPork: true,
    },
    "bud-central": {
      id: "bud-central",
      name: "Centrál Kávéház",
      city: "Budapest",
      lat: 47.4915,
      lng: 19.0581,
      type: "food",
      icon: "☕",
      cuisine: "Café histórico · almuerzos",
      story: "Café literario de 1887, sin la pompa de New York Café pero con un alma más auténtica. Mesas de mármol, sillas Thonet de bambú, pisos de madera crujientes. Aquí leían su periódico Ferenc Molnár, Sándor Márai, Sándor Petőfi. Sirven también almuerzos serios — no solo postres.",
      hours: "08:00–23:00",
      menu: ["Sopa de gulash — 2.800 HUF", "Csirkepaprikás — 5.400 HUF", "Strudel — 1.900 HUF", "Café con krémes (milhojas húngaras) — 3.500 HUF"],
      tip: "Buena alternativa al New York. Más barato, más auténtico, mejor ambiente.",
      noPork: true,
    },
    "bud-mazel-bonus-borkonyha": {
      id: "bud-mazel-bonus-borkonyha",
      name: "Borkonyha Winekitchen",
      city: "Budapest",
      lat: 47.5005,
      lng: 19.0518,
      type: "food",
      icon: "🍷",
      cuisine: "Húngara contemporánea · Michelin ★",
      story: "Una estrella Michelin desde 2014. Concepto: cocina húngara moderna anclada en los vinos del país (Tokaj, Eger, Villány). El chef Ákos Sárközi reinterpreta clásicos con técnica francesa. Menú degustación o a la carta. Ambiente íntimo, sin exceso de formalidad.",
      hours: "Lun–Sáb 12:00–14:30 y 18:00–24:00",
      reserve: "+36 1 266 0835 · borkonyha.hu",
      menu: ["Menú degustación 7 pasos — 39.000 HUF (€95)", "Foie gras de ganso con tokaj", "Mangalica (cerdo húngaro — ojo) o ternera de Hungría", "Catfish del Tisza con paprika", "Eszterházy reinterpretado"],
      tip: "Reservar con 2 semanas. Avisar 'no pork' al reservar y al pedir — el mangalica (cerdo) es el plato estrella de la carta.",
      noPork: false,
      noPorkNote: "El mangalica (cerdo húngaro de pelo rizado) es famoso aquí. Pero hay platos de pato, ganso, ternera y pescado equivalentes — solo avisar.",
    },
    "bud-kehli": {
      id: "bud-kehli",
      name: "Kéhli Vendéglő",
      city: "Budapest",
      lat: 47.5360,
      lng: 19.0507,
      type: "food",
      icon: "🥘",
      cuisine: "Húngara clásica · histórica",
      story: "Restaurante familiar desde 1899, en el barrio de Óbuda (la 'vieja Buda'). El escritor Gyula Krúdy comía aquí casi a diario y le dedicó relatos. Cocina húngara de la vieja escuela: huesos con tuétano, perdiz, ganso, somlói galuska. Gypsy music en vivo casi todas las noches.",
      hours: "12:00–24:00",
      reserve: "+36 1 368 0613 · kehli.hu",
      menu: ["Velőscsont (tuétano de res con pan tostado y ajo) — 4.200 HUF, plato icónico", "Sopa Újházy (sopa de gallina) — 3.800 HUF", "Pierna de ganso con col morada — 7.900 HUF", "Sólet (cholent húngaro con ganso) — 5.900 HUF", "Somlói galuska — 2.500 HUF"],
      tip: "Algo lejos del centro (taxi 15 min, ~5.000 HUF) pero vale el viaje. Pidan el sólet — es la versión húngara del cholent judío, perfectamente apropiado para Alan y Carolina.",
      noPork: false,
      noPorkNote: "Hay platos con cerdo. El ganso, la perdiz, el tuétano de res, la sopa de gallina y el sólet — todos sin cerdo.",
    },
    "bud-dobrumba": {
      id: "bud-dobrumba",
      name: "Dobrumba",
      city: "Budapest",
      lat: 47.4980,
      lng: 19.0610,
      type: "food",
      icon: "🥙",
      cuisine: "Mediterránea · Medio Oriente",
      story: "Vecino de Mazel Tov, cocina de Levante y Magreb: hummus, baba ganush, tagines, kebabs marroquíes, ensaladas. Decoración cálida con azulejos pintados. Una buena alternativa si Mazel Tov está lleno (lo está, casi siempre).",
      hours: "12:00–24:00",
      menu: ["Mezze platter para 2 — 6.900 HUF", "Hummus con cordero confitado — 3.500 HUF", "Tagine de pollo con limón en conserva — 5.500 HUF", "Sabich (sandwich israelí con berenjena, huevo, amba)", "Kunafa de postre — 2.300 HUF"],
      tip: "Reservar el fin de semana. Pidan los pasteles árabes de postre — los hacen ellos.",
      noPork: true,
    },
    "bud-gelarto": {
      id: "bud-gelarto",
      name: "Gelarto Rosa",
      city: "Budapest",
      lat: 47.5009,
      lng: 19.0542,
      type: "food",
      icon: "🌹",
      cuisine: "Helados artesanales",
      story: "Helado en forma de rosa. Sí, suena cursi pero la técnica es impresionante: el heladero forma pétalo por pétalo sobre el cono, en 4–5 sabores combinados. Famosos por sus sabores únicos: lavanda, tokaji, halva, pistacho siciliano. Frente a la Basílica de San Esteban.",
      hours: "10:00–22:00",
      menu: ["Helado-rosa 3 sabores — 1.800 HUF", "5 sabores — 2.400 HUF", "Combinaciones del día"],
      tip: "Fila siempre. Vale 15 min. Pidan tokaji + chocolate negro + pistacho — la combinación clásica.",
    },

    // ============== MÁS PRAGA (alternativos + cafés) ==============
    "prg-pinkasu": {
      id: "prg-pinkasu",
      name: "U Pinkasů",
      city: "Praga",
      lat: 50.0833,
      lng: 14.4222,
      type: "food",
      icon: "🍺",
      cuisine: "Cervecería histórica",
      story: "En 1843, Jakub Pinkas fue el primero en traer la Pilsner Urquell desde Plzeň a Praga. Su taberna sigue abierta en el mismo lugar, sirviendo la misma cerveza. Cocina checa básica y honesta. Patio interior con tilos.",
      hours: "10:00–24:00",
      menu: ["Pilsner Urquell de tanque 0,5L — 79 CZK", "Goulash de res con knedlíky — 269 CZK", "Svíčková (lomo en crema con knedlíky y arándanos) — 289 CZK", "Smažený sýr (queso frito con papas) — 199 CZK", "Tatarák de res — 269 CZK"],
      tip: "Pedir 'pivo z tanku' (cerveza de tanque). Si almuerzan, prueben svíčková — el plato nacional checo.",
      noPork: false,
      noPorkNote: "Hay cerdo en algunos platos. Svíčková (lomo de res), goulash de res, schnitzel de pollo, queso frito — todos sin cerdo.",
    },
    "prg-mincovna": {
      id: "prg-mincovna",
      name: "Restaurace Mincovna",
      city: "Praga",
      lat: 50.0875,
      lng: 14.4218,
      type: "food",
      icon: "🍲",
      cuisine: "Checa moderna · vista plaza",
      story: "Asomada a la Plaza de la Ciudad Vieja, en un edificio donde estuvo la Casa de la Moneda real (de ahí el nombre). Cocina checa contemporánea, mejor calidad que la mayoría de restaurantes turísticos de la plaza. Cervezas locales de microcervecerías además de Pilsner.",
      hours: "11:00–23:00",
      reserve: "+420 602 727 232 · mincovna.cz",
      menu: ["Svíčková de la abuela Marie — 365 CZK", "Goulash de res con knedlíky — 345 CZK", "Carpaccio de res checa — 295 CZK", "Trucha al horno — 425 CZK", "Větrník de postre (choux con crema y caramelo) — 145 CZK"],
      tip: "Reservar mesa con vista a la plaza. Pidan el větrník — postre checo clásico.",
      noPork: false,
      noPorkNote: "Tienen vepřo-knedlo-zelo (cerdo, plato nacional). Alternativas: svíčková, ternera, pescado, pato.",
    },
    "prg-cafe-imperial": {
      id: "prg-cafe-imperial",
      name: "Café Imperial",
      city: "Praga",
      lat: 50.0884,
      lng: 14.4302,
      type: "food",
      icon: "☕",
      cuisine: "Café Art Nouveau · desayunos",
      story: "Abierto en 1914 en el Hotel Imperial. Paredes y techo cubiertos enteros de azulejos de cerámica pintados — único en el mundo. Café favorito de Karel Čapek y Franz Kafka. Hoy famoso por su desayuno (servido hasta las 11:00) y por sus tortas.",
      hours: "07:00–23:00",
      menu: ["Desayuno Imperial (eggs benedict, salmón, panes, jugo, café) — 480 CZK", "Větrník — 165 CZK", "Medovník (torta de miel checa) — 145 CZK", "Goulash al mediodía — 320 CZK"],
      tip: "Desayuno largo aquí una mañana. Mejor entre semana — los fines de semana se llena.",
      noPork: true,
    },
    "prg-cafe-savoy": {
      id: "prg-cafe-savoy",
      name: "Café Savoy",
      city: "Praga",
      lat: 50.0801,
      lng: 14.4051,
      type: "food",
      icon: "🥐",
      cuisine: "Café histórico · desayunos · pastelería",
      story: "Abierto en 1893 en Mala Strana, con un techo neo-renacentista pintado con escenas alegóricas (uno de los más bellos de Europa). Pastelería propia premiada, panadería excelente. Carlos IV y Václav Havel comieron aquí. Desayunos legendarios.",
      hours: "08:00–22:30",
      reserve: "+420 731 136 144 · cafesavoy.ambi.cz",
      menu: ["Desayuno Savoy (huevos a la flamenca, jamón ibérico — pedir alternativa, panes propios) — 395 CZK", "Tarta savoyita — 165 CZK", "Bagel con salmón — 285 CZK", "Croissant de almendras — 95 CZK"],
      tip: "Reservar el desayuno — uno de los mejores de Praga. Pidan el bagel con salmón ahumado y los pasteles propios.",
      noPork: false,
      noPorkNote: "Algunos platos del desayuno llevan jamón. Pedir alternativa: salmón, queso, huevos.",
    },
    "prg-slavia": {
      id: "prg-slavia",
      name: "Café Slavia",
      city: "Praga",
      lat: 50.0813,
      lng: 14.4136,
      type: "food",
      icon: "☕",
      cuisine: "Café literario",
      story: "Frente al Teatro Nacional, abierto 1884. Aquí planearon la Revolución de Terciopelo escritores como Václav Havel y Jiří Kolář, en torno a un cuadro famoso ('El bebedor de absenta' de Viktor Oliva, todavía cuelga). Vista al Vltava y al Castillo.",
      hours: "08:00–24:00",
      menu: ["Absenta servida a la antigua (con cuchara y azúcar) — 180 CZK", "Sopa de ajo (česnečka) — 95 CZK", "Smažený sýr con papas — 195 CZK", "Strudel de manzana — 95 CZK"],
      tip: "Pedir mesa frente a la ventana — vista del castillo y el río. Café+postre alcanza para vivir el momento.",
      noPork: true,
    },
    "prg-obecni-dum": {
      id: "prg-obecni-dum",
      name: "Kavárna Obecní Dům",
      city: "Praga",
      lat: 50.0879,
      lng: 14.4283,
      type: "food",
      icon: "🍰",
      cuisine: "Café Art Nouveau",
      story: "Dentro de la Casa Municipal (Obecní dům, 1912) — el edificio Art Nouveau más espectacular de Praga, donde se declaró la independencia checoslovaca en 1918. El café tiene lámparas de cristal monumentales, paneles de madera dorados, frescos. Una visita arquitectónica además de gastronómica.",
      hours: "07:30–23:00",
      menu: ["Café con tarta de almendra — 220 CZK", "Almuerzo del día — 320 CZK", "Tarta praguense (Pražský dort, chocolate + nueces) — 165 CZK"],
      tip: "Después o antes, asomarse al hall principal del edificio (Sala Smetana) — gratis si no hay concierto.",
      noPork: true,
    },
    "prg-orient": {
      id: "prg-orient",
      name: "Grand Café Orient",
      city: "Praga",
      lat: 50.0877,
      lng: 14.4262,
      type: "food",
      icon: "📐",
      cuisine: "Café Cubista único",
      story: "El único café cubista del mundo. Dentro de la Casa de la Virgen Negra (Josef Gočár, 1912) — un edificio cubista checo, movimiento arquitectónico único en Praga. Lámparas, sillas, tazas: todo geométrico, anguloso. Reabierto en 2005 tras 80 años cerrado.",
      hours: "Mar–Vie 09:00–22:00 · Sáb–Dom 10:00–22:00 · Lun cerrado",
      menu: ["Café espresso — 65 CZK", "Tarta de manzana cubista — 145 CZK", "Quiche del día — 195 CZK"],
      tip: "Subir el segundo piso (escalera cubista impresionante). Visitar también el Museo de Cubismo en el mismo edificio.",
      noPork: true,
    },
    "prg-field": {
      id: "prg-field",
      name: "Field Restaurant",
      city: "Praga",
      lat: 50.0905,
      lng: 14.4242,
      type: "food",
      icon: "🌿",
      cuisine: "Contemporánea · Michelin ★",
      story: "Una estrella Michelin. Cocina hiper-local: lo que crece en el campo checo, lo que sale del bosque. Hierbas silvestres, raíces, carnes de granja, ahumados propios. Menú degustación es la vía principal. Comedor pequeño y luminoso, sin afectación.",
      hours: "Mar–Sáb 12:00–14:00 y 18:00–22:30",
      reserve: "+420 222 316 999 · fieldrestaurant.cz",
      menu: ["Menú degustación 6 pasos — 2.950 CZK (~€118)", "Menú degustación 9 pasos — 3.950 CZK", "Maridaje de vinos opcional"],
      tip: "Reservar con 2–4 semanas. Avisar 'no pork' — adaptan sin problema. Vale como cena especial.",
      noPork: false,
      noPorkNote: "Menú estacional, a veces hay cerdo en algún paso. Avisar al reservar.",
    },
    "prg-dinitz": {
      id: "prg-dinitz",
      name: "Dinitz Kosher Restaurant",
      city: "Praga",
      lat: 50.0901,
      lng: 14.4209,
      type: "food",
      icon: "🕎",
      jewish: true,
      cuisine: "Kosher · israelí",
      story: "Restaurante kosher (mehadrin) en pleno barrio judío, supervisado por el rabinato de Praga. Cocina israelí-mediterránea: shawarma, kebabs, hummus, shakshuka, ensaladas. No esperan que ustedes coman kosher — solo es un lugar agradable y auténtico para una comida judía completa.",
      hours: "Dom–Jue 11:30–23:00 · Vie 11:30–14:00 (antes de Shabat) · Sáb cierra hasta atardecer",
      reserve: "+420 222 244 000 · dinitz.cz",
      menu: ["Hummus con falafel — 280 CZK", "Shawarma plate — 420 CZK", "Kebab mixto — 480 CZK", "Shakshuka — 295 CZK", "Knafeh — 195 CZK"],
      tip: "Cierra para Shabat el viernes a las 14:00 y reabre el sábado al anochecer (~21:00 en junio). Reservar la noche del sábado si quieren cenar.",
      noPork: true,
    },
    "prg-king-solomon": {
      id: "prg-king-solomon",
      name: "King Solomon Restaurant",
      city: "Praga",
      lat: 50.0894,
      lng: 14.4186,
      type: "food",
      icon: "🕎",
      jewish: true,
      cuisine: "Kosher · ashkenazi",
      story: "El kosher 'serio' de Praga (supervisión rabínica estricta). Cocina ashkenazi: pescado gefilte, sopa de pollo con kneidlach, brisket, latkes, tzimes. Vinos kosher israelíes y europeos. Más formal y caro que Dinitz.",
      hours: "Dom–Jue 12:00–22:30 · Vie 12:00–14:00 (cierra para Shabat) · Sáb noche tras atardecer",
      reserve: "+420 224 818 752 · kosher.cz",
      menu: ["Sopa de pollo con kneidlach — 195 CZK", "Gefilte fish — 295 CZK", "Brisket de res con tzimes — 595 CZK", "Latkes — 195 CZK", "Postres caseros"],
      tip: "Reservar el sábado por la noche con días — limitan cupos. Para una comida judía emotiva y completa.",
      noPork: true,
    },
    "prg-myšák": {
      id: "prg-myšák",
      name: "Cukrárna Myšák",
      city: "Praga",
      lat: 50.0820,
      lng: 14.4221,
      type: "food",
      icon: "🧁",
      cuisine: "Pastelería histórica",
      story: "La pastelería más famosa de Praga, abierta en 1904. Inventaron la fórmula del věnečnek (donut rey) y son la referencia del větrník (el choux relleno de crema vainilla con techo de caramelo, postre nacional checo). Salón restaurado a su esplendor de los años 20.",
      hours: "10:00–20:00",
      menu: ["Větrník — 89 CZK", "Věneček (donut con glaseado) — 79 CZK", "Medovník — 95 CZK", "Rakvička (ataúd, postre con merengue) — 79 CZK", "Café — 75 CZK"],
      tip: "Si solo prueban un postre checo, que sea el větrník de Myšák. Comprar uno para llevar y comerlo en el banco de la plaza.",
    },
    "prg-manifesto": {
      id: "prg-manifesto",
      name: "Manifesto Market Anděl",
      city: "Praga",
      lat: 50.0710,
      lng: 14.4032,
      type: "food",
      icon: "🍴",
      cuisine: "Food hall · variado",
      story: "Mercado gastronómico al aire libre, 20+ puestos: ramen, smashburgers, vietnamita, italiano, vegano, mexicano. Música DJ los fines de semana, fogatas en invierno, sombrillas en verano. Ambiente casual y joven.",
      hours: "Lun–Jue 11:30–23:00 · Vie–Sáb 11:30–24:00 · Dom 11:30–22:00",
      tip: "Para una cena distinta de la checa-checa-checa. Buen plan si están cansados de knedlíky.",
    },

    // ============== MÁS BUDAPEST (restaurantes alternativos + cafés) ==============
    "bud-carmel": {
      id: "bud-carmel",
      name: "Carmel Pince",
      city: "Budapest",
      lat: 47.4956,
      lng: 19.0621,
      type: "food",
      icon: "🕎",
      jewish: true,
      cuisine: "Kosher · judía-húngara",
      story: "Restaurante kosher (supervisión rabínica) en el Barrio Judío desde 1992. Cocina ashkenazi clásica adaptada a la tradición húngara. Pince significa 'bodega' — el comedor está bajo nivel de calle. Vinos kosher de Israel y Hungría. Cierra para Shabat.",
      hours: "Dom–Jue 12:00–23:00 · Vie 12:00–14:00 · Sáb cierra todo el día",
      reserve: "+36 1 322 1834 · carmel.hu",
      menu: ["Sopa de pollo con kneidlach — 2.500 HUF", "Gefilte fish — 3.500 HUF", "Hígado picado a la judía — 2.900 HUF", "Sólet con ganso — 5.900 HUF", "Pierna de pavo asado — 5.500 HUF", "Strudel de manzana — 1.900 HUF"],
      tip: "Reservar siempre el domingo (después de Shabat — más demanda). Pidan el sólet del viernes (preparado durante 24h, servido domingo).",
      noPork: true,
    },
    "bud-macesz-huszar": {
      id: "bud-macesz-huszar",
      name: "Macesz Huszár",
      city: "Budapest",
      lat: 47.4975,
      lng: 19.0639,
      type: "food",
      icon: "✡️",
      jewish: true,
      cuisine: "Judía-húngara contemporánea",
      story: "'Macesz' es matzá en húngaro. Cocina judía-húngara modernizada en el corazón del Barrio Judío. No kosher estricto, pero sin cerdo y con respeto a la tradición. El nombre es un guiño al regimiento Huszár (los húsares, caballería ligera húngara) — donde judíos sirvieron a la corona durante el imperio. Buen ambiente, copa de vino tokaj.",
      hours: "12:00–23:00",
      reserve: "+36 1 787 6164 · maceszhuszar.com",
      menu: ["Sopa de pollo con flódni de huevo — 2.400 HUF", "Hígado picado con cebolla caramelizada — 2.900 HUF", "Sólet de ganso con huevo cocido — 5.500 HUF", "Pollo asado con relleno judío-húngaro — 5.900 HUF", "Flódni (postre judío-húngaro de manzana, nuez, amapola) — 2.200 HUF"],
      tip: "Pidan el flódni — postre judío-húngaro icónico, capas de manzana, nuez molida y semillas de amapola. Solo lo hacen aquí y en Rosenstein.",
      noPork: true,
    },
    "bud-koleves": {
      id: "bud-koleves",
      name: "Köleves Vendéglő",
      city: "Budapest",
      lat: 47.4974,
      lng: 19.0626,
      type: "food",
      icon: "🍲",
      cuisine: "Húngara contemporánea · judía",
      story: "Bistró bohemio en plena Kazinczy. Cocina húngara con mucha verdura, opciones vegetarianas serias (raras en Hungría), guiños judíos y libaneses. Patio interior con luces colgadas, ambiente relajado y multigeneracional. Buen brunch los domingos.",
      hours: "Lun–Vie 12:00–24:00 · Sáb–Dom 10:00–24:00",
      reserve: "+36 20 213 5999 · koleves.com",
      menu: ["Hummus con shakshuka — 2.500 HUF", "Sopa fría de pepino y eneldo — 1.900 HUF", "Pollo paprikash con nokedli — 4.200 HUF", "Hamburguesa de cordero con queso feta — 4.900 HUF", "Strudel de cerezas ácidas — 1.800 HUF"],
      tip: "Brunch los domingos 10–14h, mezcla húngaro-israelí, ~5.500 HUF por persona. Reservar.",
      noPork: true,
    },
    "bud-cafe-kor": {
      id: "bud-cafe-kor",
      name: "Café Kör",
      city: "Budapest",
      lat: 47.5003,
      lng: 19.0529,
      type: "food",
      icon: "🍷",
      cuisine: "Húngara-mediterránea · bistró",
      story: "Bistró de barrio cerca de la Basílica desde 1996. Clientela mitad locales, mitad viajeros que vienen recomendados. Cocina honesta, atención cuidadosa. Buena carta de vinos húngaros. Sin reservas — llegar 12:30 al almuerzo o esperar.",
      hours: "Lun–Sáb 10:00–22:30 · Dom cerrado",
      reserve: "No acepta reservas",
      menu: ["Sopa del día — 2.200 HUF", "Hígado de pollo a la cebolla — 4.500 HUF", "Goulash de res clásico — 4.900 HUF", "Trucha asada de la región — 5.900 HUF", "Crepes (palacsinta) Gundel — 2.500 HUF"],
      tip: "Los palacsinta Gundel (crepes con nuez, ron y chocolate flameados) — postre nacional. Una porción alcanza para dos.",
      noPork: false,
      noPorkNote: "Hay algún plato con cerdo. Hígado de pollo, goulash de res, trucha — sin problema.",
    },

    // ============== MÁS PRAGA ==============
    "prg-shelanu": {
      id: "prg-shelanu",
      name: "Shelanu Bistro",
      city: "Praga",
      lat: 50.0907,
      lng: 14.4193,
      type: "food",
      icon: "🥗",
      jewish: true,
      cuisine: "Kosher dairy · israelí mediterránea",
      story: "Bistró kosher dairy (lácteos, sin carne) en el Barrio Judío. Cocina israelí moderna: hummus, shakshuka, ensaladas de quinoa, sandwich de halloumi, postres con tahina. Ambiente joven, music israelí de fondo. Cierra Shabat.",
      hours: "Dom–Jue 11:00–22:00 · Vie 11:00–14:00 · Sáb noche tras atardecer",
      reserve: "+420 222 312 110 · shelanu.cz",
      menu: ["Hummus con tahina y huevo cocido — 240 CZK", "Shakshuka individual — 295 CZK", "Bowl de quinoa con halloumi — 320 CZK", "Sabich (berenjena, huevo, amba) — 280 CZK", "Knafeh — 195 CZK"],
      tip: "Buena opción del almuerzo si están cerca del barrio judío y quieren algo liviano y sano.",
      noPork: true,
    },
    "prg-hergetova": {
      id: "prg-hergetova",
      name: "Hergetova Cihelna",
      city: "Praga",
      lat: 50.0876,
      lng: 14.4087,
      type: "food",
      icon: "🌉",
      cuisine: "Internacional · vista del Puente Carlos",
      story: "Restaurante en una antigua fábrica de ladrillos del siglo XVII, justo al pie del Puente Carlos. Terraza sobre el Vltava con vista directa al puente y al Castillo. Cocina internacional con buena ejecución, no la mejor pero la vista compensa. Ideal para una cena con encanto.",
      hours: "11:30–23:00",
      reserve: "+420 296 826 103 · cihelna.com",
      menu: ["Carpaccio de res — 395 CZK", "Risotto de hongos — 425 CZK", "Lomo de ciervo con frutos rojos — 695 CZK", "Pasta del día — 365 CZK", "Postres del día"],
      tip: "Reservar mesa en la terraza. Atardecer entre 20:45 y 21:30 en junio — pedir hora para esos minutos. Puede ser caro pero la vista vale.",
      noPork: false,
      noPorkNote: "Algunos platos con cerdo. Pescados, res, ciervo, pasta — todos sin cerdo.",
    },
    "prg-la-degustation": {
      id: "prg-la-degustation",
      name: "La Degustation Bohême Bourgeoise",
      city: "Praga",
      lat: 50.0915,
      lng: 14.4250,
      type: "food",
      icon: "⭐",
      cuisine: "Checa de autor · Michelin ★",
      story: "Una estrella Michelin desde 2012. Cocina basada en recetas burguesas checas de los siglos XIX y XX, recuperadas de un libro de cocina de 1894 ('Domácí kuchařka' de Magdalena Dobromila Rettigová). Menú degustación es la única opción. Comedor minimalista, atención impecable, vinos checos boutique.",
      hours: "Mar–Sáb 18:00–23:00",
      reserve: "+420 222 311 234 · ladegustation.cz",
      menu: ["Menú 7 pasos — 3.450 CZK (~€140)", "Maridaje vinos checos — +2.000 CZK", "Vegetariano disponible"],
      tip: "Reservar 3–4 semanas. Avisar 'no pork' al reservar — adaptan el menú. Una experiencia para cerrar el viaje.",
      noPork: false,
      noPorkNote: "Algún paso puede llevar cerdo (la cocina checa antigua lo usaba mucho). Avisar al reservar — flexibles.",
    },
    "prg-sansho": {
      id: "prg-sansho",
      name: "Sansho",
      city: "Praga",
      lat: 50.0902,
      lng: 14.4350,
      type: "food",
      icon: "🌶️",
      cuisine: "Asiática creativa · Karlín",
      story: "Restaurante asiático del chef Paul Day (británico, vivió en China). Cocina vietnamita-china-tailandesa con buenos productos checos: pato, cerdo de cuello (ojo), pescado del Vltava. Para tomar un break de la cocina checa-checa-checa.",
      hours: "Lun–Vie 12:00–14:30 y 18:00–22:30 · Sáb 18:00–22:30 · Dom cerrado",
      reserve: "+420 222 317 425 · sansho.cz",
      menu: ["Almuerzo express 3 platos — 390 CZK", "Pato laqueado a la pequinesa — 595 CZK", "Pho de res checa — 295 CZK", "Bao de pollo crocante — 240 CZK"],
      tip: "Almuerzo de mediodía con muy buena relación calidad-precio. Pedir el pho.",
      noPork: false,
      noPorkNote: "Hay cerdo en algunos platos. Pato, res, pollo, pescado — alternativas suficientes.",
    },
    "prg-bombay-express": {
      id: "prg-bombay-express",
      name: "Bombay Express",
      city: "Praga",
      lat: 50.0900,
      lng: 14.4218,
      type: "food",
      icon: "🍛",
      cuisine: "India auténtica · barato y rico",
      story: "Pequeño local indio en plena Pařížská (calle judía-burguesa). Cocina india del norte (Punjab) preparada por familia india. Sin pretensiones — luz fría, mesas simples — pero comida potente. Naan fresco del tandoor. Plan B para una noche sin carne ni cerdo.",
      hours: "11:00–23:00",
      menu: ["Butter chicken — 280 CZK", "Palak paneer (espinaca + queso) — 245 CZK", "Lamb biryani — 320 CZK", "Naan al ajo — 65 CZK", "Lassi de mango — 95 CZK"],
      tip: "Pedir picante 'medium' para empezar — preparan picante de verdad. Vegetariano excelente.",
      noPork: true,
    },

    // ============== TEL AVIV ==============
    "tlv-neve-tzedek": {
      id: "tlv-neve-tzedek",
      name: "Neve Tzedek",
      nameLocal: "נוה צדק",
      city: "Tel Aviv",
      lat: 32.0608,
      lng: 34.7660,
      type: "sight",
      icon: "🏘️",
      story: "El primer barrio judío fuera de las murallas de Jaffa, fundado en 1887 — 22 años antes que Tel Aviv. Calles estrechas, casas bajas de finales del XIX restauradas, boutiques de diseñadores israelíes, librerías, cafés. La calle Shabazi es el corazón. Caminar sin rumbo, no hay forma de perderse.",
      tip: "Imprescindible al atardecer. A 8 minutos a pie del depto de Herzl 62.",
    },
    "tlv-rothschild": {
      id: "tlv-rothschild",
      name: "Boulevard Rothschild · Ciudad Blanca (UNESCO)",
      nameLocal: "שדרות רוטשילד",
      city: "Tel Aviv",
      lat: 32.0640,
      lng: 34.7740,
      type: "sight",
      icon: "🏛️",
      story: "El paseo más icónico de Tel Aviv. A ambos lados: arquitectura Bauhaus — 4.000 edificios entre 1933 y 1948 cuando los arquitectos judíos europeos huyeron del nazismo y reinventaron el racionalismo bajo el sol mediterráneo. Patrimonio UNESCO 2003. El bulevar tiene su parque central con kioscos, bicicleteros, parejas, niños.",
      tip: "Caminen del nº 1 (Independence Hall) al final. Hay placas Bauhaus en los edificios mejores. En Rothschild 16 está la Sala donde Ben Gurion declaró el Estado de Israel el 14 mayo 1948 — visitable.",
    },
    "tlv-independence-hall": {
      id: "tlv-independence-hall",
      name: "Casa de la Independencia",
      nameLocal: "בית העצמאות",
      city: "Tel Aviv",
      lat: 32.0640,
      lng: 34.7720,
      type: "sight",
      icon: "🇮🇱",
      jewish: true,
      story: "Rothschild 16, la casa que fue del primer alcalde de Tel Aviv, Meir Dizengoff. El 14 de mayo de 1948, a las 16:00, David Ben Gurion leyó aquí la declaración de independencia del Estado de Israel. La sala se conserva exactamente como ese día. Reabierta en 2023 tras restauración masiva.",
      hours: "Dom–Jue 09:00–17:00 · Vie 09:00–14:00 · Sáb cerrado",
      tip: "Entrada con ticket (~40 NIS). Reservar online: ihi.org.il. Tour guiado de 50 min — emotivo.",
    },
    "tlv-jaffa": {
      id: "tlv-jaffa",
      name: "Jaffa Antigua",
      nameLocal: "יפו",
      city: "Tel Aviv",
      lat: 32.0540,
      lng: 34.7510,
      type: "sight",
      icon: "🌅",
      story: "Una de las ciudades portuarias más antiguas del mundo (4.000+ años). Aquí desembarcó Jonás (según la Biblia), Pedro resucitó a Tabitha, Napoleón sitió la ciudad. El barrio antiguo es una colina de piedra clara, callejones empinados, talleres de artistas. El reloj otomano marca la entrada. Atardecer en el mirador frente al mar — postal absoluta.",
      tip: "Caminar desde Florentin (18 min) o tomar bici eléctrica por el malecón. El mercado de pulgas (Shuk HaPishpeshim) abre Dom–Jue 10:00–18:00, Vie hasta 14:00 — perfecto para vintage y curiosidades.",
    },
    "tlv-carmel-market": {
      id: "tlv-carmel-market",
      name: "Mercado del Carmelo",
      nameLocal: "שוק הכרמל / Shuk HaCarmel",
      city: "Tel Aviv",
      lat: 32.0680,
      lng: 34.7691,
      type: "sight",
      icon: "🛍️",
      story: "El mercado más grande y caótico de Tel Aviv. Una avenida peatonal larga, gritos de vendedores, frutas, especias, baklava, pita recién horneada, halva, dátiles, aceitunas, restaurantes ocultos entre los puestos. El olfato decide qué probar.",
      hours: "Dom–Jue 08:00–19:00 · Vie 08:00–15:00 · Sáb cerrado (Shabat)",
      tip: "Ir con hambre. Probar: borekas en el horno turco, halva en el puesto Halva Kingdom, jugo de pomelo recién exprimido, frutos secos a granel, baklava libanesa. Para almuerzo, métanse al patio escondido de M25 (mercado del carnicero) — sólo para iniciados.",
    },
    "tlv-levinsky-market": {
      id: "tlv-levinsky-market",
      name: "Mercado Levinsky",
      nameLocal: "שוק לוינסקי",
      city: "Tel Aviv",
      lat: 32.0610,
      lng: 34.7720,
      type: "sight",
      icon: "🌶️",
      story: "El mercado de especias de Tel Aviv, fundado por judíos balcánicos (búlgaros, salónicos, persas). Caminar entre tiendas de cardamomo molido, especias persas, baklavas de pistacho, quesos turcos, sambusak, tachina recién prensada. A 6 min a pie del depto.",
      hours: "Dom–Jue 08:00–19:00 · Vie 08:00–14:00 · Sáb cerrado",
      tip: "Imprescindible: visita a HaSafsal (tachina molida fresca) y Stand 5 (especias). Para almorzar: Sus6 (sandwich búlgaro) o Café Levinsky (jugos curativos).",
    },
    "tlv-sarona": {
      id: "tlv-sarona",
      name: "Sarona Market & Sarona Colony",
      nameLocal: "סרונה",
      city: "Tel Aviv",
      lat: 32.0735,
      lng: 34.7860,
      type: "sight",
      icon: "🛒",
      story: "Colonia de los Templers alemanes fundada en 1871, restaurada y convertida en complejo gastronómico-comercial moderno con un mercado techado (tipo Borough de Londres). 91 puestos: pasta italiana, sushi, hummus gourmet, vinos israelíes, quesos. Plan B perfecto si hay mucho calor o lluvia.",
      hours: "Dom–Jue 08:00–22:00 · Vie 08:00–17:00 · Sáb 09:00–22:00",
      tip: "El edificio Templer alrededor tiene historia — mientras comen, asomen a los bocetos del museo (gratis).",
    },
    "tlv-bauhaus-center": {
      id: "tlv-bauhaus-center",
      name: "Bauhaus Center",
      city: "Tel Aviv",
      lat: 32.0782,
      lng: 34.7755,
      type: "sight",
      icon: "🏗️",
      story: "Centro de información sobre la Ciudad Blanca patrimonio UNESCO. Exposición permanente sobre los arquitectos europeos refugiados, los edificios emblemáticos, el racionalismo adaptado al clima israelí. Audioguías en español para hacer caminata Bauhaus propia.",
      hours: "Dom–Jue 10:00–19:30 · Vie 10:00–14:30 · Sáb 12:00–19:30",
      tip: "Si la arquitectura les interesa, alquilen el audiotour ~40 NIS y caminen Rothschild + Dizengoff. 2h.",
    },
    "tlv-anu": {
      id: "tlv-anu",
      name: "Museo ANU · Museo del Pueblo Judío",
      nameLocal: "אנו - מוזיאון העם היהודי",
      city: "Tel Aviv",
      lat: 32.1130,
      lng: 34.8048,
      type: "sight",
      icon: "🕯️",
      jewish: true,
      story: "El antes llamado Beit Hatfutsot (Museo de la Diáspora) reabrió en 2021 reinventado: tres pisos contando los 3.000 años de historia del pueblo judío en todas sus diásporas — Sefarad, Asquenaz, Mizrahí, Etiopía, Bujara, América. Inmersivo, contemporáneo, profundo. A 25 min en bici/auto del depto (en el campus de la Universidad de Tel Aviv).",
      hours: "Dom–Mié 10:00–18:00 · Jue 10:00–22:00 · Vie 10:00–14:00 · Sáb 10:00–17:00",
      tip: "Reservar tickets online: anumuseum.org.il (~52 NIS). Dedicar 3h. Audioguía en español incluida.",
    },
    "tlv-tachana": {
      id: "tlv-tachana",
      name: "HaTachana · Vieja Estación de Tren",
      nameLocal: "התחנה",
      city: "Tel Aviv",
      lat: 32.0570,
      lng: 34.7610,
      type: "sight",
      icon: "🚂",
      story: "La estación original del ferrocarril Jaffa-Jerusalem de 1892 (la primera línea de tren del Medio Oriente otomano), abandonada por décadas, ahora compound de tiendas, restaurantes, ferias artesanales. Entre Neve Tzedek y la playa.",
      hours: "Dom–Jue 10:00–22:00 · Vie 10:00–17:00 · Sáb 10:00–22:00",
      tip: "Plan ideal: paseo Neve Tzedek → HaTachana → playa al atardecer. Buen lugar para café y compras de diseñadores locales.",
    },
    "tlv-playa": {
      id: "tlv-playa",
      name: "Playa & Tayelet",
      nameLocal: "חוף ים / טיילת",
      city: "Tel Aviv",
      lat: 32.0700,
      lng: 34.7670,
      type: "sight",
      icon: "🏖️",
      story: "14 km de costa peatonal-ciclable desde el puerto norte hasta Jaffa al sur. La playa más cercana a Florentin es la Charles Clore (15 min a pie). En junio el mar está agradable (22–24°C), arena fina, atardeceres anaranjados. Matkot (raquetas), surfistas, perros sueltos en el sector dedicado.",
      tip: "Llevar agua, sombrilla (alquilan en algunas playas, ~30 NIS) y sandalias — la arena quema. Mirta del depto: caminar al sur hasta Jaffa por el malecón al atardecer = el plan más telavivense de todos.",
    },

    // ============== TEL AVIV — RESTAURANTES ==============
    "tlv-miznon": {
      id: "tlv-miznon",
      name: "Miznon",
      city: "Tel Aviv",
      lat: 32.0750,
      lng: 34.7732,
      type: "food",
      icon: "🥙",
      cuisine: "Pita gourmet · israelí callejero",
      story: "El restaurante de Eyal Shani, el chef más famoso de Israel. Pitas calientes recién horneadas, rellenas de combinaciones radicales: coliflor entero asado, ratatouille, pollo crujiente, picaña, hígado de pollo. Música a todo volumen, papel sobre la mesa, ambiente eufórico. Sin reservas, hay que ir y esperar.",
      hours: "Dom–Jue 12:00–24:00 · Vie 12:00–16:00 · Sáb noche tras Shabat",
      menu: ["Pita de coliflor entero asado — 65 NIS (icónico)", "Pita de res-picaña con tahina — 75 NIS", "Pita de berenjena ahumada — 55 NIS", "Pita de pollo crujiente — 65 NIS", "Papas asadas con romero", "Helado de cardamomo de postre"],
      tip: "La pita del coliflor es OBLIGATORIA. Pedir 2 pitas por persona para compartir. Sucursal Dizengoff es la original; también está en King George y en el puerto.",
      noPork: true,
    },
    "tlv-port-said": {
      id: "tlv-port-said",
      name: "Port Sa'id",
      city: "Tel Aviv",
      lat: 32.0703,
      lng: 34.7773,
      type: "food",
      icon: "🎵",
      cuisine: "Tapas · cocina israelí moderna",
      story: "Bar-restaurante de Eyal Shani al lado de la Gran Sinagoga (sí, ironía buscada). Tapas mediterráneas-israelíes para compartir, vinilos sonando a todo volumen, terraza siempre llena. Una institución telavivense de los últimos 10 años. No aceptan reservas.",
      hours: "12:00–01:00 todos los días",
      menu: ["Tomate seco con tahina — 45 NIS", "Pollo crocante en su grasa — 65 NIS", "Tartar de res — 75 NIS", "Hígado de pollo con cebolla y vino dulce — 55 NIS", "Sandía con queso bulgárico — 45 NIS (verano)", "Vinos naturales israelíes por copa"],
      tip: "Llegar antes de las 19:30 o esperar. Sentarse en la terraza si pueden. Pidan 5–6 platillos para 2 personas.",
      noPork: true,
    },
    "tlv-abu-hassan": {
      id: "tlv-abu-hassan",
      name: "Abu Hassan (Ali Karavan)",
      city: "Tel Aviv",
      lat: 32.0490,
      lng: 34.7530,
      type: "food",
      icon: "🥣",
      cuisine: "Hummus · Jaffa",
      story: "Considerado por muchos críticos el mejor hummus del mundo. Tres sucursales pequeñas en Jaffa, familia palestino-israelí desde 1959. Cocinan SOLO hummus, mashawasha (con garbanzos enteros), foul (habas) y un par de cosas más. Cuando se acaba el hummus del día (~14:00), cierran.",
      hours: "Dom–Vie 08:00–14:30 · Sáb cerrado",
      menu: ["Hummus puro — 25 NIS", "Mashawasha (con garbanzos enteros) — 30 NIS", "Foul (habas) — 25 NIS", "Trío de los tres — 35 NIS", "Pita ilimitada incluida", "Cebolla cruda + limón + ají al lado"],
      tip: "Ir tipo 10:30–11:00 para evitar la fila eterna (después de las 12 puede ser 45 min). El de la calle Dolphin es el original. Pedir 'tres en uno' para probar todo.",
      noPork: true,
    },
    "tlv-manta-ray": {
      id: "tlv-manta-ray",
      name: "Manta Ray",
      city: "Tel Aviv",
      lat: 32.0620,
      lng: 34.7570,
      type: "food",
      icon: "🐟",
      cuisine: "Pescados y mariscos · playa",
      story: "Restaurante con los pies en la arena, vista directa al Mediterráneo, justo al sur del barrio Manshiya entre Neve Tzedek y Jaffa. Pescado fresco del día, mezzes mediterráneos, calamares, langostinos, ceviches. Reservar imprescindible al atardecer.",
      hours: "12:00–24:00 todos los días",
      reserve: "+972 3 517 4773 · mantaray.co.il",
      menu: ["Mezzes mediterráneos (15 platillos) — 75 NIS p/p", "Pescado del día a la sal — precio del mercado", "Calamares grillados — 88 NIS", "Ceviche de róbalo — 78 NIS", "Crème brûlée de la casa"],
      tip: "Reservar al atardecer (en junio ~19:30) — verán el sol caer al mar. Levanten copa de blanco israelí (Adir, Recanati, Tabor).",
      noPork: true,
    },
    "tlv-shakshuka-dr": {
      id: "tlv-shakshuka-dr",
      name: "Dr. Shakshuka",
      city: "Tel Aviv",
      lat: 32.0537,
      lng: 34.7521,
      type: "food",
      icon: "🍳",
      cuisine: "Tripolitana-israelí · Jaffa",
      story: "En pleno mercado de pulgas de Jaffa, comedor familiar de tres generaciones, cocina judía-libia-tripolitana. La shakshuka es la firma — huevos pochés en salsa de tomate con harissa, comino, pimentón. Carolina y Alan: el cuscús con couscoussera tradicional es legendario.",
      hours: "Dom–Vie 10:00–23:00 · Sáb 11:00–17:00",
      menu: ["Shakshuka clásica — 55 NIS", "Shakshuka roja con merguez — 65 NIS", "Couscous Bachi (con verduras) — 75 NIS", "Couscous con cordero — 105 NIS", "Bourekas de queso fritos — 45 NIS"],
      tip: "Ideal para almuerzo después de pasear Jaffa. Acompañar con limonada con menta fresca o un arak.",
      noPork: true,
    },
    "tlv-romano": {
      id: "tlv-romano",
      name: "Romano",
      city: "Tel Aviv",
      lat: 32.0630,
      lng: 34.7770,
      type: "food",
      icon: "🍝",
      cuisine: "Italiana · cocina de mercado",
      story: "Bar-restaurante en un piso alto de un edificio Bauhaus restaurado en Allenby, lleno de luces tibias, plantas, música DJ los fines de semana. Cocina italiana moderna con producto israelí: pastas hechas a mano, focaccias, parmesanos artesanales. Punto de encuentro de la escena creativa de Tel Aviv.",
      hours: "Dom–Sáb 19:00–02:00",
      reserve: "+972 53 809 6699 · romanorestaurant.com",
      menu: ["Focaccia de la casa — 38 NIS", "Cacio e pepe — 78 NIS", "Pappardelle al ragú de cordero — 95 NIS", "Pizza margherita con queso de búfala israelí — 75 NIS", "Tiramisú propio — 45 NIS"],
      tip: "Reservar con días. Atmósfera muy 'Tel Aviv joven'. Llegan después de las 22h se siente discoteca.",
      noPork: true,
    },
    "tlv-cassis": {
      id: "tlv-cassis",
      name: "Cassis",
      city: "Tel Aviv",
      lat: 32.0623,
      lng: 34.7655,
      type: "food",
      icon: "🍷",
      cuisine: "Bistró francés · Neve Tzedek",
      story: "Bistró francés clásico en una casa antigua de Neve Tzedek, manteles blancos, velas, espejos. Cocina francesa con guiño israelí — tartar, salmón gravlax, sopa de cebolla, ratatouille, créme brûlée. Bueno para una cena más tranquila.",
      hours: "12:00–23:00",
      reserve: "+972 3 510 0124",
      menu: ["Tartar de res al cuchillo — 89 NIS", "Sopa de cebolla gratinada — 48 NIS", "Salmón gravlax con blinis — 75 NIS", "Confit de pato con papas Sarladaises — 145 NIS", "Crème brûlée — 42 NIS"],
      tip: "Ambiente íntimo, ideal pareja. Reservar mesa interior o en la pequeña terraza si hace buen tiempo.",
      noPork: false,
      noPorkNote: "Tienen algún plato con cerdo (raro en Israel). Pato, salmón, res, cordero — todo sin cerdo.",
    },
    "tlv-suzanna": {
      id: "tlv-suzanna",
      name: "Suzanna",
      city: "Tel Aviv",
      lat: 32.0617,
      lng: 34.7651,
      type: "food",
      icon: "🌳",
      cuisine: "Mediterránea · jardín · Neve Tzedek",
      story: "Restaurante con un jardín-patio abierto bajo un sicómoro enorme en pleno Neve Tzedek. Cocina mediterránea-balcánica con un toque israelí. Mejor de día/atardecer. Plato icónico: malabi (postre persa con agua de rosas).",
      hours: "12:00–24:00",
      reserve: "+972 3 517 7580",
      menu: ["Mezze platter — 88 NIS", "Sambusak con queso búlgaro — 48 NIS", "Tabule de quinoa — 55 NIS", "Cordero asado con bulgur — 125 NIS", "Malabi con miel y pistacho — 38 NIS"],
      tip: "Almuerzo con vista al sicómoro = momento Tel Aviv. Sentarse fuera.",
      noPork: true,
    },
    "tlv-cafe-xoho": {
      id: "tlv-cafe-xoho",
      name: "Café Xoho",
      city: "Tel Aviv",
      lat: 32.0710,
      lng: 34.7755,
      type: "food",
      icon: "☕",
      cuisine: "Café · desayunos · brunch",
      story: "Café bohemio en Gordon, dueño australiano-israelí, ambiente acogedor con muchos libros. Buenos desayunos israelíes (con shakshuka, ensaladas, pan recién horneado), café excelente. Plan B para no comer el típico desayuno israelí del depto.",
      hours: "07:30–18:00 todos los días",
      menu: ["Desayuno israelí completo — 78 NIS (ensaladas, huevos, queso, jaffa, pan, jugo, café)", "Avocado toast con huevo poché — 58 NIS", "Granola casera con yogurt — 42 NIS", "Café de filtro — 16 NIS"],
      tip: "Si están sin desayuno en el depto, este es un mejor plan que el café del mercado. Sentarse en la terraza al sol.",
      noPork: true,
    },
    "tlv-habasta": {
      id: "tlv-habasta",
      name: "HaBasta",
      city: "Tel Aviv",
      lat: 32.0688,
      lng: 34.7686,
      type: "food",
      icon: "🌿",
      cuisine: "Mercado contemporáneo · estacional",
      story: "'La parada' — pequeño restaurante de chef adentro del mercado del Carmelo. La carta cambia a diario según lo que compran de los puestos vecinos. Cocina honesta, ingredientes vivos, sin pretensiones. Lleno de locales, casi no hay turistas.",
      hours: "Dom–Jue 12:00–24:00 · Vie 11:00–16:00 · Sáb noche",
      reserve: "+972 3 516 9234",
      menu: ["Pulpo asado con limón — 78 NIS", "Bagre del mar con tahina negra — 95 NIS", "Polenta con shitake y huevo — 62 NIS", "Tartar de remolacha — 48 NIS", "Helado de cardamomo y rosa — 38 NIS"],
      tip: "Reservar — la barra del chef es pequeña. Almuerzo después de pasear el mercado = combo perfecto.",
      noPork: true,
    },

    // ============== ISRAEL · ROAD TRIP AL SUR (10–13 jun) ==============
    "il-mitzpe-ramon": {
      id: "il-mitzpe-ramon",
      name: "Mitzpe Ramon · Cráter Ramon",
      nameLocal: "מצפה רמון · Makhtesh Ramon",
      city: "Negev",
      lat: 30.6094,
      lng: 34.7991,
      type: "sight",
      icon: "🌋",
      story: "El Cráter Ramon es el cráter erosivo más grande del mundo (40 km de largo, 10 km de ancho, 500 m de profundidad) — no es de impacto ni volcánico, sino una formación única producto de la erosión durante 220 millones de años. El mirador del Visitor Center está justo en el borde y la vista es vertiginosa. Adentro hay un museo interactivo dedicado a Ilan Ramon, el primer astronauta israelí.",
      hours: "Visitor Center: 08:00–17:00 (verano)",
      reserve: "+972 8 658 8691",
      address: "Maale Ben Tur, Mitzpe Ramon, Israel",
      tip: "Entrada 28 NIS adultos. Lo mínimo es el mirador (gratis) + visitor center (1h). Si tienen energía, hay un sendero corto de 30 min al borde del cráter (Albert Promenade). En el pueblo hay buenos cafés para almorzar antes de seguir hacia Eilat.",
    },
    "il-neot-semadar": {
      id: "il-neot-semadar",
      name: "Kibutz Neot Semadar",
      nameLocal: "נאות סמדר",
      city: "Negev",
      lat: 30.0567,
      lng: 35.0103,
      type: "sight",
      icon: "🍇",
      story: "Kibutz comunitario fundado en 1989 en pleno desierto del Negev. Conocido por su bodega ecológica, sus huertos de frutos secos y dátiles, el Centro de Arte y la cafetería abierta al público. Una sociedad utópica que vive del arte, la agricultura sostenible y la espiritualidad. Tienen tours guiados (con cita previa), pero también podés simplemente almorzar en su comedor abierto y comprar productos en la tienda.",
      hours: "Tienda: 09:00–18:00 · Café: 10:00–17:00 (cerrado sábados)",
      address: "Neot Semadar, Arava, Israel",
      tip: "Si bajan temprano, lleguen sobre las 10:00–11:00. La bodega tiene catas de su vino orgánico (~50 NIS) y aceitunas locales. El comedor del kibutz es vegetariano-vegano, fresco y barato (~60 NIS/persona).",
    },
    "il-red-canyon": {
      id: "il-red-canyon",
      name: "Red Canyon",
      nameLocal: "הקניון האדום · HaKanyon HaAdom",
      city: "Eilat (Negev)",
      lat: 29.7261,
      lng: 34.9444,
      type: "sight",
      icon: "🏜️",
      story: "Cañón corto de arenisca roja erosionada por miles de años de inundaciones súbitas. Las paredes están esculpidas como ondulaciones de fuego, con varios pasos por escaleras de hierro y secciones donde hay que apoyarse con las manos. Es uno de los senderos más fotogénicos de Israel y muy accesible — ruta circular de 1.5h aprox.",
      hours: "Siempre abierto · entrada gratuita",
      address: "Carretera 12, ~20 km al N de Eilat",
      tip: "🔥 Importante: NO entrar en días de lluvia o riesgo de flash flood. Ir temprano (antes de las 10:00) o al atardecer (17:00) en junio. Calzado con suela firme, agua 2L/persona. El recorrido completo es ~1.5h, también hay variante corta de 45min.",
    },
    "il-timna-park": {
      id: "il-timna-park",
      name: "Parque Nacional Timna",
      nameLocal: "פארק תמנע · Timna Park",
      city: "Eilat (Negev)",
      lat: 29.7855,
      lng: 34.9583,
      type: "sight",
      icon: "⛏️",
      story: "Las minas de cobre más antiguas del mundo, explotadas desde el período calcolítico (~5.000 a.C.) y luego por los egipcios y bíblicamente atribuidas al rey Salomón. Los famosos 'Pilares de Salomón' son columnas de arenisca roja de 50 metros, y el 'Hongo' es una roca esculpida por el viento. Hay también una réplica del Tabernáculo del Sinaí y un lago artificial al centro del parque.",
      hours: "Verano (jun): 08:00–17:00 (última entrada 15:00)",
      address: "Park Timna, Hwy 90, ~25 km al N de Eilat",
      reserve: "+972 8 631 6756",
      tip: "Entrada 49 NIS adultos. Se recorre EN AUTO por dentro (8 paradas señalizadas) — no hace falta caminar grandes distancias. El recorrido completo lleva 2–3h. Llevar agua, gorro, lentes. Hay un café al inicio.",
    },
    "il-eilat-arrival": {
      id: "il-eilat-arrival",
      name: "Llegada a Eilat — hotel",
      city: "Eilat",
      lat: 29.5577,
      lng: 34.9519,
      type: "transit",
      icon: "🏨",
      story: "Llegada a Eilat al anochecer después del road trip por el Negev. Detalles del hotel por confirmar.",
      tip: "📝 Pendiente: confirmar nombre y dirección del hotel + bookingRef (Alan los pasará por separado).",
    },
    "il-eilat-coral-beach": {
      id: "il-eilat-coral-beach",
      name: "Coral Beach Nature Reserve",
      nameLocal: "שמורת חוף האלמוגים",
      city: "Eilat",
      lat: 29.5028,
      lng: 34.9216,
      type: "beach",
      icon: "🐠",
      story: "La playa de snorkeling más famosa de Israel. Un arrecife de coral natural a 10 metros de la orilla con peces tropicales y a veces tortugas marinas. Está protegido como reserva natural, hay senderos señalizados con boyas y plataformas de madera para no pisar el coral.",
      hours: "Verano: 08:00–17:00",
      tip: "Entrada 35 NIS adultos. Alquilan máscara+snorkel (25 NIS) y aletas si no traen propias. Mejor temprano (09:00) o al atardecer — el sol al mediodía es brutal.",
      address: "Carretera 90 sur, Eilat, Israel",
    },
    "il-eilat-underwater": {
      id: "il-eilat-underwater",
      name: "Underwater Observatory Marine Park",
      nameLocal: "המצפה התת-ימי",
      city: "Eilat",
      lat: 29.5025,
      lng: 34.9217,
      type: "sight",
      icon: "🐬",
      story: "Único parque marino de Israel con torre de observación submarina (a 6 metros de profundidad, ventanales 360°) sobre el arrecife natural del Mar Rojo. Acuarios de tiburones, mantarrayas, tortugas, peces de coral. Hay una atracción adicional 'Oceanarium' con simulador de viaje submarino. Recorrido aprox 2–3h.",
      hours: "Verano: 08:30–16:00 (última entrada 15:00)",
      reserve: "+972 8 636 4200 · coralworld.com",
      tip: "Entrada 99 NIS adultos. Combinar con Coral Beach (están al lado). Café arriba con vista al mar y a la frontera con Jordania (Áqaba).",
      address: "Coral Beach, Eilat, Israel",
    },
    "il-eilat-ice-mall": {
      id: "il-eilat-ice-mall",
      name: "Ice Mall Eilat",
      nameLocal: "אייס מול אילת",
      city: "Eilat",
      lat: 29.5544,
      lng: 34.9519,
      type: "shopping",
      icon: "🛍️",
      story: "Centro comercial con pista de patinaje sobre hielo de tamaño olímpico en el centro — la única en Israel. Buena pausa del calor del desierto. Tiendas, foodcourt, cines. Eilat es zona libre de impuestos (sin IVA del 17%) — ropa y electrónica más baratas que en el resto del país.",
      hours: "Dom–Jue 10:00–22:00 · Vie 10:00–14:00 · Sáb 20:30–23:00",
      address: "Kampen 8, Eilat",
      tip: "Si quieren patinar: 50 NIS/persona, alquiler de patines incluido.",
    },
    "il-eilat-promenade": {
      id: "il-eilat-promenade",
      name: "Promenade y Marina de Eilat",
      nameLocal: "טיילת אילת",
      city: "Eilat",
      lat: 29.5524,
      lng: 34.9525,
      type: "sight",
      icon: "🌅",
      story: "Paseo marítimo a lo largo de la bahía norte. Frente al mar Rojo, con vista a Jordania (Áqaba). Restaurantes, helados, atracciones turísticas, parapente, bananas inflables. Ideal al atardecer cuando baja el calor.",
      hours: "Siempre abierto",
      tip: "Caminata recomendada: desde la Marina hacia el norte, ~30 minutos. Al final del paseo está la playa pública gratuita.",
      address: "Tayelet, Eilat, Israel",
    },
    "il-eilat-pago-pago": {
      id: "il-eilat-pago-pago",
      name: "Pago Pago Restaurant",
      city: "Eilat",
      lat: 29.5535,
      lng: 34.953,
      type: "food",
      icon: "🐟",
      cuisine: "Pescado y mariscos · vista a la Marina",
      story: "Clásico de Eilat desde hace 30 años. Pescado fresco del Mar Rojo, mariscos, terraza sobre la Marina con vista a los yates. Romántico al atardecer.",
      hours: "12:00–23:00 todos los días",
      reserve: "+972 8 637 6660 · pagopago.co.il",
      tip: "Reservar terraza para el atardecer (~19:00 en junio). Pidan el denis (besugo) entero al horno o el pescado del día.",
      noPork: false,
      address: "Marina, Eilat, Israel",
    },
    "il-beit-guvrin": {
      id: "il-beit-guvrin",
      name: "Parque Nacional Beit Guvrin–Maresha",
      nameLocal: "בית גוברין · UNESCO",
      city: "Shfela (cerca de Kiryat Gat)",
      lat: 31.6128,
      lng: 34.8975,
      type: "sight",
      icon: "🕳️",
      story: "Patrimonio de la Humanidad UNESCO. 3.500 cuevas excavadas durante 2.000 años en la piedra caliza blanda. Incluye la espectacular Cueva de la Campana (Bell Cave) de 25m de altura, los columbarios (cuevas-palomar para criar palomas en la época bizantina), bodegas, aceiteras y la antigua ciudad de Maresha. Senderos señalizados, caminata fácil, sombra natural.",
      hours: "Verano: 08:00–17:00 (última entrada 16:00)",
      address: "Hwy 35, Shfela, Israel",
      reserve: "+972 8 681 1020",
      tip: "Entrada 28 NIS adultos. Audio-guía gratis con la app 'Israel National Parks'. La Cueva de la Campana tiene una acústica única — si saben cantar, lánzense un nigún. Llevar linterna de bolsillo.",
    },
    "il-bet-el-house": {
      id: "il-bet-el-house",
      name: "Casa del hermano · Bet El",
      city: "Bet El",
      lat: 31.9456,
      lng: 35.2275,
      type: "stay",
      icon: "🏡",
      story: "Casa familiar del hermano de Alan en Bet El, asentamiento judío al norte de Jerusalén con vistas hacia Samaria. Shabat en familia.",
      address: "7 Khalamish st, Bet El, Israel",
      tip: "🕯️ Velas de Shabat viernes 12 jun ~19:23 · Havdalá sábado 13 jun ~20:30. No se conduce ni se enciende electricidad durante esas horas en el asentamiento.",
    },
    "il-mahane-yehuda": {
      id: "il-mahane-yehuda",
      name: "Mercado Mahane Yehuda",
      nameLocal: "שוק מחנה יהודה · Shuk Mahane Yehuda",
      city: "Jerusalén",
      lat: 31.7857,
      lng: 35.2125,
      type: "food",
      icon: "🍞",
      story: "El mercado más importante de Jerusalén. Viernes en la mañana es el momento mágico: toda la ciudad se prepara para el Shabat, las panaderías sacan jalá fresca, las verdulerías rebosan, los rugelach calientes salen del horno. Después de las 14:00 todo empieza a cerrar. Es un encuentro de sabores, olores y voces — vale más por el ambiente que por las compras.",
      hours: "Dom–Jue 08:00–19:00 · Vie 08:00–15:00 (cierre antes del Shabat)",
      address: "Etz HaChaim 100, Jerusalén",
      tip: "Llegar entre 10:00–12:00 para vivir el shuk en plenitud. Pidan jalá recién horneada en Marzipan (la mejor), rugelach de chocolate, halva, dátiles Medjool. Hay cafés bien escondidos en los callejones laterales — Beer Bazaar es clásico.",
    },
    "il-kotel": {
      id: "il-kotel",
      name: "Muro de los Lamentos · Kotel",
      nameLocal: "הכותל המערבי · HaKotel HaMa'aravi",
      city: "Jerusalén",
      lat: 31.7767,
      lng: 35.2345,
      type: "synagogue",
      icon: "🕊️",
      jewish: true,
      story: "El lugar más sagrado del judaísmo accesible para los judíos. El muro occidental del Monte del Templo, único resto en pie del Segundo Templo destruido por los romanos en el año 70 EC. Hombres a la derecha, mujeres a la izquierda. Tradición: escribir una plegaria en un papel y dejarla entre las piedras. El viernes en la tarde, antes de Shabat, el lugar se llena de hombres con tallit empezando el Kabalat Shabat — el ambiente es eléctrico.",
      hours: "Abierto 24h",
      tip: "Entrada gratis. Cubrirse hombros y rodillas. Los hombres reciben kipá a la entrada. Control de seguridad militar (mochilas grandes deben dejarse afuera). Para llegar más rápido en auto: estacionar en Mamilla y caminar 10 min por el barrio judío de la Ciudad Vieja.",
      address: "Kotel HaMaaravi, Ciudad Vieja, Jerusalén",
    },

    // ============== BARCELONA · ESCALA NOCTURNA (14–15 jun) ==============
    "bcn-sagrada-familia": {
      id: "bcn-sagrada-familia",
      name: "Sagrada Familia",
      nameLocal: "Basílica de la Sagrada Família",
      city: "Barcelona",
      lat: 41.4036,
      lng: 2.1744,
      type: "sight",
      icon: "⛪",
      story: "El templo más extraordinario del mundo en construcción desde 1882. Gaudí trabajó en él 43 años (los últimos 15 dedicándose exclusivamente) y murió en 1926 sin verlo terminado — atropellado por un tranvía y enterrado en la cripta del propio templo. Aún hoy se sigue construyendo: previsto terminar en 2026, justo el año de su visita. Adentro las columnas se ramifican como un bosque de piedra y la luz entra por vitrales que pintan las naves de azul al amanecer y rojo al atardecer. Es la obra cumbre de Gaudí y una de las construcciones más arriesgadas, espirituales y bellas jamás concebidas.",
      hours: "Lun–Sáb 09:00–20:00 · Dom 10:30–20:00",
      address: "C/ de Mallorca 401, Barcelona",
      tip: "🎟️ COMPRAR ONLINE — sagradafamilia.org. Sin ticket adelantado pueden quedarse fuera. Ticket básico €26 + audio incluido. Slot 9:00 o 9:30 ideal para empezar el día. Permanencia adentro ~1h 15min. La torre del Nacimiento sube por €36 — vale la pena pero suma 30 min.",
    },
    "bcn-passeig-gracia": {
      id: "bcn-passeig-gracia",
      name: "Passeig de Gràcia · Modernisme",
      city: "Barcelona",
      lat: 41.3917,
      lng: 2.1649,
      type: "sight",
      icon: "🏛️",
      story: "La avenida más elegante de Barcelona, llena de obras maestras del modernismo catalán. En una sola cuadra (la 'Manzana de la Discordia') están la Casa Batlló de Gaudí (fachada de huesos y escamas dragoneras), la Casa Amatller de Puig i Cadafalch (frontón escalonado holandés) y la Casa Lleó-Morera de Domènech i Montaner. Más arriba, la Casa Milà / La Pedrera, otro Gaudí, con su fachada ondulante. Caminar el Passeig de Gràcia es ver Barcelona haciendo arte urbano hace 120 años.",
      hours: "Calle abierta · fachadas siempre visibles",
      address: "Passeig de Gràcia, Barcelona",
      tip: "Para entrar a Casa Batlló: €35 con audioguía VR. Si solo tienen 1 día, vean las fachadas por fuera y guarden el tiempo para Sagrada Familia + Boqueria. El metro Passeig de Gràcia (L2/L3/L4) deja al lado.",
    },
    "bcn-boqueria": {
      id: "bcn-boqueria",
      name: "Mercat de la Boqueria",
      nameLocal: "Mercat de Sant Josep de la Boqueria",
      city: "Barcelona",
      lat: 41.3818,
      lng: 2.1716,
      type: "food",
      icon: "🍓",
      story: "El mercado más famoso de Europa, abierto desde 1840 sobre lo que era el convento de Sant Josep. Justo al lado de Las Ramblas. 300 puestos: jamones colgando, mariscos vivos en hielo, frutas tropicales de la huerta valenciana, especias, dulces, quesos. Pero más allá de pasear, lo bueno es comer en los puestos-bar del mercado mismo: pequeños mostradores donde te sirven lo que se cocina al momento. Pulpo a la gallega, calamares, jamón ibérico cortado a cuchillo. Atmósfera viva.",
      hours: "Lun–Sáb 08:00–20:30 · Cerrado domingos",
      address: "La Rambla 91, Barcelona",
      tip: "Llegar antes de las 13:00 para evitar el pico turístico. Los puestos de comida en la parte trasera son los más auténticos. Evitar los 'menús turísticos' del frente. Metro Liceu (L3).",
    },
    "bcn-quim-boqueria": {
      id: "bcn-quim-boqueria",
      name: "El Quim de la Boqueria",
      city: "Barcelona",
      lat: 41.3819,
      lng: 2.1716,
      type: "food",
      icon: "🍳",
      cuisine: "Tapas · cocina de mercado",
      story: "Mostrador legendario dentro de la Boqueria. El plato icónico: huevos fritos con chipirones (calamares chicos). También: gallinejas, alcachofas de Prat con butifarra, bocata de jamón ibérico recién cortado. 12 banquetas en barra, no se reserva — hay que esperar turno (~15-20 min) pero vale la pena. Vinos por copa.",
      hours: "Mar–Sáb 09:00–16:00 · Cerrado dom y lun",
      address: "Mercat de la Boqueria, puesto 583-585",
      tip: "⚠️ CERRADO LUNES. Plan B si llegan lunes: **Bar Pinotxo** (mismo mercado, atendido por Juanito desde 1940 — un personaje) o salir del mercado y caminar 10 min al Barrio Gótico para almorzar en otro lugar.",
      noPork: false,
    },
    "bcn-gotico": {
      id: "bcn-gotico",
      name: "Barrio Gótico",
      nameLocal: "Barri Gòtic",
      city: "Barcelona",
      lat: 41.3833,
      lng: 2.1769,
      type: "sight",
      icon: "🏰",
      story: "El corazón medieval de Barcelona. Calles estrechas adoquinadas que serpentean entre la Catedral, el antiguo Call (barrio judío hasta 1391), la Plaza del Rey y la Plaza Sant Jaume con sus dos sedes de poder (Ayuntamiento y Generalitat). Aquí se siente la Barcelona antes de Gaudí, antes del modernismo. Iglesias románicas, vestigios romanos visibles bajo cristal, balcones de piedra, y rincones perfectos para una caña y olivas en una terraza tranquila.",
      hours: "Calles siempre abiertas · Catedral 09:30–18:30",
      address: "Barri Gòtic, Barcelona",
      tip: "Catedral de Barcelona: visita normal €9, gratis los días de semana 08:30–12:30. Plaza Real para una caña al sol. Para tapas tranquilas en el barrio: **Bodega Biarritz**, **Caelis Tapas** o **Bar del Pla** (en el limítrofe Born).",
    },
    "bcn-palau-musica": {
      id: "bcn-palau-musica",
      name: "Palau de la Música Catalana",
      city: "Barcelona",
      lat: 41.3877,
      lng: 2.1748,
      type: "sight",
      icon: "🎼",
      story: "Patrimonio de la Humanidad UNESCO desde 1997. Sala de conciertos del modernismo catalán construida por Domènech i Montaner entre 1905 y 1908 — contemporánea exacta de la Sagrada Familia, pero del otro lado del movimiento (geometría racional vs naturaleza salvaje de Gaudí). El techo es un lucernario invertido en forma de gota de cristal azul que parece descender sobre el público. Mosaicos, columnas floridas, esculturas de ninfas y musas. Es uno de los espacios arquitectónicos más mágicos del mundo. La mayoría de turistas se quedan en la Pedrera y nunca lo descubren.",
      hours: "Visitas guiadas (50 min) cada 30 min: 10:00–15:30",
      address: "C/ Palau de la Música 4-6, Barcelona",
      reserve: "palaumusica.cat · +34 932 95 72 00",
      tip: "🎟️ COMPRAR ONLINE — €20 con guía en español. Slot 10:00 ideal para empezar el día. Si toca un concierto de mañana a precio simbólico (€7-15), todavía mejor que el tour. Metro L1/L4 Urquinaona o L4 Jaume I.",
    },
    "bcn-sant-pau": {
      id: "bcn-sant-pau",
      name: "Recinte Modernista de Sant Pau",
      nameLocal: "Hospital de Sant Pau · UNESCO",
      city: "Barcelona",
      lat: 41.4116,
      lng: 2.1741,
      type: "sight",
      icon: "🏥",
      story: "El otro tesoro modernista de Domènech i Montaner — un complejo hospitalario de 12 pabellones conectados por túneles subterráneos, jardines y cúpulas de cerámica. Lo construyeron entre 1902-1930 como nueva versión del Hospital de la Santa Creu medieval. Funcionó como hospital hasta 2009. Hoy es centro cultural visitable. Casi sin turistas si lo comparan con la Sagrada Familia (que queda a 5 minutos caminando). Una joya rara: arquitectura sanitaria como arte.",
      hours: "Lun–Sáb 10:00–18:30 · Dom 10:00–14:30",
      address: "C/ Sant Antoni Maria Claret 167, Barcelona",
      reserve: "santpaubarcelona.org",
      tip: "🎟️ €18 entrada. ALTERNATIVA si prefieren modernismo nuevo (no quieren repetir Sagrada Familia, que está al lado). Ojo: cierre temprano dom 14:30. Metro L5 Sant Pau / Dos de Maig.",
    },
    "bcn-pedralbes": {
      id: "bcn-pedralbes",
      name: "Monestir de Pedralbes",
      city: "Barcelona",
      lat: 41.3919,
      lng: 2.1102,
      type: "sight",
      icon: "🏛️",
      story: "Monasterio gótico catalán fundado en 1326 por la reina Elisenda de Montcada. Habitado por monjas clarisas hasta 1983 (¡600 años continuos!). El claustro de tres pisos es de los más impresionantes de Europa: arcos góticos, jardines de árboles frutales, un pozo central. Adentro pueden ver las celdas de las monjas, la cocina del s.XIV, una capilla con frescos de Ferrer Bassa (la 'capilla Sixtina catalana'). A 10 minutos del hotel — vale la pena la visita rápida si no quieren entrar al centro o si vuelven con tiempo.",
      hours: "Mar–Vie 10:00–14:00 · Sáb–Dom 10:00–17:00 · Lun CERRADO",
      address: "Baixada del Monestir 9, Barcelona",
      tip: "⚠️ CERRADO LUNES. Plan B si quieren visita rápida cerca del hotel: jardines del Palau de Pedralbes (públicos, gratis) o el Camp Nou (a 10 min andando).",
    },
    "bcn-cal-pep": {
      id: "bcn-cal-pep",
      name: "Cal Pep",
      city: "Barcelona",
      lat: 41.3838,
      lng: 2.1825,
      type: "food",
      icon: "🦐",
      cuisine: "Tapas de barra · pescados y mariscos",
      story: "Una barra mítica desde 1977. No hay carta — Pep elige por vos. Se entra, se espera de pie 20-40 minutos (no se reserva la barra), y cuando hay sitio él te empieza a mandar platos: gambas de Palamós a la plancha, chipirones, callos, tortilla de butifarra, espinacas con garbanzos. Cocina catalana de mercado al máximo nivel, sin manteles, sin servilletas dobladas. Una experiencia.",
      hours: "Lun 19:30–23:30 · Mar–Sáb 13:00–16:00 · 19:30–23:30 · Cerrado dom",
      address: "Plaça de les Olles 8, El Born, Barcelona",
      reserve: "+34 933 10 79 61 (sólo mesas, NO barra)",
      tip: "⭐ Va al Born después del Palau de la Música. La barra es la magia — vayan con hambre, dejá que Pep elija. Si quieren mesa (más tranquilo), reserven 5 días antes. €40-50/pax.",
      noPork: false,
    },
    "bcn-bar-del-pla": {
      id: "bcn-bar-del-pla",
      name: "Bar del Pla",
      city: "Barcelona",
      lat: 41.3849,
      lng: 2.1804,
      type: "food",
      icon: "🍷",
      cuisine: "Tapas modernas · cocina catalana",
      story: "Pequeño bar del Born con tapas modernas pero arraigadas en la cocina catalana. Mucho más tranquilo y reservable que Cal Pep. Plato icónico: ravioli de rabo de toro. Buena lista de vinos. Atendido por jóvenes catalanes apasionados. Plan B si no quieren la cola de Cal Pep o si Cal Pep está cerrado.",
      hours: "Mar–Sáb 13:00–16:00 · 19:30–23:30 · Cerrado dom y lun",
      address: "C/ de Montcada 2, El Born, Barcelona",
      reserve: "+34 932 68 30 03 · bardelpla.cat",
      tip: "⚠️ CERRADO LUNES — para almorzar el día 15 (lunes) no sirve. Plan A: Cal Pep. Plan B: 7 Portes (clásico, a 4 min) o Mercat de Santa Caterina (tapas en mostrador).",
      noPork: false,
    },
    "bcn-7-portes": {
      id: "bcn-7-portes",
      name: "7 Portes",
      city: "Barcelona",
      lat: 41.3818,
      lng: 2.1825,
      type: "food",
      icon: "🍚",
      cuisine: "Catalana clásica · paellas y arroces",
      story: "Restaurante histórico inaugurado en 1836 — uno de los más antiguos de España aún en activo. Pasó por sus mesas Picasso, Hemingway, Lorca, Plácido Domingo. Famoso por la paella Parellada (sin espinas ni cáscaras) y por el arroz negro. Salones con techos altos, manteles blancos, camareros de chaqueta blanca. Es turístico pero la calidad se mantiene desde hace 189 años.",
      hours: "Todos los días 13:00–01:00 (no cierra)",
      address: "Passeig d'Isabel II 14, Born, Barcelona",
      reserve: "7portes.com · +34 933 19 30 33",
      tip: "Plan B si Torre d'Alta Mar no funciona. A 12 min caminando del hotel Eurostars Grand Marina. Reservar 2-3 días antes. €35-45/pax.",
      noPork: false,
    },
    "bcn-torre-alta-mar": {
      id: "bcn-torre-alta-mar",
      name: "Torre d'Alta Mar",
      city: "Barcelona",
      lat: 41.3753,
      lng: 2.1851,
      type: "food",
      icon: "🥂",
      cuisine: "Mediterránea contemporánea · alta cocina",
      story: "Restaurante panorámico dentro de la Torre de Sant Sebastià — la torre del telefèric del puerto — a 75m de altura. Vistas 360° del Mediterráneo, el puerto, Montjuïc, la Sagrada Familia y la Barcelona vieja. Cocina mediterránea moderna de producto: pescados de lonja, arroces, terrina de bogavante. Un destino clásico para aniversarios, pedidas y celebraciones — pocas mesas en Barcelona ofrecen una vista así desde el plato.",
      hours: "Mar–Sáb 13:00–15:30 · 20:00–23:00 · Lun mediodía abierto (verificar) · Dom cerrado",
      address: "Torre de Sant Sebastià, Passeig Joan de Borbó 88, Barcelona (telefèric del puerto)",
      reserve: "torredealtamar.com · +34 932 21 00 07",
      tip: "🥂 ANIVERSARIO — pedir mesa de ventana con vista al mar (avisar al reservar que es una ocasión especial — suelen poner una copa de cava de cortesía). Menú degustación €95-130 pp · vinos aparte. Solo se accede en ascensor por la torre del telefèric — 5 minutos caminando desde el hotel Eurostars Grand Marina. Reservar 1-2 semanas antes con OpenTable o por teléfono.",
      noPork: false,
    },
    "bcn-salamanca-bcn": {
      id: "bcn-salamanca-bcn",
      name: "Salamanca (Barceloneta)",
      city: "Barcelona",
      lat: 41.3795,
      lng: 2.1860,
      type: "food",
      icon: "🥘",
      cuisine: "Marisquería catalana · paellas y arroces",
      story: "Clásico de Barceloneta a pasos del puerto. Cocina marinera honesta: paella valenciana, arroz negro, mariscadas. Ambiente animado, abierto hasta tarde, ideal para una cena de llegada después de un viaje largo. 7 minutos caminando del Eurostars Grand Marina por el paseo del puerto.",
      hours: "Todos los días 13:00–24:00 (cocina hasta 23:30)",
      address: "Almirante Cervera 34 · Passeig Joan de Borbó 21, Barceloneta, Barcelona",
      reserve: "+34 932 21 50 33",
      tip: "🍤 7 min caminando del hotel por el Moll. Si llegan ~22:15 del aeropuerto: ducharse rápido y caminar. Pidan paella valenciana para dos + tomate aliñado. Llamar al salir del aeropuerto para avisar hora estimada.",
      noPork: false,
    },
    "bcn-santa-caterina": {
      id: "bcn-santa-caterina",
      name: "Mercat de Santa Caterina",
      city: "Barcelona",
      lat: 41.3858,
      lng: 2.1773,
      type: "food",
      icon: "🍅",
      story: "Mercado del barrio del Born, mucho menos turístico que la Boqueria. Reconocido por su techumbre ondulante de cerámica colorida diseñada por Enric Miralles (2005) — una de las imágenes contemporáneas de Barcelona. Adentro: 67 puestos de productos frescos + 4-5 puestos-bar para comer tapas al mostrador. Más local, más auténtico, más tranquilo.",
      hours: "Lun, Mié, Sáb 07:30–15:30 · Mar, Jue, Vie 07:30–20:30 · Dom cerrado",
      address: "Av. de Francesc Cambó 16, Born, Barcelona",
      tip: "🍳 Comer en el puesto Cuines Santa Caterina (a la izquierda del acceso principal) — tapas y platos del día por €12-18. Al lado están las ruinas de un convento medieval del s.XIII bajo cristal.",
    },
    "bcn-da-greco": {
      id: "bcn-da-greco",
      name: "Da Greco",
      city: "Barcelona",
      lat: 41.3791,
      lng: 2.1186,
      type: "food",
      icon: "🍝",
      cuisine: "Italiano · trattoria de barrio",
      story: "Italiano clásico y honesto en Les Corts. Pasta hecha en casa, pizzas al horno de leña, ambiente familiar. Atendido por italianos de verdad. Una opción perfecta para una cena de llegada: a 8 minutos caminando del hotel Ilunion, abierto hasta las 23:30.",
      hours: "Mar–Dom 13:00–16:00 · 20:00–23:30 (cerrado lunes)",
      address: "C/ Numància 75, Les Corts, Barcelona",
      reserve: "+34 933 22 50 86",
      tip: "🚶 7-8 min caminando desde el hotel. Reservar mesa antes de salir del hotel (el dueño habla castellano perfecto). Pidan los gnocchi al ragú o la pizza Da Greco.",
      noPork: false,
    },
    "bcn-casa-lloret": {
      id: "bcn-casa-lloret",
      name: "Casa Lloret",
      city: "Barcelona",
      lat: 41.3796,
      lng: 2.1148,
      type: "food",
      icon: "🥘",
      cuisine: "Catalana tradicional · cocina de barrio",
      story: "Bar de barrio de toda la vida en Les Corts. Cocina catalana sin pretensiones: butifarras, escalivada, fideuá, bacalao a la llauna. Ambiente local, sin turistas, precio justo. La ventaja: a 10 minutos del hotel, cierra tarde, y comen una cena auténtica recién bajados del avión.",
      hours: "Lun–Sáb 13:00–16:00 · 20:00–23:00 · Dom cerrado",
      address: "C/ Numància 79, Les Corts, Barcelona",
      reserve: "+34 933 22 90 13",
      tip: "Pedir mesa al llegar, no se reserva. Plato fuerte: la fideuá negra. Si llegan tarde (>22:00) avisar al hotel y llamar antes para asegurar cocina abierta.",
      noPork: false,
    },
    "bcn-bardeni": {
      id: "bcn-bardeni",
      name: "Bardeni (Carnicería Bar)",
      city: "Barcelona",
      lat: 41.4031,
      lng: 2.1605,
      type: "food",
      icon: "🥩",
      cuisine: "Carnes · barra de carnicería",
      story: "Una carnicería convertida en bar de tapas. Concepto del chef Dani Lechuga: aquí solo se come carne, y se come muy bien. Famoso por su hamburguesa Bardeni (la votaron entre las mejores de España) y por las pequeñas raciones de cortes premium. Si quieren una cena de llegada con identidad, vale la pena el metro de 15 min hasta acá.",
      hours: "Mar–Sáb 13:00–15:30 · 19:30–22:30 · Cerrado dom y lun",
      address: "C/ Valencia 454, Eixample, Barcelona",
      reserve: "+34 932 32 58 11",
      tip: "Hay que reservar SIEMPRE (bardeni.cat). Si llegan sin reserva: barra de pie. Hamburguesa €13, magret con miel €16. 15 min en metro desde el hotel (L3 Les Corts → L5 Diagonal → 7 min andando).",
      noPork: false,
    },
  },

  // ============== SABORES TÍPICOS · QUÉ PROBAR Y DÓNDE ==============
  tastings: {
    Budapest: [
      {
        id: "t-langos",
        name: "Lángos",
        emoji: "🫓",
        what: "Masa frita gruesa, untada con crema agria (tejföl) y queso rallado (sajt). El street food por excelencia de Hungría. Tradicionalmente come obreros para empezar el día.",
        where: "Karaván Street Food · Mercado Central (piso 2, Lángos Csemege) · Retró Lángos Büfé",
        tip: "Pedir el clásico (fokhagyma con ajo, tejföl, sajt). Sin kolbász si quieren evitar cerdo. ~€4.",
        venues: [
          { name: "Karaván Street Food", lat: 47.4975, lng: 19.0617 },
          { name: "Mercado Central — Lángos Csemege (piso 2)", lat: 47.4865, lng: 19.0586 },
          { name: "Retró Lángos Büfé", lat: 47.5050, lng: 19.0731 },
        ],
      },
      {
        id: "t-kurtos",
        name: "Kürtőskalács (chimney cake)",
        emoji: "🎂",
        what: "Masa enrollada en un cilindro, asada sobre brasas, espolvoreada de canela-azúcar o coco. Originario de Transilvania. Inventaron el TikTok-friendly de helado adentro, pero el original sin relleno es lo bueno.",
        where: "Molnár's Kürtőskalács (Váci u. 31) · Vitéz Kürtős · puestos en Mercado Central",
        tip: "Comerlo recién hecho, todavía caliente. ~1.500 HUF (€3.70).",
        venues: [
          { name: "Molnár's Kürtőskalács (Váci u. 31)", lat: 47.4915, lng: 19.0540 },
          { name: "Vitéz Kürtős (Váci u.)", lat: 47.4956, lng: 19.0521 },
          { name: "Mercado Central (puestos)", lat: 47.4865, lng: 19.0586 },
        ],
      },
      {
        id: "t-gulyas",
        name: "Gulyás",
        emoji: "🥣",
        what: "ATENCIÓN: en Hungría, el gulyás es una SOPA, no un estofado. Sopa espesa de res, papas, cebolla y mucha paprika dulce. Lo que el mundo llama 'goulash' aquí se llama pörkölt.",
        where: "Hungarikum Bisztró · Frici Papa · Café Centrál · Kéhli",
        tip: "Pidan también un buen vino tinto Egri Bikavér (Sangre de Toro) para acompañar.",
        venues: [
          { name: "Hungarikum Bisztró", lat: 47.5028, lng: 19.0511 },
          { name: "Frici Papa Kifőzdéje", lat: 47.5057, lng: 19.0631 },
          { name: "Café Centrál Kávéház", lat: 47.4922, lng: 19.0567 },
          { name: "Kéhli Vendéglő", lat: 47.5400, lng: 19.0427 },
        ],
      },
      {
        id: "t-paprikas",
        name: "Csirkepaprikás",
        emoji: "🍗",
        what: "Pollo en salsa cremosa de paprika dulce y crema agria, servido con nokedli (pequeñas pastas-dumplings caseras). El plato húngaro de domingo familiar por excelencia.",
        where: "Frici Papa · Hungarikum Bisztró · Café Centrál · Rosenstein · Spinoza",
        tip: "Probar con un Olaszrizling blanco de la zona del Lago Balatón.",
        venues: [
          { name: "Rosenstein Vendéglő", lat: 47.5004, lng: 19.0773 },
          { name: "Hungarikum Bisztró", lat: 47.5028, lng: 19.0511 },
          { name: "Frici Papa Kifőzdéje", lat: 47.5057, lng: 19.0631 },
          { name: "Spinoza Café & Restaurant", lat: 47.4960, lng: 19.0598 },
        ],
      },
      {
        id: "t-solet",
        name: "Sólet",
        emoji: "🫘",
        what: "Cholent húngaro: estofado de porotos blancos, cebada y carne (ganso, res o cordero, no cerdo), cocido lentamente desde el viernes. Plato judío adaptado a la mesa húngara durante siglos. Sustancioso, terroso, abrazador.",
        where: "Rosenstein · Kéhli (con ganso) · Carmel · Macesz Huszár · Spinoza",
        tip: "Pidan con huevo cocido entero adentro (la versión judía clásica) y el ganso ahumado encima.",
        venues: [
          { name: "Rosenstein Vendéglő", lat: 47.5004, lng: 19.0773 },
          { name: "Carmel Étterem", lat: 47.4956, lng: 19.0630 },
          { name: "Macesz Huszár", lat: 47.4979, lng: 19.0620 },
          { name: "Spinoza Café & Restaurant", lat: 47.4960, lng: 19.0598 },
        ],
      },
      {
        id: "t-dobos",
        name: "Dobos torta",
        emoji: "🍰",
        what: "Inventada por József Dobos en 1884: 5–7 capas finas de bizcocho con crema de manteca y chocolate, coronada con una tapa de caramelo duro. Para muchos, la torta más famosa de Europa central.",
        where: "Café Gerbeaud · New York Café · Centrál Kávéház · Café Auguszt",
        tip: "Probarla en Gerbeaud — la casa donde se perfeccionó.",
        venues: [
          { name: "Café Gerbeaud (Vörösmarty tér)", lat: 47.4965, lng: 19.0508 },
          { name: "New York Café", lat: 47.4970, lng: 19.0712 },
          { name: "Centrál Kávéház", lat: 47.4922, lng: 19.0567 },
        ],
      },
      {
        id: "t-somloi",
        name: "Somlói galuska",
        emoji: "🍮",
        what: "Postre nacional húngaro: tres capas de bizcocho (vainilla, chocolate, nuez) empapadas en almíbar de ron, con crema pastelera, ganache de chocolate y crema chantilly. Brutal en porción y sabor.",
        where: "Hungarikum Bisztró · Café Centrál · Kéhli · cualquier restaurante húngaro tradicional",
        venues: [
          { name: "Hungarikum Bisztró", lat: 47.5028, lng: 19.0511 },
          { name: "Centrál Kávéház", lat: 47.4922, lng: 19.0567 },
        ],
      },
      {
        id: "t-toko",
        name: "Tokaji Aszú",
        emoji: "🍷",
        what: "El vino dulce más prestigioso del mundo, llamado 'el rey de los vinos, el vino de los reyes' por Luis XIV. De uvas botritizadas de la región de Tokaj. Color ámbar, notas de damasco, miel y nuez.",
        where: "Cualquier wine bar: DiVino Borbár, Doblo, Tasting Table (frente al Parlamento)",
        tip: "Pedir un Aszú de 5 puttonyos (escala de dulzor). Como aperitivo o postre, una copa pequeña.",
        venues: [
          { name: "DiVino Borbár (Szent István tér)", lat: 47.5005, lng: 19.0529 },
          { name: "Doblo Wine Bar", lat: 47.4969, lng: 19.0617 },
          { name: "Tasting Table Budapest", lat: 47.5034, lng: 19.0469 },
        ],
      },
      {
        id: "t-palinka",
        name: "Pálinka",
        emoji: "🥃",
        what: "Aguardiente húngaro de fruta, alcohol fuerte (40–50°). De damasco (barack), pera (körte), ciruela (szilva), cereza (meggy). Se toma como bajativo o como aperitivo.",
        where: "Cualquier bar tradicional. Magyar Pálinka Háza (tienda especializada).",
        tip: "Beber de un trago a temperatura ambiente, en copita pequeña tipo dedal. ¡Egészségedre! (salud).",
        venues: [
          { name: "Magyar Pálinka Háza (Rákóczi út 17)", lat: 47.4949, lng: 19.0668 },
          { name: "Szimpla Kert (ruin bar clásico)", lat: 47.4970, lng: 19.0633 },
        ],
      },
      {
        id: "t-unicum",
        name: "Unicum Zwack",
        emoji: "🍶",
        what: "Bíter herbal con 40 hierbas, color marrón muy oscuro, sabor a regaliz amargo. Receta secreta desde 1790. Botella redonda con cruz roja. El bajativo nacional húngaro.",
        where: "Cualquier bar. Visitar el Museo Zwack si tienen tiempo.",
        tip: "Tomarlo helado, después de comida pesada. No es para todos los paladares — gusto adquirido.",
        venues: [
          { name: "Zwack Unicum Museum", lat: 47.4774, lng: 19.0667 },
          { name: "Szimpla Kert", lat: 47.4970, lng: 19.0633 },
        ],
      },
    ],

    Praga: [
      {
        id: "t-svickova",
        name: "Svíčková na smetaně",
        emoji: "🍖",
        what: "El plato nacional checo. Lomo de res cocido lento en salsa cremosa de raíces (zanahoria, apio, perejil), servido con knedlíky (dumplings de pan al vapor) y una cucharada de mermelada de arándanos. Suena raro la combinación, funciona perfecto.",
        where: "U Pinkasů · Mincovna · Lokál Dlouhááá · Café Imperial al almuerzo",
        tip: "Acompañar con un par de cervezas Pilsner. El plato sin cerdo más típico de Bohemia.",
        venues: [
          { name: "Lokál Dlouhááá", lat: 50.0908, lng: 14.4257 },
          { name: "U Pinkasů", lat: 50.0843, lng: 14.4232 },
          { name: "Mincovna", lat: 50.0876, lng: 14.4214 },
          { name: "Café Imperial", lat: 50.0894, lng: 14.4308 },
        ],
      },
      {
        id: "t-gulas",
        name: "Hovězí guláš",
        emoji: "🥣",
        what: "Versión checa del goulash: estofado espeso de res con cebolla y un toque de paprika (mucho menos que el húngaro), servido con knedlíky de pan. Comida de hospoda.",
        where: "Lokál · U Pinkasů · Mincovna",
        venues: [
          { name: "Lokál Dlouhááá", lat: 50.0908, lng: 14.4257 },
          { name: "U Pinkasů", lat: 50.0843, lng: 14.4232 },
          { name: "Mincovna", lat: 50.0876, lng: 14.4214 },
        ],
      },
      {
        id: "t-tatarak",
        name: "Tatarák",
        emoji: "🥩",
        what: "Tartar de res checa, montañita servida con yema cruda encima, cebolla picada, pepinillos y mostaza al lado. Junto: rebanadas de pan tostado y un diente de ajo para frotar el pan. Acompaña con cerveza fría.",
        where: "Lokál (especialidad) · U Pinkasů · Café Slavia",
        tip: "Frotar bien el ajo en el pan caliente antes de montar el tartar. Una experiencia.",
        venues: [
          { name: "Lokál Dlouhááá", lat: 50.0908, lng: 14.4257 },
          { name: "U Pinkasů", lat: 50.0843, lng: 14.4232 },
          { name: "Café Slavia", lat: 50.0813, lng: 14.4138 },
        ],
      },
      {
        id: "t-smazak",
        name: "Smažený sýr",
        emoji: "🧀",
        what: "Queso (eidam o hermelín) empanizado y frito, servido con papas hervidas y salsa tártara. Es básicamente queso frito. Comida ultra-checa, sin pretensiones.",
        where: "Lokál · cualquier hospoda · Café Slavia",
        venues: [
          { name: "Lokál Dlouhááá", lat: 50.0908, lng: 14.4257 },
          { name: "Café Slavia", lat: 50.0813, lng: 14.4138 },
        ],
      },
      {
        id: "t-bramboraky",
        name: "Bramboráky",
        emoji: "🥔",
        what: "Tortillas de papa rallada con mejorana y ajo, fritas crujientes. Snack callejero en mercados. Olor inolvidable.",
        where: "Mercados callejeros (Havelská) · Lokál (en carta)",
        venues: [
          { name: "Mercado Havelská", lat: 50.0847, lng: 14.4225 },
          { name: "Lokál Dlouhááá", lat: 50.0908, lng: 14.4257 },
        ],
      },
      {
        id: "t-trdelnik",
        name: "Trdelník",
        emoji: "🌀",
        what: "Masa enrollada en cilindro, asada con canela-azúcar. SE VENDE COMO 'tradicional praguense' pero NO LO ES — es un postre transilvano (primo del kürtőskalács húngaro) que llegó a Praga en los 2000 vía marketing turístico. Pero ya está, ahí están en cada esquina.",
        where: "Cualquier esquina del centro turístico",
        tip: "Si lo prueban, que sea recién hecho. NO lo rellenen de helado — el original es seco, con canela.",
        venues: [
          { name: "Puestos Plaza Vieja (Staroměstské náměstí)", lat: 50.0875, lng: 14.4213 },
          { name: "Puestos Karlova (camino al Puente de Carlos)", lat: 50.0858, lng: 14.4175 },
        ],
      },
      {
        id: "t-vetrnik",
        name: "Větrník",
        emoji: "🌪️",
        what: "Esta SÍ es la pastelería praguense de verdad. Choux relleno de crema vainilla y crema de mantequilla, con un techo de caramelo crujiente. Postre nacional checo.",
        where: "Cukrárna Myšák (la mejor) · Café Imperial · Mincovna · Erhartova Cukrárna",
        tip: "Comerlo recién hecho, el caramelo crujiente es la clave. Myšák es la referencia.",
        venues: [
          { name: "Cukrárna Myšák", lat: 50.0833, lng: 14.4242 },
          { name: "Café Imperial", lat: 50.0894, lng: 14.4308 },
          { name: "Erhartova Cukrárna (Vinohrady)", lat: 50.0779, lng: 14.4444 },
        ],
      },
      {
        id: "t-medovnik",
        name: "Medovník",
        emoji: "🍯",
        what: "Torta de miel checa: 6+ capas finas de masa de miel con crema agria-mascarpone entre cada una. Rusa de origen, adoptada por los checos. Dulce-ácida, densa, perfecta con café.",
        where: "Café Imperial · Café Slavia · cualquier café histórico · supermercados grandes (para llevar)",
        venues: [
          { name: "Café Imperial", lat: 50.0894, lng: 14.4308 },
          { name: "Café Slavia", lat: 50.0813, lng: 14.4138 },
          { name: "Café Louvre", lat: 50.0832, lng: 14.4189 },
        ],
      },
      {
        id: "t-pilsner",
        name: "Pilsner Urquell de tanque",
        emoji: "🍺",
        what: "La cerveza más copiada del mundo (todas las 'pilsen' del planeta vienen de esta receta, 1842). La que sirven 'z tanku' (sin pasteurizar, en tanques traídos directos de Plzeň) es muy distinta de la embotellada — más fresca, espuma cremosa.",
        where: "Lokál (la mejor servida de Praga) · U Pinkasů · Pivovarský Dům",
        tip: "Pedir 'pivo z tanku' o señalar al barril. Estilos de servicio: 'hladinka' (clásica), 'mlíko' (toda espuma — sorprendente).",
        venues: [
          { name: "Lokál Dlouhááá", lat: 50.0908, lng: 14.4257 },
          { name: "U Pinkasů", lat: 50.0843, lng: 14.4232 },
          { name: "Pivovarský Dům", lat: 50.0738, lng: 14.4257 },
        ],
      },
      {
        id: "t-becherovka",
        name: "Becherovka",
        emoji: "🌿",
        what: "Bíter herbal verde-amarillo de Karlovy Vary, receta de 1807. 20 hierbas y especias, regaliz dominante. El bajativo checo nacional.",
        where: "Cualquier bar. Servido bien helado.",
        tip: "También existe 'Beton' = Becherovka + tónica en hielo. Refrescante en verano.",
        venues: [
          { name: "Lokál Dlouhááá", lat: 50.0908, lng: 14.4257 },
          { name: "Hemingway Bar", lat: 50.0848, lng: 14.4173 },
        ],
      },
      {
        id: "t-slivovice",
        name: "Slivovice",
        emoji: "🥃",
        what: "Aguardiente de ciruela, originario de Moravia y los Balcanes. Las versiones caseras (z domácí) pueden ser ferocidades de 60°. La comercial Jelínek es la referencia.",
        where: "Bares con buena oferta de destilados.",
        venues: [
          { name: "Hemingway Bar", lat: 50.0848, lng: 14.4173 },
          { name: "Lokál Dlouhááá", lat: 50.0908, lng: 14.4257 },
        ],
      },
    ],

    Madrid: [
      {
        id: "t-cocido",
        name: "Cocido madrileño",
        emoji: "🍲",
        what: "El plato madrileño por excelencia. Garbanzos con verduras, gallina, ternera y embutidos (chorizo, morcilla — cerdo). Se sirve en 'vuelcos': primero el caldo con fideos, después garbanzos+verduras, después carnes.",
        where: "Lhardy (jueves) · La Bola (tradicional, en olla de barro) · Malacatín",
        tip: "Pueden pedir 'cocido sin los embutidos' — sale más limpio. El caldo y los garbanzos son la base.",
        venues: [
          { name: "Lhardy", lat: 40.4156, lng: -3.7028 },
          { name: "La Bola Taberna", lat: 40.4198, lng: -3.7110 },
          { name: "Malacatín", lat: 40.4101, lng: -3.7088 },
        ],
      },
      {
        id: "t-tapas",
        name: "Tapas de barrio",
        emoji: "🍢",
        what: "La cultura de tapeo: pequeños platos en barra. Algunas sin cerdo: tortilla de patatas, croquetas de gallina o de bacalao, gambas al ajillo, calamares a la romana, boquerones en vinagre, pulpo a feira, pimientos de Padrón.",
        where: "La Latina (calles Cava Baja, Cava Alta) · barrio de Las Letras · Mercado de San Miguel (turístico pero rico)",
        venues: [
          { name: "Cava Baja (La Latina)", lat: 40.4118, lng: -3.7095 },
          { name: "Mercado de San Miguel", lat: 40.4153, lng: -3.7090 },
          { name: "Barrio de Las Letras (Plaza Santa Ana)", lat: 40.4150, lng: -3.7000 },
        ],
      },
      {
        id: "t-churros",
        name: "Churros con chocolate",
        emoji: "🍫",
        what: "Desayuno o merienda madrileña. Masa frita en tiras, sumergida en chocolate caliente espeso. Hay porras también (más gruesos).",
        where: "Chocolatería San Ginés (1894, abierta 24h, la referencia) · La Antigua Churrería",
        venues: [
          { name: "Chocolatería San Ginés", lat: 40.4170, lng: -3.7066 },
        ],
      },
    ],

    "Tel Aviv": [
      {
        id: "tlv-hummus",
        name: "Hummus",
        emoji: "🥣",
        what: "El plato nacional de Israel. Pasta cremosa de garbanzos con tahini, limón, ajo y aceite de oliva, servida tibia con pita recién horneada, cebolla cruda, pepinillos y un huevo cocido. El hummus de verdad — el de los hummusiyot tradicionales — es una experiencia completamente distinta al de supermercado. Cada local tiene su versión: clásico, masabacha (con garbanzos enteros), ful (con habas).",
        where: "Abu Hassan / Ali Karavan (Jaffa, el mejor) · HaKosem · Shlomo & Doron · Mashawsha",
        tip: "Desayuno o almuerzo temprano. Después de las 14:00 muchos hummusiyot cierran. Pidan 'masabacha' al menos una vez.",
        venues: [
          { name: "Abu Hassan / Ali Karavan (Jaffa, Ha-Dolfin)", lat: 32.0539, lng: 34.7548 },
          { name: "HaKosem (Shlomo HaMelech)", lat: 32.0747, lng: 34.7720 },
          { name: "Shlomo & Doron (Mercado Carmel)", lat: 32.0703, lng: 34.7682 },
        ],
      },
      {
        id: "tlv-sabich",
        name: "Sabich",
        emoji: "🥙",
        what: "El street food más característico de Tel Aviv. Pita rellena de berenjena frita, huevo duro, ensalada israelí, papas, hummus, tahini y amba (salsa de mango fermentado). Invento de los judíos iraquíes que llegaron en los 50. Suena raro la combinación — funciona perfecto.",
        where: "Sabich Frishman · Sabich Tchernichovsky · Oved Sabich (Givat Shmuel)",
        tip: "Pedir 'sabich shalem' (entero) con todas las salsas. La amba es opcional pero le da el toque.",
        venues: [
          { name: "Sabich Frishman 42", lat: 32.0830, lng: 34.7745 },
          { name: "Sabich Tchernichovsky", lat: 32.0720, lng: 34.7705 },
        ],
      },
      {
        id: "tlv-falafel",
        name: "Falafel",
        emoji: "🧆",
        what: "Bolitas de garbanzo molido y especias frito, servido en pita con hummus, tahini, ensaladas y pepinillos. Aparentemente simple, brutalmente bueno cuando está bien hecho. El falafel israelí es más verde por dentro que el de otros países — usan cilantro y perejil frescos.",
        where: "HaKosem (referencia de TLV) · Falafel Gabay · Miznon (con torsión gourmet)",
        tip: "Pedirlo recién frito, con la pita caliente. ~25 NIS.",
        venues: [
          { name: "HaKosem", lat: 32.0747, lng: 34.7720 },
          { name: "Falafel Gabay (Bezalel)", lat: 32.0762, lng: 34.7724 },
          { name: "Miznon (King George)", lat: 32.0775, lng: 34.7715 },
        ],
      },
      {
        id: "tlv-shakshuka",
        name: "Shakshuka",
        emoji: "🍳",
        what: "Huevos pochados en salsa picante de tomate, pimientos, cebolla, comino y paprika, servido en sartén caliente con pan para mojar. Origen norteafricano (Túnez, Libia), adoptado por los judíos mizrajíes y hoy desayuno israelí por antonomasia. Variantes: roja clásica, verde (con espinacas), 'matbucha' más espesa.",
        where: "Dr. Shakshuka (Jaffa, el más famoso) · Benedict (24h) · Café Noir · cualquier desayuno israelí",
        tip: "Pidan extra de pita para mojar. Con un café turco al lado es desayuno perfecto.",
        venues: [
          { name: "Dr. Shakshuka (Jaffa)", lat: 32.0530, lng: 34.7540 },
          { name: "Benedict (Rothschild)", lat: 32.0633, lng: 34.7715 },
        ],
      },
      {
        id: "tlv-bourekas",
        name: "Bourekas",
        emoji: "🥟",
        what: "Hojaldres rellenos: queso (gvina), espinaca-queso, papa, champiñón. Herencia de los judíos sefardíes balcánicos. Desayuno de mercado por excelencia — los bourekas calientes con un té con menta y un huevo cocido es ritual israelí.",
        where: "Bourekas Penso (Levinsky Market) · Bourekas Tunisiens · Mercado Carmel",
        tip: "Comerlos recién horneados. Los de espinaca-queso son los más clásicos.",
        venues: [
          { name: "Bourekas Penso (Levinsky)", lat: 32.0612, lng: 34.7705 },
          { name: "Mercado Carmel (varios puestos)", lat: 32.0700, lng: 34.7680 },
        ],
      },
      {
        id: "tlv-jachnun",
        name: "Jachnun · Malawach",
        emoji: "🫓",
        what: "Pan yemenita enrollado y cocido a fuego lento toda la noche del viernes (jachnun) o frito tipo crepe (malawach). Tradición de los judíos yemeníes. Se sirve con tomate rallado fresco, huevo cocido marrón (cocido 8h junto al pan) y zhug (salsa picante yemenita). Desayuno DE shabat por excelencia.",
        where: "Malabi-Cohen (Tikva) · Restaurantes yemenitas en Kerem HaTeimanim · Saluf & Sons",
        tip: "Buscar 'beit teimanim' (casa yemenita). El Kerem HaTeimanim (junto al Mercado Carmel) es el barrio yemenita histórico.",
        venues: [
          { name: "Saluf & Sons (Nahalat Binyamin)", lat: 32.0683, lng: 34.7707 },
          { name: "Barrio Kerem HaTeimanim", lat: 32.0720, lng: 34.7660 },
        ],
      },
      {
        id: "tlv-knafeh",
        name: "Knafeh",
        emoji: "🧀",
        what: "Postre árabe-palestino-libanés: fideos de kataifi crujientes sobre una capa de queso semi-fundido, bañados en almíbar de agua de rosas, espolvoreados con pistachos. Caliente y crujiente por fuera, derretido por dentro. El que se come en Jaffa es de los mejores del mundo.",
        where: "Said Abu Lafia (Jaffa, panadería 1880) · Hummus Shel Tehina (Florentin) · cafés árabes en Jaffa",
        tip: "Comerlo recién hecho, todavía caliente. La textura es la mitad de la experiencia.",
        venues: [
          { name: "Abu Lafia (Jaffa)", lat: 32.0541, lng: 34.7541 },
        ],
      },
      {
        id: "tlv-malabi",
        name: "Malabi",
        emoji: "🍮",
        what: "Postre israelí-mediooriental: budín de leche perfumado con agua de rosas, coronado con almíbar rojo, coco rallado y pistachos. Frío, ligero, perfecto en verano. Origen turco-libanés, pero adoptado por Israel como postre callejero.",
        where: "Malabi-Cohen (Yehuda HaLevi) · puestos en mercados · postres en cualquier restaurante mizrají",
        tip: "Ideal después de un día caluroso. Buscar el vaso plástico clásico vendido en la calle, no el de restaurante.",
        venues: [
          { name: "Malabi-Cohen (Yehuda HaLevi)", lat: 32.0680, lng: 34.7720 },
        ],
      },
      {
        id: "tlv-flo-eats",
        name: "Sabores de Florentin",
        emoji: "🍽️",
        what: "Su barrio. Florentin es el barrio bohemio-obrero de Tel Aviv, lleno de bares, talleres mecánicos, grafitis y comida honesta. Imprescindibles: Romano (cocina israelí moderna), Frishkash (sándwiches de pastrami), Beit Lechem (panadería del barrio), Cafelix (mejor café de filtro), Hummus Shel Tehina (hummus de barrio).",
        where: "Romano · Beit Lechem · Cafelix · Hummus Shel Tehina · Mercado Levinsky a 5 min",
        tip: "Caminar por la calle Florentin de noche es uno de los mejores planes baratos de TLV. Levinsky Market a 5 min para spices y delikatessen.",
        venues: [
          { name: "Cafelix Florentin", lat: 32.0588, lng: 34.7707 },
          { name: "Romano (Florentin)", lat: 32.0617, lng: 34.7713 },
          { name: "Hummus Shel Tehina", lat: 32.0595, lng: 34.7717 },
          { name: "Mercado Levinsky (cabecera)", lat: 32.0612, lng: 34.7705 },
        ],
      },
      {
        id: "tlv-limonana",
        name: "Limonana",
        emoji: "🍋",
        what: "Limonada con hojas de menta fresca batida, hielo y un toque de azúcar. La bebida nacional de Israel en verano. Refrescante, ácida-dulce-mentolada, vital con el calor de junio en TLV.",
        where: "Cualquier café, restaurante o puesto callejero. Mejor en los mercados.",
        tip: "En los mercados (Carmel, Levinsky) la sirven recién batida frente a uno por ~15 NIS.",
        venues: [
          { name: "Mercado Carmel", lat: 32.0700, lng: 34.7680 },
          { name: "Mercado Levinsky", lat: 32.0612, lng: 34.7705 },
        ],
      },
      {
        id: "tlv-goldstar",
        name: "Goldstar / cervezas israelíes",
        emoji: "🍺",
        what: "Goldstar (oscura) y Maccabee (lager) son las cervezas industriales clásicas, parte del paisaje. Pero la escena craft israelí ha explotado: Alexander, Malka, Negev, Dancing Camel. Lo bueno: muchos bares de Florentin y Rothschild las tienen tap.",
        where: "Bares de Florentin (Rothschild Allenby) · Beer Bazaar (Allenby & Carmel) · Dancing Camel (Florentin)",
        tip: "Dancing Camel está a 10 min andando de Herzl 62 — cervecería local con tour si les interesa.",
        venues: [
          { name: "Dancing Camel Brewery (Florentin)", lat: 32.0585, lng: 34.7755 },
          { name: "Beer Bazaar (Allenby)", lat: 32.0703, lng: 34.7693 },
        ],
      },
    ],
  },

  // ============== TICKETS · QUÉ COMPRAR Y CUÁNDO ==============
  // Tipos: "free" (gratis), "onsite" (se paga en la entrada, sin reserva), "advance" (REQUIERE compra anticipada)
  tickets: {
    "bud-castillo": { status: "free", note: "Patio y jardines del castillo: gratis. Museo de Historia y Galería Nacional Húngara: ticket aparte (~3.000 HUF c/u), se compra en la entrada." },
    "bud-matias": { status: "onsite", price: "2.500 HUF (~€6)", url: "matyas-templom.hu", note: "Compra en taquilla. Ticket combinado iglesia + torre: ~4.500 HUF. La torre tiene cupos por hora limitados — comprar al llegar." },
    "bud-bastion": { status: "free+paid", price: "1.000 HUF (terraza superior)", note: "La terraza baja y los miradores principales son GRATIS. Solo la terraza superior (las torres altas) cobra ~1.000 HUF. La vista del Parlamento se ve perfecto desde lo gratis." },
    "bud-funicular": { status: "onsite", price: "1.800 HUF ida (~€4.5) · 3.000 HUF ida y vuelta", note: "Compra en la base. Tarjeta o efectivo." },
    "bud-parlamento": { status: "advance", price: "Adultos UE/no-UE €15/€21", url: "jegymester.hu/parlament", note: "⭐ RESERVA ANTICIPADA OBLIGATORIA. Cupos en español agotan 2–3 semanas antes. Comprar apenas tengan fechas firmes." },
    "bud-zapatos": { status: "free", note: "Memorial al aire libre, gratis 24h." },
    "bud-basilica": { status: "free+paid", price: "Iglesia: donación €2 · Cúpula (mirador 360°): €8", url: "bazilika.biz", note: "Iglesia con donación simbólica. Para subir a la cúpula: ticket €8, se compra ahí mismo." },
    "bud-andrassy": { status: "free", note: "Es la avenida — gratis caminarla. Ópera y museos en el camino con tickets aparte." },
    "bud-dohany": { status: "advance", price: "€34 adultos (incluye Museo Judío + cementerio + Templo de los Héroes + Árbol de la Vida)", url: "jewishtourhungary.com", note: "⭐ MUY recomendable comprar online — fila de 1h+ en taquilla. Tour guiado en español sale en horarios fijos." },
    "bud-arbol": { status: "free", note: "Incluido en el ticket de la Gran Sinagoga de Dohány. Sin acceso independiente." },
    "bud-kazinczy": { status: "onsite", price: "€4 (1.500 HUF)", note: "Compra en la entrada. Cerrada los sábados (Shabat)." },
    "bud-rumbach": { status: "onsite", price: "€6 (2.500 HUF)", note: "Compra en la entrada. Cerrada los sábados." },
    "bud-szimpla": { status: "free", note: "Entrada libre. Se paga lo que se consume." },
    "bud-heroes-square": { status: "free", note: "Plaza pública, gratis 24h. Los dos museos a sus lados (Bellas Artes y Műcsarnok): ticket aparte 3.500–6.000 HUF." },
    "bud-city-park": { status: "free", note: "Parque público gratis. El Zoo y el Castillo Vajdahunyad interiores: ticket aparte 3.000–6.000 HUF." },
    "bud-szechenyi-baths": { status: "advance", price: "Día completo Lun–Jue: 11.000 HUF (~€27) · Vie–Dom: 12.500 HUF · Tarde (3h): 9.000 HUF", url: "szechenyifurdo.hu", note: "Reserva online ahorra tiempo en taquilla. Llevan traje de baño, toalla, chanclas (o alquilan)." },
    "bud-gellert-hill": { status: "free", note: "Subida pública. El bus 27 desde Móricz Zsigmond körtér los acerca a la cima por ~600 HUF." },
    "bud-house-of-terror": { status: "advance", price: "4.000 HUF adultos (~€10)", url: "terrorhaza.hu/en/tickets", note: "Compra online recomendada. Audio guía en español incluido." },
    "bud-opera": { status: "advance", price: "Tour guiado: 5.500 HUF · Función: desde 3.000 HUF", url: "opera.hu", note: "Tours 13:00, 14:30 y 16:00. Funciones de junio: revisar calendario online." },
    "bud-parlamento-extra-spanish": { status: "info", note: "Tip: cupos en español son ~3 al día. Si no encuentran español, tomen en inglés — el contenido es el mismo." },

    "prg-ciudad-vieja": { status: "free", note: "Plaza gratis. Subir a la Torre del Ayuntamiento (vista 360°): 250 CZK aparte, se compra ahí." },
    "prg-reloj": { status: "free", note: "El espectáculo del reloj es gratis (cada hora en punto, desde la plaza)." },
    "prg-tyn": { status: "free", note: "Entrada gratis con donación sugerida (40 CZK). Horarios reducidos — revisar." },
    "prg-puente-carlos": { status: "free", note: "Puente peatonal, gratis 24h. La torre del puente (Mostecká věž) con vista del puente: 200 CZK aparte." },
    "prg-castillo": { status: "advance", price: "Circuito B (recomendado): 250 CZK · Circuito A (completo): 450 CZK", url: "hrad.cz", note: "Patio y jardines: gratis. Para entrar a Catedral, Palacio Real y Callejón de Oro: ticket B. Comprar online ahorra fila." },
    "prg-san-vito": { status: "free+paid", note: "Hay una zona pública gratis (entran al narthex). Para ver el vitral de Mucha y la nave entera: incluido en ticket B del Castillo." },
    "prg-callejon-oro": { status: "free+paid", note: "De día (09:00–17:00): incluido en ticket del Castillo. DESPUÉS de las 17:00: entrada GRATIS (con menos exposiciones)." },
    "prg-mala-strana": { status: "free", note: "Barrio entero, gratis caminar." },
    "prg-nerudova": { status: "free", note: "Calle pública." },
    "prg-wallenstein": { status: "free", note: "Jardines gratis, Abr–Oct 07:30–18:00. Pavos reales sueltos incluidos." },
    "prg-san-nicolas": { status: "onsite", price: "Adultos 140 CZK · Torre del campanario: 190 CZK aparte", note: "Compra en la entrada." },
    "prg-pinkas": { status: "advance", price: "Ticket combinado Museo Judío: 500 CZK adultos (incluye Pinkas + Cementerio + Klausen + Maisel + Española + Sala Ceremonial)", url: "jewishmuseum.cz", note: "⭐ MEJOR comprar online — un solo ticket para todo el barrio. CERRADO sábados (Shabat) y festivos judíos.", bundle: ["prg-cementerio", "prg-klausen", "prg-maisel", "prg-espanola"] },
    "prg-cementerio": { status: "advance", note: "Incluido en el ticket combinado del Museo Judío (500 CZK). CERRADO sábados.", includedIn: "prg-pinkas" },
    "prg-klausen": { status: "advance", note: "Incluida en el ticket combinado. Cerrada sábados.", includedIn: "prg-pinkas" },
    "prg-maisel": { status: "advance", note: "Incluida en el ticket combinado. Cerrada sábados.", includedIn: "prg-pinkas" },
    "prg-espanola": { status: "advance", note: "Incluida en el ticket combinado. Cerrada sábados.", includedIn: "prg-pinkas" },
    "prg-vieja-nueva": { status: "onsite", price: "220 CZK adultos", url: "synagogue.cz", note: "⚠️ Ticket APARTE — no incluida en el combinado del Museo Judío. Compra en la puerta. Cerrada sábados y festivos." },
    "prg-kafka": { status: "free", note: "Escultura pública en exterior. Gratis." },
    "prg-dancing-house": { status: "free+paid", price: "Exterior: gratis · Glass Bar terraza: ~250 CZK consumo mínimo · Galería arte (interior): 250 CZK", url: "tadu.cz", note: "Verla por fuera es gratis (la mejor toma es desde el puente Jiráskův Most). Para subir al bar-terraza del último piso hay que consumir (un drink ~200 CZK)." },
    "prg-vysehrad": { status: "free+paid", note: "Parque y vistas: gratis. Casemates y exposiciones interiores: 90 CZK." },
    "prg-wenceslas-square": { status: "free", note: "Plaza pública." },
    "prg-lennon-wall": { status: "free", note: "Muro al aire libre, gratis 24h. Plumones se aceptan." },
    "prg-kampa": { status: "free", note: "Isla-parque pública. El Museo Kampa (arte moderno checo, adentro) cobra 320 CZK." },
    "prg-petrin": { status: "free+paid", price: "Torre: 200 CZK · Funicular: incluido con ticket de transporte (~40 CZK) o pase 90 min/24h", note: "Las áreas verdes y la subida a pie son gratis. La torre, el laberinto y el observatorio cobran entrada por separado." },
    "prg-mucha-museum": { status: "onsite", price: "320 CZK adultos", url: "mucha.cz", note: "Compra en taquilla. Audioguía en español." },
    "prg-obecni-dum-building": { status: "free+paid", note: "Hall y café: gratis. Tour guiado de salas: 290 CZK. Conciertos Sala Smetana: desde 600 CZK." },
    "prg-vinohrady": { status: "free", note: "Barrio — gratis caminar." },
    "prg-terezin-fortaleza": { status: "advance", price: "✅ Incluido en tu tour de Nattivus (Torres de Praga) · ref NTT76562474", url: "nattivus.com/es/praga/excursion-terezin", note: "🚐 Tu tour de Nattivus (6h, en español) incluye TODAS las entradas al complejo de Terezín — Fortaleza Pequeña, Museo del Gueto, Magdeburg y Cementerio Nacional. Salida viernes 5 jun · 09:00 · punto de encuentro: Billa, V Celnici 4 (metro Náměstí Republiky · línea B). Lleguen 08:45. Toca \"Marcar como comprado\" para confirmar.", bundle: ["prg-terezin-museo", "prg-terezin-magdeburg", "prg-terezin-cementerio"] },
    "prg-terezin-museo": { status: "advance", note: "Incluido en tu tour de Nattivus · ref NTT76562474 (ya reservado).", includedIn: "prg-terezin-fortaleza" },
    "prg-terezin-magdeburg": { status: "advance", note: "Incluido en tu tour de Nattivus · ref NTT76562474 (ya reservado).", includedIn: "prg-terezin-fortaleza" },
    "prg-terezin-cementerio": { status: "advance", note: "Incluido en tu tour de Nattivus · ref NTT76562474 (ya reservado).", includedIn: "prg-terezin-fortaleza" },

    "mad-plaza-mayor": { status: "free", note: "Plaza pública." },
    "mad-prado": { status: "free+paid", price: "Entrada general €15 · GRATIS Lun–Sáb 18:00–20:00 y Dom 17:00–19:00", url: "museodelprado.es", note: "En la franja gratis: filas largas pero rotación rápida. Llegar 30 min antes." },
    "bcn-palau-musica": { status: "advance", price: "€20 visita guiada (español)", url: "palaumusica.cat", note: "⚠️ Reservar online sí o sí. Slot 10:00 ideal para empezar el día. Sin ticket adelantado pueden quedarse fuera. Lunes hay visitas." },
    "bcn-7-portes": { status: "advance", price: "€35-45/pax (paella + ensalada + bebida)", url: "7portes.com", note: "Reservar 2-3 días antes — los lunes al mediodía Cal Pep no abre y Bar del Pla está cerrado." },
    "bcn-santa-caterina": { status: "free", note: "Mercado público, entrada libre." },
  },

  // ============== FREE WALKING TOURS ==============
  // Pay-what-you-want (~€10–15 de propina). Reservar online el día antes — los cupos en español a veces se llenan.
  freeTours: [
    {
      id: "ft-bud-general",
      city: "Budapest",
      dayRecommended: "d1",
      title: "Tour clásico de Pest (general)",
      operator: "Free Budapest Walking Tours",
      url: "freebudapestwalkingtours.com",
      duration: "2,5 h",
      meeting: "Erzsébet tér, junto a la fuente Akvárium · 47.4977, 19.0529",
      meetingLat: 47.4977,
      meetingLng: 19.0529,
      times: "10:30 y 14:30 todos los días",
      language: "Español e inglés",
      summary: "Introducción al lado Pest: Plaza Vörösmarty, Basílica, Parlamento desde afuera, Avenida Andrássy, contexto histórico desde Atila hasta la caída del muro. Ideal el primer día para orientarse.",
      tip: "Reservar online el día anterior. Llegar 15 min antes — el guía busca a quien usa la app o lleva una hoja impresa.",
      jewish: false,
    },
    {
      id: "ft-bud-jewish",
      city: "Budapest",
      dayRecommended: "d3",
      title: "Tour del Barrio Judío",
      operator: "Generation Tours",
      url: "generationtours.com",
      duration: "2,5 h",
      meeting: "En frente de la Gran Sinagoga de Dohány · 47.4956, 19.0610",
      meetingLat: 47.4956,
      meetingLng: 19.0610,
      times: "10:00 todos los días (excepto sábado)",
      language: "Inglés",
      summary: "Recorrido por el gueto histórico: las tres sinagogas (Dohány, Kazinczy, Rumbach por fuera), el Memorial del Holocausto, el patio del Árbol de la Vida, anécdotas de Theodor Herzl, Karl Lutz y los Justos entre las Naciones. Las entradas a las sinagogas son aparte.",
      tip: "Llevar agua. Reservar online — cupos en español puntuales, mejor optar por inglés. ESTE tour es la mejor introducción al barrio antes de visitar las sinagogas con ticket aparte.",
      jewish: true,
    },
    {
      id: "ft-bud-communism",
      city: "Budapest",
      dayRecommended: "d2",
      title: "Tour del Comunismo y la Hungría socialista",
      operator: "Free Budapest Walking Tours",
      url: "freebudapestwalkingtours.com",
      duration: "2,5 h",
      meeting: "Erzsébet tér, fuente Akvárium · 47.4977, 19.0529",
      meetingLat: 47.4977,
      meetingLng: 19.0529,
      times: "14:30 los miércoles, viernes y domingos",
      language: "Inglés",
      summary: "La revolución de 1956, el régimen Kádár, la vida cotidiana bajo el comunismo, la transición del 89, escándalos políticos contemporáneos. Pasan por la Casa del Terror y el monumento a 1956.",
      tip: "Si calza, complementen con la visita a la Casa del Terror (museo, ticket aparte €15).",
      jewish: false,
    },
    {
      id: "ft-bud-buda",
      city: "Budapest",
      dayRecommended: "d2",
      title: "Tour del Castillo de Buda",
      operator: "Free Budapest Walking Tours",
      url: "freebudapestwalkingtours.com",
      duration: "2 h",
      meeting: "Plaza Clark Ádám tér (al pie del Puente de las Cadenas, lado Buda) · 47.4990, 19.0414",
      meetingLat: 47.4990,
      meetingLng: 19.0414,
      times: "10:30 todos los días",
      language: "Inglés",
      summary: "Sube al lado Buda con un local: el funicular, el Distrito del Castillo, la Iglesia Matías por fuera, el Bastión de los Pescadores, leyendas medievales y vistas al Danubio. Ideal el día 2 para conocer el lado de las colinas.",
      tip: "Cuesta arriba — calzado cómodo. El tour no entra a museos (esos son ticket aparte).",
      jewish: false,
    },

    {
      id: "ft-prg-general",
      city: "Praga",
      dayRecommended: "d4",
      title: "Tour clásico de la Ciudad Vieja y Castillo",
      operator: "Prague Extravaganza Free Tour",
      url: "extravaganzafreetour.com",
      duration: "3 h",
      meeting: "Bajo el Reloj Astronómico (Plaza de la Ciudad Vieja) · 50.0870, 14.4208",
      meetingLat: 50.0870,
      meetingLng: 14.4208,
      times: "11:00 y 14:00 todos los días",
      language: "Inglés (tours en español: pragueglobal.com)",
      summary: "El tour más completo: Plaza de la Ciudad Vieja, Casa Municipal, Torre de la Pólvora, calle Celetná, Puente Carlos, subida a Mala Strana y panorámica del Castillo desde abajo. Excelente como llegada el día 4.",
      tip: "Llevar agua y calzado cómodo (3h caminando). Si prefieren español, prueben PragueGlobal — mismo concepto, en castellano.",
      jewish: false,
    },
    {
      id: "ft-prg-jewish",
      city: "Praga",
      dayRecommended: "d6",
      title: "Tour del Barrio Judío (Josefov)",
      operator: "Sandemans New Europe",
      url: "neweuropetours.eu/prague/free-tours/jewish-quarter",
      duration: "2,5 h",
      meeting: "Estatua de Kafka (frente a Sinagoga Española) · 50.0901, 14.4220",
      meetingLat: 50.0901,
      meetingLng: 14.4220,
      times: "14:00 todos los días (excepto sábado)",
      language: "Inglés",
      summary: "Recorrido externo por las seis sinagogas del Museo Judío y el cementerio, historia milenaria del gueto, leyenda del Golem, vida de Kafka, deportaciones nazis y reconstrucción. Las entradas son ticket aparte.",
      tip: "PLAN B IDEAL PARA SHABAT: si el sábado las sinagogas están cerradas, este tour las recorre por fuera y aprovecha cada minuto. Combinar con la Sinagoga Vieja-Nueva (ticket aparte, abierta domingos a viernes).",
      jewish: true,
    },
    {
      id: "ft-prg-communism",
      city: "Praga",
      dayRecommended: "d5",
      title: "Tour de Comunismo y Bombardeo Nazi",
      operator: "Prague Extravaganza",
      url: "extravaganzafreetour.com",
      duration: "2,5 h",
      meeting: "Plaza de Wenceslao, junto a la estatua · 50.0810, 14.4275",
      meetingLat: 50.0810,
      meetingLng: 14.4275,
      times: "10:30 los lun, mié, vie y sáb",
      language: "Inglés",
      summary: "La invasión nazi, el atentado al carnicero Heydrich, la Primavera de Praga del 68, la Revolución de Terciopelo del 89, Václav Havel, vida cotidiana bajo el régimen. Pasa por la Plaza de Wenceslao, el monumento a Jan Palach y los lugares de las protestas.",
      tip: "Combinar con el Museo del Comunismo (10 min a pie, ticket €10) si quieren profundizar.",
      jewish: false,
    },
    {
      id: "ft-prg-castle",
      city: "Praga",
      dayRecommended: "d5",
      title: "Tour del Castillo y Mala Strana",
      operator: "Sandemans / Prague Extravaganza",
      url: "neweuropetours.eu/prague",
      duration: "2,5 h",
      meeting: "Entrada principal del Castillo (Hradčanské náměstí) · 50.0915, 14.3990",
      meetingLat: 50.0915,
      meetingLng: 14.3990,
      times: "14:00 todos los días",
      language: "Inglés",
      summary: "Recorre el complejo del Castillo POR FUERA, los jardines, baja por la calle Nerudova, pasa por la Iglesia de San Nicolás de Mala Strana y llega al Puente Carlos. Las entradas a Catedral/Palacio Real son aparte (ticket B).",
      tip: "Buena complementación: hacer este tour en la mañana para entender el conjunto, después comprar el ticket B y entrar a la Catedral y el Palacio por la tarde.",
      jewish: false,
    },
    {
      id: "ft-mad-general",
      city: "Madrid",
      dayRecommended: "d15",
      title: "Tour clásico del Madrid de los Austrias",
      operator: "Madrid Free Walking Tours",
      url: "ogotours.com/madrid-free-walking-tour",
      duration: "2,5 h",
      meeting: "Plaza Mayor, junto a la estatua de Felipe III · 40.4155, -3.7074",
      meetingLat: 40.4155,
      meetingLng: -3.7074,
      times: "11:00 y 14:00 todos los días",
      language: "Español",
      summary: "Plaza Mayor, Casa de la Villa, Mercado de San Miguel, Catedral de la Almudena, Palacio Real (por fuera), Plaza de Oriente. Para aprovechar el día completo en Madrid antes del vuelo nocturno.",
      tip: "Si tienen vuelo a las 23:59 y el día 15 entero en Madrid: hagan el tour a las 11:00, almuercen tarde, descansen en el hotel y al aeropuerto a las 21:00.",
      jewish: false,
    },
  ],

  // ============== TIPS PRÁCTICOS POR CIUDAD ==============
  // Curados de Mochileando por el Mundo + experiencia local. Para no cometer errores típicos de viajero.
  tips: {
    Budapest: {
      flag: "🇭🇺",
      currency: "Florín húngaro (HUF) · 1€ ≈ 400 HUF · Hungría NO usa el euro aunque esté en la UE.",
      source: "Basado en mochileandoporelmundo.com + experiencia local",
      sections: [
        {
          icon: "💳",
          title: "Dinero y tarjetas",
          items: [
            "Lleven Revolut o N26 (sin comisiones por sacar en cajero). Idealmente las dos por si una falla, más una tarjeta del banco como backup.",
            "NO cambien en el aeropuerto — el tipo de cambio es pésimo. Hay casas de cambio en casi cada cuadra del centro; comparar siempre 2–3.",
            "Eviten la casa de cambio 'Change Group' del centro: márgenes abusivos. Mejor 'Correct Change' (varias sucursales).",
            "Casi todo se paga con tarjeta. Tener algo de efectivo (~10.000 HUF) sólo para mercados pequeños o el termal.",
          ],
        },
        {
          icon: "✈️",
          title: "Del aeropuerto al centro",
          items: [
            "Bus 100E directo al centro (~3€ / 2.200 HUF). Paradas: Kálvin tér · Astoria · Deák Ferenc tér. Sale cada 20 min, tarda 35–45 min.",
            "Comprar el ticket del 100E ANTES de subir (máquinas en la terminal). No vale el ticket urbano normal.",
            "Taxi/Uber al centro: ~25–30€. Hay un taxi oficial (Főtaxi) con tarifas fijas — sí, evitar taxis no oficiales.",
          ],
        },
        {
          icon: "🚇",
          title: "Transporte público",
          items: [
            "Billete sencillo: 450 HUF (~1,20€). Pase diario: 2.500 HUF (~6,7€). 72h: 5.500 HUF (~15€).",
            "Validar SIEMPRE el ticket en la máquina amarilla al entrar al metro o subir al bus/tranvía — multan al turista sin compasión.",
            "Hay 4 líneas de metro. La M1 ('amarilla') es la primera línea continental de Europa (1896), vagones originales restaurados.",
            "Mayores de 65 años de la UE viajan GRATIS (no aplica a Uds., pero útil saber).",
            "Como alternativa al crucero turístico: línea de barco público D-11/D-12 (~2,5€) recorre el Danubio.",
          ],
        },
        {
          icon: "📅",
          title: "Cuándo y cuánto tiempo",
          items: [
            "Mayo y septiembre son los mejores meses: buen tiempo, menos turistas. Su viaje (junio) está en buena ventana.",
            "Mínimo 2 días, ideal 3–4. Uds. tienen 3 días — alcanza para Buda + Pest + Barrio Judío sin correr.",
            "El sábado el barrio judío está parcialmente cerrado (Shabat). Planifiquen sinagogas en domingo o jueves.",
          ],
        },
        {
          icon: "🎫",
          title: "Tickets y reservas",
          items: [
            "Parlamento: RESERVAR online en jegymester.hu/parlament con anticipación. No residentes UE pagan el doble (~€21).",
            "Sinagoga de Dohány: ticket online evita 1h+ de cola. Tour guiado en español sale en horarios fijos.",
            "Termal Széchenyi: reserva online ahorra tiempo. Llevar traje de baño, toalla y chanclas (o alquilan).",
            "Budapest Card: 33€/1d, 49€/2d — solo conviene si piensan entrar a MUCHOS museos. Verifiquen sus tickets antes de comprarla.",
          ],
        },
        {
          icon: "💡",
          title: "Costumbres y cultura",
          items: [
            "Propina: 10–15% en restaurantes (a veces ya viene incluida — verifiquen 'service charge' en la cuenta).",
            "El 'goulash' que conocen es SOPA aquí (gulyás). Lo que llamamos goulash espeso aquí se llama 'pörkölt'.",
            "Saludos: 'Szia' (hola informal), 'Jó napot' (formal). 'Köszönöm' (gracias). 'Egészségére!' al brindar.",
            "Los húngaros se apellidan al revés: apellido primero, nombre después. En tickets/reservas oficiales lo pondrán así.",
          ],
        },
        {
          icon: "🍻",
          title: "Imprescindibles que NO se pierdan",
          items: [
            "Mejor atardecer: Bastión de los Pescadores, una hora antes del ocaso (luz dorada sobre el Parlamento).",
            "Ruin pubs: Szimpla Kert es el más famoso (a veces hay tour guiado de ruin bars).",
            "Un crucero corto por el Danubio al atardecer (Budapest se ve totalmente distinta desde el agua).",
            "Tomar el M1 amarillo al menos una estación — los vagones originales son una experiencia.",
            "Pálinka en copita: pedirlo 'házi' (casero) si encuentran un bar viejo de barrio.",
          ],
        },
      ],
    },
    Praga: {
      flag: "🇨🇿",
      currency: "Corona checa (CZK) · 1€ ≈ 25 CZK · Chequia NO usa el euro.",
      source: "Basado en mochileandoporelmundo.com + experiencia local",
      sections: [
        {
          icon: "💳",
          title: "Dinero y tarjetas",
          items: [
            "Lleven Revolut o N26 (sin comisiones por sacar en cajero). Complementen con la tarjeta del banco habitual.",
            "NO cambien en el aeropuerto — pésimo cambio. Hay casas de cambio en el centro; comparar 2–3.",
            "EVITAR cajeros 'Euronet' (los amarillos/azules en cada esquina turística) — cobran tasas brutales. Usar cajeros de bancos (ČSOB, Komerční Banka, Česká Spořitelna).",
            "Cuidado con el truco: si el cajero o el TPV ofrece 'cambio garantizado en euros', siempre digan NO — paguen en CZK, su banco aplica un tipo mejor.",
          ],
        },
        {
          icon: "✈️",
          title: "Del aeropuerto al centro",
          items: [
            "Bus 119 → metro línea A (Nádraží Veleslavín). Para el centro / Castillo / Vieja Praga.",
            "Bus 100 → metro línea B (Zličín). Útil si su hotel está en la zona sur o este.",
            "Boleto único bus+metro 90 min: 40 CZK (~1,60€). Comprar en la máquina del aeropuerto antes de subir.",
            "Traslado privado: ~15€/pax (reservable online). Uber/Bolt: ~30€. Taxi oficial 'AAA Radiotaxi': ~25€.",
            "Evitar taxis sin marcar en el aeropuerto: el clásico timo praguense.",
          ],
        },
        {
          icon: "🚇",
          title: "Transporte público",
          items: [
            "Billete sencillo 30 min: 30 CZK. 90 min: 40 CZK. Pase diario: 120 CZK (~5€) — viajes ilimitados, conviene casi siempre.",
            "Validar el ticket en la máquina amarilla al entrar al metro o subir al tranvía/bus. Multa por no validar: 1.000 CZK.",
            "Aplicación 'PID Lítačka' (oficial): compra de tickets digitales y plano del sistema. Útil tenerla.",
            "El metro tiene sólo 3 líneas (A verde, B amarilla, C roja). Praga se camina muy bien — usen el metro sólo para tramos largos.",
          ],
        },
        {
          icon: "📅",
          title: "Cuándo y cuánto tiempo",
          items: [
            "Abril a septiembre es ideal. Junio (su viaje) = días largos, calor moderado, menos lluvia que otros meses.",
            "Julio y agosto se pone caluroso y MUY turístico. Junio es una ventana perfecta antes del pico.",
            "Mínimo 2 días, ideal 3–4. Uds. tienen 4 días — espacio para excursión a Terezín si quieren.",
            "El SÁBADO el barrio judío entero está cerrado (Shabat). Reserven Pinkas/Maisel/Cementerio para domingo/lunes.",
          ],
        },
        {
          icon: "🎫",
          title: "Tickets y reservas",
          items: [
            "Castillo de Praga: comprar online el Circuito B (250 CZK) — incluye Catedral, Palacio Real, Callejón del Oro. Ahorra cola.",
            "Museo Judío: ticket combinado 500 CZK incluye Pinkas + Cementerio + Klausen + Maisel + Española. Comprar online.",
            "Sinagoga Vieja-Nueva: ticket APARTE (220 CZK), no incluida en el combinado.",
            "Praga Card: solo conviene si entran a muchos museos. Hacer cuentas — a Uds. probablemente NO les compense (la mayoría de visitas son gratis o sueltas).",
          ],
        },
        {
          icon: "💡",
          title: "Costumbres y cultura",
          items: [
            "Propina: 10% en restaurantes (suele añadirse 'spropitné' a la cuenta — verificar). Dejar redondeo si no.",
            "Los checos son secos al principio pero amables. No esperar la calidez mediterránea — es directo, no antipático.",
            "Saludos básicos: 'Dobrý den' (buenos días formal), 'Děkuji' (gracias), 'Na zdraví!' (¡salud!).",
            "Cerveza más barata que el agua: literal. Chequia es el país que más cerveza bebe del mundo per cápita.",
            "Pedir 'pivo z tanku' (cerveza de tanque, sin pasteurizar) — diferente a la embotellada. Lokál Dlouhááá es la referencia.",
          ],
        },
        {
          icon: "⚠️",
          title: "Trampas turísticas a evitar",
          items: [
            "Trdelník vendido como 'pastel tradicional praguense' — NO LO ES (es transilvano, llegó en los 2000).",
            "Casas de cambio con cartel '0% COMMISSION' — cobran en el spread. Comparar siempre.",
            "Restaurantes en la Plaza Vieja con 'menú turístico' de pizarra — sobreprecios. Caminar 2 cuadras hacia las calles laterales mejora todo.",
            "Conciertos de Vivaldi / Mozart con flyer en la calle: la calidad varía mucho. Si quieren ir, busquen reseñas del lugar concreto antes.",
          ],
        },
        {
          icon: "🌍",
          title: "Excursiones recomendadas (si sobra día)",
          items: [
            "Terezín (1h en bus): campo de concentración, memorial del Holocausto. Excursión organizada o tren + bus.",
            "Český Krumlov (3h ida): pueblo medieval declarado UNESCO, casi de cuento.",
            "Kutná Hora (1h en tren): impresionante Iglesia de los Huesos (Sedlec Ossuary) y catedral gótica.",
            "Karlovy Vary (2h): balneario imperial con aguas termales — ambiente belle époque.",
          ],
        },
      ],
    },
  },

  // ============== RESTAURANTES TRADICIONALES POR CIUDAD ==============
  // Lista curada con precio, rating Google (aprox.), cocina y barrio.
  // price: 1=$ (<€15), 2=$$ (€15-35), 3=$$$ (€35-65), 4=$$$$ (€65+)
  restaurants: {
    Budapest: [
      { id: "r-bud-rosenstein", name: "Rosenstein", cuisine: "Húngara · judía", price: 3, rating: 4.6, area: "Distrito VIII", address: "Mosonyi u. 3", lat: 47.5004, lng: 19.0773, hours: "Lun–Sáb 12:00–23:00 · Dom cerrado", signature: "Sólet con ganso ahumado, gulyás", noPork: true, jewish: true, reserve: "+36 1 333 3492 · rosenstein.hu", tip: "El más auténtico húngaro-judío de la ciudad. Reservar siempre." },
      { id: "r-bud-spinoza", name: "Spinoza Café", cuisine: "Húngara · judía", price: 2, rating: 4.4, area: "Barrio Judío · Dob u. 15", address: "Dob u. 15", lat: 47.4960, lng: 19.0598, hours: "Lun–Mié 17–23 · Jue–Dom 12–23", signature: "Sopa de ganso con matzá, flódni", noPork: true, jewish: true, reserve: "+36 1 413 7488 · spinoza-restaurant.hu", tip: "Música en vivo todas las noches. Klezmer los viernes." },
      { id: "r-bud-mazel-tov", name: "Mazel Tov", cuisine: "Israelí · mediterránea", price: 2, rating: 4.4, area: "Barrio Judío", address: "Akácfa u. 47", lat: 47.4970, lng: 19.0631, hours: "12:00–01:00", signature: "Mezzes, sabich, shakshuka", noPork: true, jewish: true, reserve: "+36 70 626 4280 · mazeltov.hu", tip: "Reservar — siempre lleno. Patio con plantas y música." },
      { id: "r-bud-carmel", name: "Carmel Étterem", cuisine: "Judía húngara", price: 2, rating: 4.3, area: "Barrio Judío · Kazinczy", address: "Kazinczy u. 31", lat: 47.4956, lng: 19.0630, hours: "Lun–Jue 12–22 · Vie hasta Shabat · Sáb cerrado", signature: "Sólet, ganso asado, csirkepaprikás", noPork: true, jewish: true, tip: "Cocina kosher-style (no estricto kosher pero sin cerdo/mariscos)." },
      { id: "r-bud-macesz", name: "Macesz Huszár", cuisine: "Judía húngara", price: 2, rating: 4.3, area: "Barrio Judío", address: "Dob u. 26", lat: 47.4979, lng: 19.0620, hours: "Dom–Jue 12–22 · Vie 12–15 · Sáb cerrado", signature: "Pollo paprika, sólet, kugel", noPork: true, jewish: true, tip: "Pequeño y familiar. Menú del día barato al almuerzo." },
      { id: "r-bud-hungarikum", name: "Hungarikum Bisztró", cuisine: "Húngara tradicional", price: 2, rating: 4.5, area: "Lipótváros", address: "Steindl Imre u. 13", lat: 47.5028, lng: 19.0511, hours: "12:00–22:30", signature: "Gulyás, paprikás csirke, somlói galuska", noPork: false, noPorkNote: "Tiene cerdo pero alternativas sobran", reserve: "Reservar online", tip: "Cerca del Parlamento. Acordeón en vivo algunas noches." },
      { id: "r-bud-frici", name: "Frici Papa Kifőzdéje", cuisine: "Húngara casera", price: 1, rating: 4.4, area: "Barrio Judío", address: "Király u. 55", lat: 47.5057, lng: 19.0631, hours: "Lun–Sáb 11–22", signature: "Menú del día por €6 — comida casera", noPork: false, noPorkNote: "Tiene cerdo, pero también pollo y res", tip: "Almuerzo abundante a precio de cocina familiar. Sin reservas." },
      { id: "r-bud-stand25", name: "Stand25 Bisztró", cuisine: "Húngara contemporánea", price: 3, rating: 4.6, area: "Buda · Castillo", address: "Hunyadi János út 25", lat: 47.4998, lng: 19.0349, hours: "Mar–Sáb 12–22", signature: "Bib Gourmand · gulyás reinventado, krémes", noPork: false, noPorkNote: "Hay cerdo, hay alternativas", reserve: "+36 30 961 3262 · stand25.hu", tip: "Chef Tamás Széll (Bocuse d'Or). Reservar con días." },
      { id: "r-bud-borkonyha", name: "Borkonyha Winekitchen", cuisine: "Húngara con vinos", price: 3, rating: 4.7, area: "Lipótváros", address: "Sas u. 3", lat: 47.5021, lng: 19.0530, hours: "Lun–Sáb 12–24", signature: "Michelin estrella · carta corta de mercado", noPork: false, noPorkNote: "Hay cerdo, varias alternativas", reserve: "borkonyha.hu", tip: "Una estrella Michelin asequible. Maridaje de vinos húngaros." },
      { id: "r-bud-kehli", name: "Kéhli Vendéglő", cuisine: "Húngara clásica", price: 2, rating: 4.5, area: "Óbuda", address: "Mókus u. 22", lat: 47.5400, lng: 19.0427, hours: "12–23", signature: "Sopa de tuétano (favorita del escritor Gyula Krúdy), ganso", noPork: false, noPorkNote: "Múltiples platos de cerdo y alternativas", reserve: "+36 1 250 4241", tip: "1899. Restaurante histórico, ambiente de taberna magyar. Lejos del centro." },
      { id: "r-bud-bors", name: "Bors GasztroBár", cuisine: "Sopas y bocadillos creativos", price: 1, rating: 4.6, area: "Barrio Judío", address: "Kazinczy u. 10", lat: 47.4964, lng: 19.0610, hours: "Lun–Sáb 11:30–21", signature: "Sopas exóticas + baguettes calientes", noPork: false, tip: "Local minúsculo. Para almuerzo rápido. Sin asientos — para llevar." },
      { id: "r-bud-cafe-koer", name: "Café Kör", cuisine: "Húngara · internacional", price: 2, rating: 4.5, area: "Cerca Basílica", address: "Sas u. 17", lat: 47.5011, lng: 19.0530, hours: "Lun–Sáb 10–22", signature: "Almuerzo de mercado · platos del día", noPork: false, noPorkNote: "Hay cerdo, opciones de pescado/pollo", reserve: "+36 1 311 0053", tip: "Clásico del barrio. Almuerzos abundantes." },
      { id: "r-bud-bestia", name: "Bestia", cuisine: "Balcánica · parrilla", price: 2, rating: 4.5, area: "Barrio Judío", address: "Nagy Diófa u. 31", lat: 47.4953, lng: 19.0626, hours: "Lun–Dom 12–23", signature: "Cevapi, pljeskavica, mezzes balcánicos", noPork: false, tip: "Cocina serbo-balcánica con ambiente alegre." },
      { id: "r-bud-dobrumba", name: "Dobrumba", cuisine: "Mediooriental · mediterránea", price: 2, rating: 4.6, area: "Barrio Judío", address: "Dob u. 5", lat: 47.4942, lng: 19.0573, hours: "Lun–Dom 12–23", signature: "Mezzes, kebab de cordero, shakshuka", noPork: true, reserve: "Reservar online", tip: "De los mejores nuevos. Reservar 1 semana antes." },
      { id: "r-bud-gerbeaud", name: "Café Gerbeaud", cuisine: "Café histórico · pastelería", price: 2, rating: 4.4, area: "Vörösmarty tér", address: "Vörösmarty tér 7", lat: 47.4965, lng: 19.0508, hours: "09:00–21:00", signature: "Dobos torta, esterházy, café vienés", noPork: false, tip: "1858. La pastelería más histórica de Pest. Solo para café+postre." },
      { id: "r-bud-newyork", name: "New York Café", cuisine: "Café histórico", price: 3, rating: 4.4, area: "Erzsébet körút", address: "Erzsébet krt. 9-11", lat: 47.4970, lng: 19.0712, hours: "08:00–24:00", signature: "Decoración palaciega · café y postres", noPork: false, tip: "Llamado 'el café más bello del mundo'. Caro para la comida; venir solo a tomar café." },
      { id: "r-bud-central", name: "Centrál Kávéház", cuisine: "Café histórico húngaro", price: 2, rating: 4.4, area: "Centro", address: "Károlyi u. 9", lat: 47.4922, lng: 19.0567, hours: "08:00–24:00", signature: "Café literario, somlói galuska", noPork: false, tip: "1887. Café de intelectuales. Ambiente menos turístico que NY Café." },
      { id: "r-bud-karavan", name: "Karaván Street Food", cuisine: "Street food húngaro", price: 1, rating: 4.4, area: "Barrio Judío", address: "Kazinczy u. 18", lat: 47.4975, lng: 19.0617, hours: "11:30–23:00", signature: "Lángos, kürtős, hamburguesa húngara", noPork: false, tip: "Patio de food trucks al lado de Szimpla. Casual, barato." },
      { id: "r-bud-koleves", name: "Köleves Vendéglő", cuisine: "Húngara contemporánea · judía-friendly", price: 2, rating: 4.4, area: "Barrio Judío", address: "Kazinczy u. 35", lat: 47.4971, lng: 19.0638, hours: "12–24 todos los días", signature: "Pollo paprikás, sopa de cereza fría, lángos de almuerzo", noPork: true, jewish: true, reserve: "+36 20 213 5999 · koleves.com", tip: "Patio amplio en el corazón del barrio judío. Carta sin cerdo, varias opciones kosher-style. Música en vivo algunas noches." },
      { id: "r-bud-mak", name: "Mák Bisztró", cuisine: "Húngara moderna · Michelin Bib Gourmand", price: 3, rating: 4.7, area: "Lipótváros (cerca Basílica)", address: "Vigyázó Ferenc u. 4", lat: 47.5018, lng: 19.0481, hours: "Mar–Sáb 12–22 · Dom–Lun cerrado", signature: "Menú degustación corto · cordero, pato, postres reinventados", noPork: false, noPorkNote: "Hay cerdo en algunos platos, pero la mayoría son cordero, pato, res o pescado", reserve: "mak.hu", tip: "Bib Gourmand desde 2016. Calidad Michelin a precio razonable. Reservar 1 semana antes." },
    ],
    Praga: [
      { id: "r-prg-nase-maso", name: "Naše Maso", cuisine: "Carnicería con grill · checa moderna", price: 2, rating: 4.6, area: "Staré Město", address: "Dlouhá 39", lat: 50.0910, lng: 14.4262, hours: "Lun–Sáb 09:30–22 · Dom 11–22", signature: "Hamburguesa Czech Angus, salchicha klobása al momento, tatarák", noPork: false, noPorkNote: "Tiene cerdo (klobása), pero también res Angus, cordero y embutidos de pollo", tip: "Carnicería gourmet de Ambiente Group. Comen de pie en mesas altas. La hamburguesa Angus es de las mejores de Praga." },
      { id: "r-prg-lokal", name: "Lokál Dlouhááá", cuisine: "Checa de hospoda", price: 2, rating: 4.4, area: "Staré Město", address: "Dlouhá 33", lat: 50.0908, lng: 14.4257, hours: "11–24", signature: "Svíčková, tatarák, pivo z tanku", noPork: false, noPorkNote: "Carta con cerdo pero hay svíčková (res) y tatarák", reserve: "ambi.cz/lokal-dlouha", tip: "Cerveza Pilsner Urquell sin pasteurizar. Reservar de noche." },
      { id: "r-prg-pinkasu", name: "U Pinkasů", cuisine: "Checa clásica", price: 2, rating: 4.3, area: "Staré Město", address: "Jungmannovo nám. 16", lat: 50.0843, lng: 14.4232, hours: "10–24", signature: "Svíčková, gulaš, knedlíky", noPork: false, tip: "1843. Primer pub en servir Pilsner Urquell en Praga. Histórico." },
      { id: "r-prg-mincovna", name: "Mincovna", cuisine: "Checa moderna", price: 3, rating: 4.4, area: "Plaza Vieja", address: "Staroměstské nám. 7", lat: 50.0876, lng: 14.4214, hours: "11–23", signature: "Svíčková reinterpretada, vetrník", noPork: false, reserve: "mincovna.cz", tip: "Vista directa al Reloj Astronómico. Mejor que la mayoría de la plaza." },
      { id: "r-prg-modre-kachnicky", name: "U Modré Kachničky", cuisine: "Checa de caza", price: 3, rating: 4.5, area: "Mala Strana", address: "Nebovidská 460/6", lat: 50.0833, lng: 14.4039, hours: "12–16, 18:30–24", signature: "Pato a la cereza, ciervo, conejo", noPork: false, reserve: "umodrekachnicky.cz", tip: "Salones íntimos. Cocina checa de caza, refinada." },
      { id: "r-prg-cafe-imperial", name: "Café Imperial", cuisine: "Café histórico · checo", price: 3, rating: 4.5, area: "Nové Město", address: "Na Poříčí 15", lat: 50.0894, lng: 14.4308, hours: "07–23", signature: "Vetrník, svíčková de almuerzo, desayunos", noPork: false, reserve: "cafeimperial.cz", tip: "1914 · interior Art Nouveau con cerámicas. Brunch espectacular." },
      { id: "r-prg-cafe-savoy", name: "Café Savoy", cuisine: "Café histórico", price: 2, rating: 4.5, area: "Smíchov", address: "Vítězná 5", lat: 50.0815, lng: 14.4079, hours: "08–22:30", signature: "Pasteles vieneses, desayuno", noPork: false, reserve: "cafesavoy.ambi.cz", tip: "Techo neorrenacentista magnífico. Cola de espera mañanas — vale." },
      { id: "r-prg-louvre", name: "Café Louvre", cuisine: "Café histórico", price: 2, rating: 4.5, area: "Nové Město", address: "Národní 22", lat: 50.0832, lng: 14.4189, hours: "08–23:30", signature: "Almuerzos checos, postres", noPork: false, tip: "1902 · iban Einstein, Kafka, Čapek. Salón de billar arriba." },
      { id: "r-prg-slavia", name: "Café Slavia", cuisine: "Café histórico", price: 2, rating: 4.3, area: "Frente al Teatro Nacional", address: "Smetanovo nábř. 1012/2", lat: 50.0813, lng: 14.4138, hours: "08–24", signature: "Tatarák, postre 'absente'", noPork: false, tip: "Frente al río · vista al Castillo. Café de intelectuales del s.XX." },
      { id: "r-prg-eska", name: "Eska", cuisine: "Checa contemporánea", price: 3, rating: 4.5, area: "Karlín", address: "Pernerova 49", lat: 50.0935, lng: 14.4476, hours: "08–23", signature: "Pan negro de centeno, sopas de raíz", noPork: false, reserve: "eska.ambi.cz", tip: "La Praga del s.XXI. Pan recién horneado de entrada." },
      { id: "r-prg-field", name: "Field", cuisine: "Checa moderna · Michelin", price: 4, rating: 4.7, area: "Staré Město", address: "U Milosrdných 12", lat: 50.0925, lng: 14.4205, hours: "Mar–Sáb 18–22:30", signature: "Estrella Michelin · menú degustación", noPork: false, reserve: "fieldrestaurant.cz", tip: "Reservar 2-3 semanas. Cocina de mercado audaz." },
      { id: "r-prg-la-degustation", name: "La Degustation Bohême Bourgeoise", cuisine: "Checa alta cocina · Michelin", price: 4, rating: 4.7, area: "Staré Město", address: "Haštalská 18", lat: 50.0928, lng: 14.4243, hours: "Mar–Sáb 18:30–24", signature: "Estrella Michelin · cocina checa s.XIX reinterpretada", noPork: false, reserve: "ladegustation.cz", tip: "Una de las experiencias más singulares de Praga. Solo cena." },
      { id: "r-prg-grand-orient", name: "Grand Café Orient", cuisine: "Café cubista", price: 2, rating: 4.4, area: "Staré Město", address: "Ovocný trh 19", lat: 50.0866, lng: 14.4248, hours: "09–22", signature: "Café + postres en interior cubista único", noPork: false, tip: "Único café cubista del mundo (1912). Postre + café para ver el interior." },
      { id: "r-prg-dinitz", name: "Dinitz Kosher", cuisine: "Kosher mediterránea", price: 3, rating: 4.3, area: "Barrio Judío", address: "Bílkova 12", lat: 50.0917, lng: 14.4178, hours: "Dom–Jue 12–23 · Vie hasta Shabat · Sáb cerrado", signature: "Cordero, falafel, ensaladas mizrají", noPork: true, jewish: true, reserve: "+420 222 313 010 · dinitz.cz", tip: "Kosher certificado. Ideal después del Pinkas." },
      { id: "r-prg-king-solomon", name: "King Solomon", cuisine: "Kosher centroeuropea", price: 3, rating: 4.2, area: "Barrio Judío", address: "Široká 8", lat: 50.0894, lng: 14.4193, hours: "Dom–Jue 11:30–23 · Vie cierre Shabat · Sáb cerrado", signature: "Sólet, ganso, gefilte fish", noPork: true, jewish: true, tip: "Kosher. Menú Shabat con reserva anticipada." },
      { id: "r-prg-mysak", name: "Cukrárna Myšák", cuisine: "Pastelería histórica", price: 1, rating: 4.5, area: "Nové Město", address: "Vodičkova 31", lat: 50.0833, lng: 14.4242, hours: "09–20", signature: "Větrník, espresso, helado", noPork: false, tip: "1904. El mejor větrník (postre nacional checo)." },
      { id: "r-prg-manifesto", name: "Manifesto Market", cuisine: "Mercado gourmet · internacional", price: 2, rating: 4.4, area: "Nové Město · Smíchov", address: "Václavské nám. (varios)", lat: 50.0816, lng: 14.4271, hours: "11–24", signature: "Food market · ramen, tacos, pizza, etc.", noPork: false, tip: "Para grupos que quieren cocinas distintas. Ambiente festivalero." },
    ],
    "Tel Aviv": [
      { id: "r-tlv-sabich-tcher", name: "Sabich Tchernichovsky", cuisine: "Sabich tradicional", price: 1, rating: 4.6, area: "Centro · Tchernichovsky", address: "Tchernichovsky 2", lat: 32.0716, lng: 34.7714, hours: "Dom–Jue 09–22 · Vie 09–15 · Sáb cerrado", signature: "Sabich original (pan pita, berenjena frita, huevo, ensalada israelí, amba, tahini)", noPork: true, jewish: true, tip: "EL sabich icónico de Tel Aviv. Sin él, no se entiende el plato. Fila al almuerzo — vale 5 min." },
      { id: "r-tlv-abu-hassan", name: "Abu Hassan / Ali Karavan", cuisine: "Hummus tradicional", price: 1, rating: 4.5, area: "Jaffa", address: "HaDolfin 1", lat: 32.0539, lng: 34.7548, hours: "Dom–Vie 08–15 (hasta agotar) · Sáb cerrado", signature: "Hummus, masabacha, ful", noPork: true, tip: "El templo del hummus. Solo efectivo. Ir antes de las 13:00." },
      { id: "r-tlv-hakosem", name: "HaKosem", cuisine: "Falafel · sabich", price: 1, rating: 4.5, area: "Centro · Shlomo HaMelech", address: "Shlomo HaMelech 1", lat: 32.0747, lng: 34.7720, hours: "Dom–Jue 10–21 · Vie 10–17 · Sáb cerrado", signature: "Falafel, hummus, sabich", noPork: true, jewish: true, tip: "Falafel verde por dentro. Fila siempre, vale la pena." },
      { id: "r-tlv-dr-shakshuka", name: "Dr. Shakshuka", cuisine: "Tripolitana-judía", price: 2, rating: 4.4, area: "Jaffa", address: "Beit Eshel 3", lat: 32.0530, lng: 34.7540, hours: "Dom–Jue 12–23 · Vie 12–17 · Sáb cerrado", signature: "Shakshuka, mafrum, couscous", noPork: true, jewish: true, reserve: "+972 3-682-2842", tip: "Cocina tripolitana familiar. Bullicioso, abundante." },
      { id: "r-tlv-miznon", name: "Miznon", cuisine: "Pita gourmet (Eyal Shani)", price: 2, rating: 4.4, area: "Centro · King George", address: "King George 30", lat: 32.0775, lng: 34.7715, hours: "11:30–23 (todos los días)", signature: "Coliflor entero, pita de batata", noPork: true, jewish: true, tip: "Concepto Eyal Shani. Sin reserva — fila. Abierto Shabat." },
      { id: "r-tlv-saluf", name: "Saluf & Sons", cuisine: "Yemenita-judía", price: 2, rating: 4.6, area: "Centro · Nahalat Binyamin", address: "Nahalat Binyamin 80", lat: 32.0683, lng: 34.7707, hours: "Dom–Jue 12–23 · Vie 11–16 · Sáb cerrado", signature: "Jachnun, malawach, sopa yemenita", noPork: true, jewish: true, reserve: "+972 3-522-1344", tip: "Cocina judía-yemenita auténtica. Pedir sampler." },
      { id: "r-tlv-abu-lafia", name: "Abu Lafia (Jaffa)", cuisine: "Panadería árabe (1880)", price: 1, rating: 4.4, area: "Jaffa", address: "Yefet 7", lat: 32.0541, lng: 34.7541, hours: "24 horas", signature: "Sambusak, fatayer, knafeh", noPork: true, tip: "Cuatro generaciones. Knafeh caliente al momento." },
      { id: "r-tlv-romano", name: "Romano", cuisine: "Israelí moderna", price: 3, rating: 4.5, area: "Florentin", address: "Derech Yafo 9", lat: 32.0617, lng: 34.7713, hours: "Dom–Sáb 19–01", signature: "Menú semanal · vinos naturales", noPork: false, noPorkNote: "Carta semanal — algún plato puede tener cerdo", reserve: "romano.co.il", tip: "Cena. Reservar 1 semana. A 5 min de Herzl 62." },
      { id: "r-tlv-cafelix", name: "Cafelix Florentin", cuisine: "Café especialidad · brunch", price: 2, rating: 4.6, area: "Florentin", address: "Hertzl 73", lat: 32.0588, lng: 34.7707, hours: "07–18", signature: "Filtro V60, shakshuka, bagels", noPork: true, tip: "A 3 min de Herzl 62. Mejor café de Tel Aviv." },
      { id: "r-tlv-mashawsha", name: "Mashawsha", cuisine: "Hummus tradicional", price: 1, rating: 4.5, area: "Centro · Rashi", address: "Rashi 45", lat: 32.0715, lng: 34.7726, hours: "Dom–Vie 09–17 · Sáb cerrado", signature: "Hummus shel hayom, ful, sabich", noPork: true, tip: "Hummusiyya familiar. Alternativa a Abu Hassan." },
      { id: "r-tlv-port-said", name: "Port Sa'id", cuisine: "Mediooriental · vino natural", price: 3, rating: 4.5, area: "Centro · junto Gran Sinagoga", address: "Har Sinai 5", lat: 32.0641, lng: 34.7745, hours: "12–01", signature: "Mezze, kebab res, vino natural", noPork: false, tip: "Mesas en la calle bajo árboles. Vino israelí." },
      { id: "r-tlv-puaa", name: "Pua'a", cuisine: "Israelí · bohemia (Jaffa)", price: 2, rating: 4.4, area: "Jaffa · Mercado Pulgas", address: "Rabbi Yohanan 8", lat: 32.0544, lng: 34.7556, hours: "10–24", signature: "Brunch, ensaladas, kebab", noPork: false, tip: "En pleno Mercado de las Pulgas. Vintage y muebles antiguos." },
      { id: "r-tlv-onza", name: "Onza", cuisine: "Mediterránea-turca", price: 3, rating: 4.6, area: "Jaffa", address: "Rabbi Hanina 3", lat: 32.0538, lng: 34.7561, hours: "Dom–Sáb 18–24", signature: "Pulpo, dorada, lentejas con cordero", noPork: true, reserve: "+972 3-648-6060", tip: "Cocina turco-mediterránea. Reservar de noche." },
      { id: "r-tlv-shlomo-doron", name: "Shlomo & Doron", cuisine: "Hummus de mercado", price: 1, rating: 4.4, area: "Mercado Carmel", address: "HaCarmel 36", lat: 32.0703, lng: 34.7682, hours: "Dom–Vie 09–16 · Sáb cerrado", signature: "Hummus con ful, masabacha", noPork: true, tip: "Hummus de mercado. Almuerzo rápido al pasar." },
      { id: "r-tlv-anita", name: "Anita La Mamma del Gelato", cuisine: "Heladería", price: 1, rating: 4.6, area: "Neve Tzedek", address: "Shabazi 42", lat: 32.0625, lng: 34.7660, hours: "11–24", signature: "Helado artesanal", noPork: true, tip: "El mejor helado de TLV. Calle Shabazi peatonal." },
      { id: "r-tlv-haachim", name: "HaAchim", cuisine: "Israelí · parrilla", price: 2, rating: 4.4, area: "Centro · Ibn Gabirol", address: "Ibn Gabirol 12", lat: 32.0762, lng: 34.7794, hours: "12–24", signature: "Mezze, parrilla mixta, kebab", noPork: true, jewish: true, tip: "Cadena israelí confiable. Mezze abundante." },
      { id: "r-tlv-thai-house", name: "Thai House", cuisine: "Tailandesa", price: 2, rating: 4.5, area: "Centro · Bograshov", address: "Bograshov 8", lat: 32.0786, lng: 34.7710, hours: "12–23", signature: "Curries, pad thai", noPork: false, tip: "Si quieren un descanso de comida israelí. Auténtico tailandés." },
    ],
    Madrid: [
      { id: "r-mad-lucio", name: "Casa Lucio", cuisine: "Madrileña tradicional", price: 4, rating: 4.4, area: "La Latina · Cava Baja", address: "Cava Baja 35", lat: 40.4113, lng: -3.7099, hours: "13–16, 20:30–24 · Sáb solo cena", signature: "Huevos rotos con patatas (los famosos), cordero, callos", noPork: false, noPorkNote: "Hay cerdo en menú, pero los huevos rotos, cordero, pescados y callos están bien", reserve: "casalucio.es", tip: "1974. Los huevos rotos legendarios de Madrid — la han pedido reyes y presidentes. Reservar 1 mes antes." },
      { id: "r-mad-lhardy", name: "Lhardy", cuisine: "Española clásica", price: 4, rating: 4.4, area: "Centro · Carrera de San Jerónimo", address: "Carrera de San Jerónimo 8", lat: 40.4156, lng: -3.7028, hours: "Lun–Sáb 13–16, 20:30–24 · Dom 13–16", signature: "Cocido madrileño (jueves), perdiz", noPork: false, reserve: "lhardy.com", tip: "1839. Cocido madrileño legendario los jueves. Reservar." },
      { id: "r-mad-bola", name: "Taberna La Bola", cuisine: "Madrileña tradicional", price: 3, rating: 4.4, area: "Centro · Bola", address: "Bola 5", lat: 40.4198, lng: -3.7110, hours: "Lun–Sáb 13–16, 20:30–23 · Dom 13–16", signature: "Cocido en olla de barro", noPork: false, reserve: "+34 915 476 930", tip: "1870. Cocido cocinado en olla de barro a fuego de carbón. Único." },
      { id: "r-mad-botin", name: "Casa Botín", cuisine: "Castellana", price: 3, rating: 4.3, area: "La Latina", address: "Cuchilleros 17", lat: 40.4136, lng: -3.7102, hours: "13–16, 20–24", signature: "Cochinillo asado (1725) · cordero", noPork: false, reserve: "botin.es", tip: "Restaurante más antiguo del mundo según Guinness. Cordero si evitan cerdo." },
      { id: "r-mad-malacatin", name: "Malacatín", cuisine: "Madrileña tradicional", price: 2, rating: 4.4, area: "La Latina", address: "Ruda 5", lat: 40.4101, lng: -3.7088, hours: "Lun–Sáb 11–17, 20–24 · Dom 11–17", signature: "Cocido (3 vuelcos), torrijas", noPork: false, tip: "1895. Cocido tradicional sin pretensiones. Reservar." },
      { id: "r-mad-san-gines", name: "Chocolatería San Ginés", cuisine: "Churros (1894)", price: 1, rating: 4.3, area: "Sol", address: "Pasadizo de San Ginés 5", lat: 40.4170, lng: -3.7066, hours: "24 horas", signature: "Churros con chocolate", noPork: true, tip: "Abierta 24h. Madrugar (o trasnochar) la hace mágica." },
      { id: "r-mad-san-miguel", name: "Mercado de San Miguel", cuisine: "Mercado gourmet", price: 2, rating: 4.4, area: "Plaza Mayor", address: "Plaza de San Miguel s/n", lat: 40.4153, lng: -3.7090, hours: "10–24", signature: "Tapas variadas, jamón, croquetas", noPork: false, tip: "Turístico pero rico. Para tapeo sin compromiso." },
      { id: "r-mad-casa-revuelta", name: "Casa Revuelta", cuisine: "Tasca tradicional", price: 1, rating: 4.5, area: "La Latina", address: "Latoneros 3", lat: 40.4133, lng: -3.7088, hours: "Mar–Dom 11–16, 19–22 · Lun cerrado", signature: "Bacalao rebozado", noPork: true, tip: "Tasca antigua. El mejor bacalao tapa de Madrid. Solo efectivo." },
      { id: "r-mad-100-montaditos", name: "Los Galayos", cuisine: "Castellana · Plaza Mayor", price: 2, rating: 4.2, area: "Plaza Mayor", address: "Botoneras 5", lat: 40.4152, lng: -3.7076, hours: "12–24", signature: "Tapas, paellas, cordero", noPork: false, tip: "Terraza con vista a Plaza Mayor. Turístico, decente." },
      { id: "r-mad-cebreria", name: "Casa González", cuisine: "Tienda de quesos · vinos", price: 2, rating: 4.6, area: "Las Letras", address: "León 12", lat: 40.4147, lng: -3.6995, hours: "10–24", signature: "Tabla de quesos + vinos por copa", noPork: true, tip: "1931. Para vino y queso a media tarde. Local pequeño y auténtico." },
      { id: "r-mad-stop", name: "Stop Madrid", cuisine: "Tabernería tradicional", price: 1, rating: 4.5, area: "Gran Vía", address: "Hortaleza 11", lat: 40.4186, lng: -3.7000, hours: "12–02", signature: "Caña + tapa, tortilla, jamón", noPork: false, tip: "1929. Taberna sin tiempo. Caña a precio honesto." },
    ],
  },

  // Recomendaciones de eventos verificables en las ciudades durante las fechas; revisar disponibilidad antes de viajar.
  events: [
    {
      city: "Budapest",
      date: "2026-06-01",
      title: "Festival de la Música de Pentecostés (si calza)",
      where: "Toda la ciudad",
      time: "—",
      note: "Pentecostés 2026 cae el 24 de mayo, pero los eventos relacionados a veces se extienden. Revisar programcsorda.hu y budapestinfo.hu al llegar.",
    },
    {
      city: "Budapest",
      date: "2026-06-02",
      title: "Concierto de órgano · Basílica de San Esteban",
      where: "Basílica de San Esteban",
      time: "20:00",
      note: "Conciertos de órgano y trompeta, casi todos los martes y jueves de verano. Programa de Bach, Vivaldi, Albinoni. Tickets €25 en la puerta o online: organconcerts.hu",
      url: "organconcerts.hu",
    },
    {
      city: "Budapest",
      date: "2026-06-03",
      title: "Concierto Klezmer · Gran Sinagoga de Dohány",
      where: "Sinagoga de Dohány",
      time: "20:00",
      note: "Conciertos de klezmer y música judía húngara, varias noches por semana en verano. Acústica única en la sinagoga más grande de Europa. Programa actualizado en jewishfestival.hu o dohany-zsinagoga.hu",
      url: "jewishfestival.hu",
    },
    {
      city: "Budapest",
      date: "2026-06-03",
      title: "Open-air en Margaret Island",
      where: "Isla Margarita",
      time: "Desde las 19:00",
      note: "En junio empieza la temporada del Teatro al Aire Libre (Szabadtéri Színpad) — óperas, ballets y conciertos sinfónicos en la isla del medio del Danubio. Programa: szabadter.hu",
      url: "szabadter.hu",
    },
    {
      city: "Praga",
      date: "2026-06-05",
      title: "Pražské jaro (Primavera de Praga) · cierres del festival",
      where: "Rudolfinum, Sala Smetana",
      time: "20:00",
      note: "El festival internacional de música 'Primavera de Praga' suele cerrar entre el 1 y el 6 de junio. Revisar festival.cz por conciertos finales — una noche en el Rudolfinum es inolvidable.",
      url: "festival.cz",
    },
    {
      city: "Praga",
      date: "2026-06-06",
      title: "Concierto en Sinagoga Española",
      where: "Španělská synagoga",
      time: "20:00",
      note: "Conciertos casi todas las noches en verano: Mozart, Dvořák, Smetana, klezmer. En la sinagoga morisca más bella del mundo. Tickets ~€25 en la puerta o online: synagogueconcerts.com",
      url: "synagogueconcerts.com",
    },
    {
      city: "Praga",
      date: "2026-06-07",
      title: "Concierto matinal · Casa Municipal",
      where: "Obecní Dům (Sala Smetana)",
      time: "11:00",
      note: "Domingos en la mañana, concierto de cámara en una de las salas Art Nouveau más bonitas de Europa. Buena opción la mañana antes del aeropuerto. Tickets: obecnidum.cz",
      url: "obecnidum.cz",
    },
    {
      city: "Praga",
      date: "2026-06-05",
      title: "United Islands of Prague (festival al aire libre)",
      where: "Várias islas del Vltava",
      time: "16:00 en adelante",
      note: "Festival gratuito de música independiente en las islas del Vltava — suele ser a fines de mayo / comienzos de junio. Revisar unitedislands.cz para fechas 2026.",
      url: "unitedislands.cz",
    },
  ],

  // ============== FRASES ÚTILES ==============
  phrases: {
    Hungarian: {
      language: "Húngaro (magyar)",
      flag: "🇭🇺",
      note: "El húngaro no se parece a ninguna lengua europea común — pertenece a la familia urálica (como el finés). Los meseros jóvenes hablan inglés en Budapest. Estas frases derriten corazones.",
      categories: [
        {
          name: "Básico",
          items: [
            { es: "Hola", local: "Szia (informal) · Jó napot (formal)", phon: "sí-a · yó ná-pot" },
            { es: "Buenos días", local: "Jó reggelt", phon: "yó re-gguelt" },
            { es: "Buenas noches", local: "Jó éjszakát", phon: "yó éy-sa-kát" },
            { es: "Por favor", local: "Kérem", phon: "ké-rem" },
            { es: "Gracias", local: "Köszönöm", phon: "kó-só-nóm" },
            { es: "Muchas gracias", local: "Köszönöm szépen", phon: "kó-só-nóm sé-pen" },
            { es: "Sí / No", local: "Igen / Nem", phon: "í-gen / nem" },
            { es: "Disculpe / Lo siento", local: "Elnézést / Sajnálom", phon: "el-né-sést / sháy-ná-lom" },
            { es: "¿Habla inglés?", local: "Beszél angolul?", phon: "be-sél án-go-lul" },
            { es: "No entiendo", local: "Nem értem", phon: "nem ér-tem" },
            { es: "¡Salud!", local: "Egészségedre!", phon: "e-géss-shé-ged-re" },
          ],
        },
        {
          name: "En el restaurante",
          items: [
            { es: "Una mesa para dos, por favor", local: "Egy asztalt két személyre, kérem", phon: "edy ás-talt két se-mély-re ké-rem" },
            { es: "La carta, por favor", local: "Az étlapot, kérem", phon: "az ét-lá-pot ké-rem" },
            { es: "¿Tienen menú en inglés?", local: "Van angol étlapjuk?", phon: "ván án-gol ét-láp-yuk" },
            { es: "¿Qué recomienda?", local: "Mit ajánl?", phon: "mit á-yánl" },
            { es: "Sin cerdo, por favor", local: "Sertéshús nélkül, kérem", phon: "sher-tésh-húsh nél-kül ké-rem" },
            { es: "¿Tiene cerdo este plato?", local: "Van benne sertés?", phon: "ván ben-ne sher-tésh" },
            { es: "Soy vegetariano/a", local: "Vegetáriánus vagyok", phon: "ve-ge-tá-riá-nush vá-dyok" },
            { es: "La cuenta, por favor", local: "A számlát, kérem", phon: "ah sám-lát ké-rem" },
            { es: "Estaba delicioso", local: "Nagyon finom volt", phon: "ná-dyon fí-nom volt" },
          ],
        },
        {
          name: "Comprar y direcciones",
          items: [
            { es: "¿Cuánto cuesta?", local: "Mennyibe kerül?", phon: "men-nyí-be ke-rül" },
            { es: "¿Acepta tarjeta?", local: "Elfogad bankkártyát?", phon: "el-fo-gad bánk-kár-tyát" },
            { es: "¿Dónde está...?", local: "Hol van...?", phon: "hol ván" },
            { es: "Sinagoga", local: "Zsinagóga", phon: "zhi-na-gó-ga" },
            { es: "Estación de metro", local: "Metróállomás", phon: "me-tró-á-llo-másh" },
            { es: "Baños", local: "Mosdó / WC", phon: "mos-dó / vé-tsé" },
          ],
        },
      ],
    },
    Czech: {
      language: "Checo (čeština)",
      flag: "🇨🇿",
      note: "El checo es lengua eslava — primo del polaco. Menos inglés en la calle que en Budapest, especialmente con gente mayor. Las consonantes apiladas asustan pero la pronunciación es regular.",
      categories: [
        {
          name: "Básico",
          items: [
            { es: "Hola (informal)", local: "Ahoj", phon: "á-joy" },
            { es: "Buenos días (formal)", local: "Dobrý den", phon: "dó-brí den" },
            { es: "Buenas noches", local: "Dobrou noc", phon: "dó-brou nots" },
            { es: "Por favor / De nada", local: "Prosím", phon: "pró-sím" },
            { es: "Gracias", local: "Děkuji", phon: "dié-ku-yi" },
            { es: "Muchas gracias", local: "Mnohokrát děkuji", phon: "mno-jo-krát dié-ku-yi" },
            { es: "Sí / No", local: "Ano / Ne", phon: "á-no / ne" },
            { es: "Disculpe", local: "Promiňte", phon: "pro-míny-te" },
            { es: "¿Habla inglés?", local: "Mluvíte anglicky?", phon: "mlu-ví-te án-glits-ki" },
            { es: "No entiendo", local: "Nerozumím", phon: "ne-ro-zu-mím" },
            { es: "¡Salud!", local: "Na zdraví!", phon: "ná zdrá-ví" },
          ],
        },
        {
          name: "En el restaurante",
          items: [
            { es: "Mesa para dos, por favor", local: "Stůl pro dva, prosím", phon: "stúl pro dva pró-sím" },
            { es: "La carta, por favor", local: "Jídelní lístek, prosím", phon: "yí-del-ní lís-tek pró-sím" },
            { es: "¿Tienen menú en inglés?", local: "Máte jídelní lístek v angličtině?", phon: "má-te yí-del-ní lís-tek v án-glits-tini" },
            { es: "Una cerveza, por favor", local: "Jedno pivo, prosím", phon: "yed-no pí-vo pró-sím" },
            { es: "Sin cerdo, por favor", local: "Bez vepřového, prosím", phon: "bez vep-shó-vé-jo pró-sím" },
            { es: "¿Lleva cerdo?", local: "Je v tom vepřové?", phon: "ye v tom vep-shó-vé" },
            { es: "Soy vegetariano/a", local: "Jsem vegetarián(ka)", phon: "yshem ve-ge-ta-ryán(ka)" },
            { es: "La cuenta, por favor", local: "Účet, prosím", phon: "ú-chet pró-sím" },
            { es: "Estaba delicioso", local: "Bylo to výborné", phon: "bí-lo to ví-bor-né" },
          ],
        },
        {
          name: "Comprar y direcciones",
          items: [
            { es: "¿Cuánto cuesta?", local: "Kolik to stojí?", phon: "kó-lik to sto-yí" },
            { es: "¿Acepta tarjeta?", local: "Berete kartu?", phon: "be-re-te kar-tu" },
            { es: "¿Dónde está...?", local: "Kde je...?", phon: "k-dé ye" },
            { es: "Sinagoga", local: "Synagoga", phon: "si-na-gó-ga" },
            { es: "Metro", local: "Metro", phon: "me-tro" },
            { es: "Baños", local: "Záchody / WC", phon: "zá-jo-di / vé-tsé" },
            { es: "Cerveza de tanque (¡importante!)", local: "Pivo z tanku", phon: "pí-vo z tán-ku" },
          ],
        },
      ],
    },
  },

};
